/*! Copyright (c) 2017  House on-line.  All Rights Reserved. */
void 0;


var cemf =  cemf || {
  js: {}
};

 /*
      exemplos de acesso aos modulos

      _module_.get();              -> Retorna todo objeto
      _module_.get('central');     -> Retorna um obj específico do campo
      _module_.get('central', 0);  -> Retorna o registro da posicao 0

      _module_.replace(dados);                     -> Substitui o objeto
      _module_.replace('central', dados_central);  -> Substitui o obj 'central' do objeto
      _module_.replace('central', dados, 0);       -> Substitui o registro da posição 0 do obj 'central'
      
      _module_.subreplace('setores',10,'componentes',0,dados);    -> Substitui o objeto componentes da posicao 0 dentro de setores na posicao 10
      
      _module_.change(dados);                     -> Altera os campos do objeto conforme parametros enviados
      _module_.change('central', dados_central);  -> Altera os campos do objeto informado
      _module_.change('central', dados, 0);       -> Altera os campos do filtro informado

      _module_.search({obj:'central',PK_central:1});       -> Procura o campo informado dentro do objeto informado


   */

cemf.js.Dados = function(){};

cemf.js.Dados.prototype.dados_object = null;

cemf.js.Dados.prototype.exists = function(obj){
     return (this.dados_object.hasOwnProperty(obj))
};

cemf.js.Dados.prototype.objeto = function(obj,pos){
          if(obj != undefined){
              if(pos != undefined){
                  return (this.exists(obj) && this.dados_object[obj][pos] != undefined)? this.dados_object[obj][pos]: false;
              }else{
                  return (this.exists(obj))? this.dados_object[obj]: false;
              }
          }else
            return this.dados_object;
};

/*
   Recupera os dados do objeto
*/
cemf.js.Dados.prototype.get = function(obj,pos){
   return this.objeto(obj,pos);
};

/*
   Altera dados do objeto
*/
cemf.js.Dados.prototype.replace = function(obj, dados, id){
          if(dados != undefined){
              if(id != undefined){
                 this.dados_object[obj][id] = dados;
              }else{
                 this.dados_object[obj] = dados;
              }
          }else{
              this.dados_object = obj;
          }
};

/*
   Altera dados do objeto
*/
// cemf.js.Dados.prototype.subReplace = function(obj_1,pos_1,obj_2,pos_2, dados){
          
//           if(dados != undefined){
//             this.dados_object[obj_1][pos_1][obj_2][pos_2] = dados;
//           }else{
//             this.dados_object[obj_1][pos_1] = obj_2; // onde pos_2 receberá os dados
//           }
          
// };

/*

*/
cemf.js.Dados.prototype.change = function(obj, dados, id){
  void 0;
          if(dados != undefined){
              if(id != undefined){
                  jQuery.extend(this.dados_object[obj][id],dados);
              }else{
                  jQuery.extend(this.dados_object[obj],dados);
              }
          }else{
              jQuery.extend(this.dados_object,obj);
          }
};

/*
   Procura um dado no objeto
*/
cemf.js.Dados.prototype.search = function(params){
  if(this.dados_object.hasOwnProperty(params.obj)){
              var object = this.dados_object[params.obj];
              var campo  = Object.keys(params)[1]; // captura o nome do campo
              for (var key in object) {
                  if((this.dados_object[params.obj][key]).hasOwnProperty(campo)){
                      
                      if(object[key][campo] == params[campo]){
                        return object[key];
                      }
                  }
              }
              return false;
   }
   return false
};


void 0;

var cemf = cemf || {
	js: {}
};

cemf.js.Connection = function () {
	// Verifica se foi chamado a palavra new a invocar o objeto.
	if (!(this instanceof arguments.callee)) {
		//console.log("Nao e uma instancia");
		return new cemf.js.Connection();
	}
};

/*	
	Configura o caminho dos arquivos de comunicação com Servidor

*/
cemf.js.Connection.prototype.server = function (tipo) {
	var local = {
		gerenciador: {
			method: 'POST',
			server: "../controller/dados_gerenciador.php"
		},
		dados: {
			method: 'GET',
			server: "../controller/dados_componentes_usuario.php"
		},
		idados: {
			method: 'GET',
			server: "controller/dados_componentes_usuario.php"
		},
		login: {
			method: 'GET',
			server: "../controller/dados_cadastro_login.php"
		},
		ilogin: {
			method: 'GET',
			server: "controller/dados_cadastro_login.php"
		},
		key: {
			method: 'GET',
			server: "../controller/validaHash.php"
		},
		mail: {
			method: 'GET',
			server: "controller/send_mail.php"
		},
		cpanel: {
			method: 'GET',
			server: "../controller/cpanel_gerenciador.php"
		},
		person: {
			method: 'GET',
			server: "../controller/person.php"
		},
		broker: {
			method: 'GET',
			server: "../controller/publish.php"
		}
	};


	return local[tipo];
}

cemf.js.Connection.prototype.execute = function (config, params, template) {
	var execute = this;


	_method = ((config.hasOwnProperty('method')) ? config.method : "GET");
	_server = ((config.hasOwnProperty('server')) ? config.server : "");
	return $.ajax({
		method: _method,
		url: _server,
		data: params,
		beforeSend: function () {
			void 0;
			if (template.loading != null)
				(template.loading).prepend(template.createLoading());
			//else
			//template.animation.toast("Sincronizando...");
		},
		success: function (data) {
			void 0;
			if (template.loading != null)
				template.removeLoading();

			msg = data.resposta;
			void 0;
			if (msg.hasOwnProperty('error') && msg.error > 0) {
				if (msg.hasOwnProperty('error_msg')) {
					template.animation.toast(msg.error_msg);
				}
			}
		},

	}).fail(function (exc) {
		//Toast("Problema na Comunicação com Servidor");
		template.removeLoading();
		void 0;
		void 0;

	});
};


cemf.js.Connection.prototype.request = function (response, template) {
	var request = this;

	var msg_tentativas_conexao = 3;
	var msg_limite_tentativas = 5;
	//var test = "RAW12.900.850.1750.1750.1750.1750.1750.850.900.850.900.850.900.1750.850.850.1800.850.900!";
	//var test = "RAW12.900.850.900.850.900.850.1750.1750.1750.900.850.850.900.1750.1750.850.900.850.900.850.900!"; //up
	//var test = "RAW12.950.800.950.800.950.800.1800.1700.1800.800.950.800.950.1700.1800.850.900.800.950.1700.900!"; //down
	//var test = "RAW12.900.850.1750.1750.1750.1700.1800.850.900.850.900.1700.1800.850.900.850.900.1700.900!"; //next
	//console.log(response.data.prot);

	//(response.data).prot = test;
	//console.log(response.data);


	$('.msg-request').html('sincronizando...');
	return $.ajax({
		method: 'GET',
		url: 'http://' + ((response.acesso) ? response.ddns : response.ip) + ':' + response.porta,
		data: response.data,
		timeout: 5000,
		//crossDomain: true,
		dataType: 'json',
		success: function (data) {
			//console.log("Sucesso");
			if (data.hasOwnProperty("error")) {
				template.animation.toast(data.error);
			}
			$('.msg-request').html('');
			void 0;

			try {
				var obj = template.dados.search({ obj: 'central', 'PK_central': response.id_central });
				if (obj.hasOwnProperty("error")) {
					obj.error = 0;
				} else {
					obj.error = 0;
				}
			} catch (e) {
				void 0;
			}
		}
	}).fail(function (exc) {

		void 0;
		$('.msg-request').html('');
		var obj = template.dados.search({ obj: 'central', 'PK_central': response.id_central });
		void 0;

		try {
			if (obj.hasOwnProperty("error")) {
				obj.error = parseInt(obj.error) + 1;
			} else {
				obj.error = 1;
			}

			void 0;
			if (obj.error > msg_tentativas_conexao && obj.error < msg_limite_tentativas) {

				void 0;
				template.animation.toast("Problema na comunicação : " + response.nome + "  [ T : " + obj.error + " ]");
			}
		} catch (e) {
			template.animation.toast("Problema na comunicação : " + response.nome);
		}






	});


};
void 0;


var cemf =  cemf || {
  js: {}
};


cemf.js.Animation = function(params){
	var animation = this;
	 window.addEventListener('resize', function(){
   		// params.callback(animation.screenSize());
   		 animation
	 		.screenSize();
   		 animation
   		 	.ajustaLayouts();
	});
	 animation
	 	.screenSize();
	 
 			animation.ajustaLayouts();
}


/*
   Objeto contendo todos os elementos que devem ser ajustados de acordo com o tamanho das telas

*/
cemf.js.Animation.prototype.paramsLayout = null;

/*
	Tamanho mínimo para restirar o Panel e Ajustar a tela de componentes
*/
cemf.js.Animation.prototype.maxWidth  = 480;

cemf.js.Animation.prototype.maxHeigth = 600;

cemf.js.Animation.prototype.isCelular = false;

cemf.js.Animation.prototype.pilhaToast = [];



cemf.js.Animation.prototype.screenSize = function(){
	//console.log("--> screenSize()");

			var w = window,
		    d = document,
		    e = d.documentElement,
		    g = d.getElementsByTagName('body')[0],
		    x = w.innerWidth || e.clientWidth || g.clientWidth,
		    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

		    var screen = {
		    				width:x,
		    				height:y
		    			};
		   	this.isCelular = (x <= this.maxWidth);
		 		   	 
		   	 $('.dashboard').css({height:(y)});
		   //	 $('.painel-lista').css({height:(y - 110)}); // 100px é o tamanho do img-top
		   	 if( y > 637)
		   	 	 y = 637;
		   	 $('.painel-lista').css({height:(y - 110)}); // 100px é o tamanho do img-top
		   	// var o = y - 527;
		   //	 $('.painel-lista').css({height:y - o}); // 100px é o tamanho do img-top
		   //	 $('.painel-lista').css({height:527}); // 100px é o tamanho do img-top

		   
			return screen;
}
cemf.js.Animation.prototype.screenDevice = function(){

/*

  Site para tamanhos de Telas
  https://mydevice.io/devices/#sortTablets

*/

		// @media screen and (min-width:320px) { }
		// @media screen and (min-width:480px) { }
		// @media screen and (min-width:600px) { }
		// @media screen and (min-width:768px) { }
		// @media screen and (min-width:992px) { }
}

/******************************************************************
   Ajusta os layouts Layout da Tela Esconde ou Mostra Menu Lateral

*************************************************************/

	cemf.js.Animation.prototype.ajustaLayouts = function(){
	//	console.log("-> ajustaLayouts()");
		
		var layout = this;
		var $fundo 				= $('.fundo-modal');
		var $panel 				= $('.menu-panel');
		var $area_controle		= $('.area-controle');


		 if(layout.isCelular){
		  		$panel.animate({left:'-300px'}, 400);
		 	    $area_controle.animate({left:'0px',opacity: 1}, 300);

		 	     $area_controle.on('click',function(){
		 	     	if($panel.css('left') == '0px'){
					  		$panel.animate({left:'-300px'}, 300);
					 }
		 	     });
		 }else{
		 		 	
		 		$panel.animate({left:'0px'}, 400);
		 		$area_controle.animate({left:'250px',opacity: 1}, 400);
		 	 	$area_controle.off('click');
		 	  
		 }

	}

	/*
		Abre o Painel quando clicado no icone Menu
	*/
	cemf.js.Animation.prototype.openPainel = function(tempo){
		void 0;

		var $panel = $('.menu-panel');
		$panel.animate({left:'0px'},300);

	}


	/*
		 Adiciona e Anima o Painel de Fundo colorido.
	*/
	cemf.js.Animation.prototype.animatePanelFundo = function(fundo_left){
		void 0;

		var anima = this;
		 $('.menu-panel').animate({left:'-300px'},300, function() {
				$('.menu-panel').append(fundo_left);
				
				if(!(anima.isCelular)){
				    $('.menu-panel').animate({left:'0'},400, function() {
				    });
				}
		 });
	}


	/*
		Remove o Fundo colorido em cima das listas.

	*/
	cemf.js.Animation.prototype.removeFundoModal = function(tempo){
		void 0;

		var menu = this;

		var $fundo = $('.fundo-modal');
		var $panel = $('.menu-panel');
		
		if($fundo.length > 0){
				$panel.animate({left:'-300px'},(300), function() {
			   		$fundo.remove();
			   		if(!(menu.isCelular)){
			   			$panel.animate({left:'0px'},(300));
			   		}
		 		});
		}
	}





/************************************************************
	Exibe e Oculta o Menu de Opções, ou outro componentes informado
*/
cemf.js.Animation.prototype.fade = function(comp,tempo){
	void 0;

	var $area_controle		= $('.area-controle');
		if($(comp).is(':visible')){
				$(comp).fadeOut(tempo | 100);
				$area_controle.off('click');
			}else{
				$(comp).fadeIn(tempo | 100);
				 $area_controle.on('click',function(){
					$(comp).fadeOut(tempo | 100);	 	    	
		 	    });
			}
}


/*
	Fecha todos os menus abertos.
*/
cemf.js.Animation.prototype.closeOpen = function(){
	void 0;
	 $('.options').fadeOut(100);
	 this.ajustaLayouts();

}



/*
	Anima e adiciona e remove os diferentes Menu Bar
*/
cemf.js.Animation.prototype.animateMenuBar = function(container){
	void 0;

	var $menubar 		= $('.menu-bar');
	var $dashboard		= $('.dashboard');

	if($menubar.length  == 0){
		   		$dashboard.prepend(container);
		   		container.animate({top:'0px'},200);
	}else{
				$menubar.animate({top:'-100px'},200, function() {
						void 0;
						
				   		this.remove();
				   		
				   		$dashboard.prepend(container);
				   		container.animate({top:'0px'},150);
				});	
	}
}








/*
   anima Area Controle para troca de informações
*/

cemf.js.Animation.prototype.animaAreaControle = function(comp,tempo){
	void 0;

	var $area_controle		= $('.area-controle .lista-componentes');

		$area_controle.fadeOut((tempo | 100), function() {
			 $area_controle.html("");
			$area_controle.fadeIn((tempo | 100), function() {
				$area_controle.html(comp);
			});
			
		});
}


/*
   anima Controle Float
*/

cemf.js.Animation.prototype.animaControlFloat = function(status, remove){
	void 0;
	

    void 0;

	var $float		= $('.dashboard .controle-float');

		if(status){
			$float.find('div').fadeIn('fast', function() {
				$(this).addClass('open');
			});
		}else{
			$float.find('div').animate({},400,function() {
				$(this).removeClass('open');
			});
			if(remove){
				$float.animate({'opacity':0},1000,function(){
					void 0;
					$(this).remove();

				});
			}
		}

}

/*
   Animação para movimentar um item da lista (para cima ou para baixo)
*/
cemf.js.Animation.prototype.movimentaLista = function(itemSobe,itemDesce){

	 aux = itemSobe.innerHTML;
	  $(itemSobe).animate({opacity:0.1},100,function(){
		itemSobe.innerHTML = itemDesce.innerHTML;
		itemDesce.innerHTML = aux;	
			$(itemSobe).removeClass('selected');
			$(itemSobe).animate({opacity:1},100,function(){
				$(itemDesce).addClass('selected');	
			});
	});
}

/*
	Animação para Remover um item da Lista
*/
cemf.js.Animation.prototype.removeItemLista = function(item){

	 $(item).fadeOut('slow',function(){
	 	$(this).remove();
	 });
}

/*
	Animação para Mostrar item na Lista
*/
cemf.js.Animation.prototype.adicionaItemLista = function(item,tempo){

	 $(item).animate({'opacity':'1'},tempo * 400);
}



/*
	Animação para Mostrar o painel de adicionar Central
*/
cemf.js.Animation.prototype.slideUpDown = function(item){

	 void 0;
	 if($(item).css('top') == '20px'){
	 	 $(item).animate({top:-86,opacity:0},500,function(){
	 			try{
	 				$(this).remove();
	 			}catch(e){
					void 0;
					$(this).removeChild($menubar);
				 }
		 });	

	 }else{
	 	$(item).animate({top:20,opacity:1},500,function(){
	 		//console.log($(this));
		 });	
	 }
	 
}

cemf.js.Animation.prototype.geoLocation = function(callback){
	void 0;
	var self = this;

		/*

		   maximumAge :  Busca em cache a ultima localização pelo tempo em millisegundos
		   enableHighAccuracy (true or false)  : maior precisao na lozalização, pode dar problema no IOS e Android
		   timeout : tempo em millisegundos que aguarda a localização.


		*/
	  if(navigator.geolocation){
	       navigator.geolocation.getCurrentPosition(callback,handle_error,{enableHighAccuracy:false,maximumAge:600000});
      }else{
    		void 0;
	  }


	    	function handle_error(err){
	    			void 0;

	    			/*
	    			   PERMISSION_DENIED (1)
	    			   POSITION_UNAVAILABLE(2)
	    			   TIMEOUT (3)
	    			*/

      			if (err.code == 1) {
				    	self.toast("Autorize mostrar sua Localização para controle de proximidade, BETA");
				  }

	    	}
return true;	    	
	  
}


/*
   Mensagems Informativa para Usuario
   Mensagems sequenciais são colocadas em Pilhas de execução.
*/
cemf.js.Animation.prototype.toast = function(msg){
	var toast = this;

		// var arr = [1, 2, 3, 4, 5, 6];
		// arr = arr.slice(0, 3);
		// console.log(arr);


   	  (toast.pilhaToast).push(msg);
   	  
	  if((toast.pilhaToast).length >= 1){
	  		Exibir();

	  		var interva_toast = setInterval(function(){

	      				 if((toast.pilhaToast).length > 0){
	      						Exibir();	      						
	      				}else{
	      					   
									clearInterval(interva_toast);
	      				}
	      	},3000);
	  }

	 function Exibir(){
	 							
					$("#snackbar")	
					 	.html(toast.pilhaToast[0])
					 	.fadeIn(100)
       					.addClass('show');
       				
       				

       			 setTimeout(
						function(){ 
								$("#snackbar")
								.fadeOut(500,function(){$("#snackbar").removeClass('show')});	   

								toast.pilhaToast = (toast.pilhaToast).slice(1,(toast.pilhaToast).length); 					
		   		}, 2500);

       			
	}

}





void 0;

var cemf =  cemf || {
  js: {}
};



cemf.js.Ferramentas = function(params){
	this.params_ = jQuery.extend(params.classe, params.id,params.img,params);
}

cemf.js.Ferramentas.prototype.animation = null;

/*
   Menu Bar Principal
*/
cemf.js.Ferramentas.prototype.createMenuBarDefault = function(){
	
	void 0;
	var menu = this;

	

	var container 	= $('<div></div>');
	    container.addClass(this.params_.menu_bar +" "+ this.params_.color +" "+ this.params_.elevation);

	
	var img_left  	= $('<img></img>');
		img_left.addClass(this.params_.icons);
		//img_left.attr('id',this.params_.id_menu);
		img_left.attr('src',this.params_.ic_menu);



	var title 		= $('<span></span>');
		title.addClass(this.params_.font);
		title.attr('id',this.params_.id_title);
		title.text("Home");

	var img_right  	= $('<img></img>');
		img_right.addClass(this.params_.icons + " " + this.params_.right);
		//img_right.attr('id',this.params_.id_vert);
		img_right.attr('src',this.params_.ic_vert);

	var option_menu = $('<div></div>');
	  option_menu.addClass(this.params_.menuCard +" "+ this.params_.elevation + " " + this.params_.none)
	  //option_menu.attr('id',this.params_.id_options);

	var ul = $('<ul></ul>');
	
	var actionMenuOptions = {
			click : function(){
				menu.params_.animation.fade(option_menu,10);
				menu.params_.callbackMenuBarOptions(this.id);	
			
			}
	};

	var actionVert = {
				click: function(){
					menu.params_.animation.closeOpen();
					menu.params_.animation.fade(option_menu);
				}
	};

	var actionMenuPanel = {
				click: function(){
					   option_menu.fadeOut('fast');
					   menu.params_.animation.openPainel();
					   void 0;
					 	//var $panel = $('.menu-panel');
						//$panel.css({left:'0px'});
				}
					
	};

void 0;
	var icons = this.params_.icon;
	(this.params_.menu).forEach(function(event, el) {
			
			var li = $('<li></li>');
			var img_icon = $('<img></img>');

			img_icon.attr('src',icons[el]);
			li
				.html(img_icon)
				.attr('id',el);
			li.append(event);
			
			$(li).on(actionMenuOptions);

			ul.append(li);
	});	

	$(img_right).on(actionVert);
	$(img_left).on(actionMenuPanel);


	option_menu.append(ul);
	container.append(img_left);
	container.append(title);
	container.append(img_right);
	container.append(option_menu);

	
	menu.params_.animation.animateMenuBar(container);
	menu.params_.animation.ajustaLayouts();
	
   
}

/*
   Menu Bar quando Config Sertor
   Option { voltar }
*/
cemf.js.Ferramentas.prototype.createMenuBarSetor = function(params){
	void 0;

	this.params_ = jQuery.extend(this.params_, params.classe, params.id , params.img ,params);
	var menu = this;

	
	var container 	= $('<div></div>');
	    container.addClass(this.params_.menu_bar +" "+ this.params_.color );

	
	var img_left  	= $('<img></img>');
		img_left.addClass(this.params_.icons);
		//img_left.attr('id',this.params_.id_back);
		img_left.attr('src',this.params_.ic_back);

		var actionBack  = {
				click: function(){
					menu.params_.callback(true);
					
				}
		};

		$(img_left).on(actionBack);


	var title 		= $('<span></span>');
		title.addClass(this.params_.font);
		//title.text(this.params_.menus[0]);
		title.text('Setor');


	var fundo_left = $('<div></div>');
		fundo_left.addClass('fundo-modal '+ this.params_.color);

	container.css('z-index','10');

	container.append(img_left);
	container.append(title);

	menu.params_.animation.animatePanelFundo(fundo_left);
	menu.params_.animation.animateMenuBar(container);
	menu.createControlFloat(menu.params_.callbackFloat);

}

/*
   Menu Bar Central
   Option { voltar }
  
*/
cemf.js.Ferramentas.prototype.createMenuBarCentral = function(params){
	void 0;

	this.params_ = jQuery.extend(this.params_, params);

	void 0;
	var menu = this;

	var container 	= $('<div></div>');
	    container.addClass(this.params_.classe.menu_bar +" "+ this.params_.classe.color );

	
	var img_left  	= $('<img></img>');
		img_left.addClass(this.params_.classe.icons);
		//img_left.attr('id',this.params_.id_back);
		img_left.attr('src',this.params_.img.ic_back);

		var actionBack  = {
				click: function(){
					menu.params_.callback(true);
					
				}
		};
		// var actionDown  = {
		// 		click: function(){
		// 			menu.params_.callbackDown(true);
					
		// 		}
		// };
		var actionAdd  = {
				click: function(){
					menu.params_.callbackAdd(true);
					
				}
		};

		var actionShare  = {
				click: function(){
					menu.params_.callbackShare(true);
				}
		};

		$(img_left).on(actionBack);

	var container_icon = $('<div></div>');
	    container_icon.addClass(this.params_.classe.control);

	// var img_down = $('<img></img>');
	// 	img_down.addClass(this.params_.classe.icons);
	// 	img_down.attr('src',this.params_.img.ic_down);

	var img_add  = $('<img></img>');
		img_add.addClass(this.params_.classe.icons);
		img_add.attr('src',this.params_.img.ic_add);
		img_add.attr('id','img_add_central');


	var img_share  = $('<img></img>');
		img_share.addClass(this.params_.classe.icons + ' right');
		img_share.attr('src',this.params_.img.ic_share);
		img_share.attr('id','img_share_central');


	var title 		= $('<span></span>');
		title.addClass(this.params_.classe.font);
		//title.text(this.params_.menus[0]);
		title.text('Módulos');


	var fundo_left = $('<div></div>');
		fundo_left.addClass('fundo-modal '+ this.params_.classe.color);

	container.css('z-index','10');

	container.append(img_left);
	container.append(title);

	//$(img_down).on(actionDown);
	$(img_add).on(actionAdd);
	$(img_share).on(actionShare);


	//container_icon.append(img_down);
	container_icon.append(img_add);
	container_icon.append(img_share);

	img_share.css({'display':'none'});
	container.append(container_icon);

	menu.params_.animation.animatePanelFundo(fundo_left);
	menu.params_.animation.animateMenuBar(container);
	//menu.createControlFloat(menu.params_.callbackFloat);
	

}

/*
   Menu Bar Libraries
   
  
*/
cemf.js.Ferramentas.prototype.createMenuBarLibraries = function(params){
	void 0;

	this.params_ = jQuery.extend(this.params_, params);

	void 0;
	var self = this;

	var container 	= $('<div></div>');
	    container.addClass(this.params_.classe.menu_bar +" "+ this.params_.classe.color );

	
	var img_left  	= $('<img></img>');
		img_left.addClass(this.params_.classe.icons);
		//img_left.attr('id',this.params_.id_back);
		img_left.attr('src',this.params_.img.ic_back);

		var actionBack  = {
				click: function(){

						self.params_.callback(true);					
					
				}
		};
		
		var actionAdd  = {
				click: function(){
					img_share.fadeOut('fast');
					img_add.fadeOut('fast',function(){
						img_lib.fadeIn('slow');
						img_save.fadeIn('slow');
					});
					
					self.params_.callbackAdd(true);
					
				}
		};

		var actionLib  = {
				click: function(){
					self.params_.callbackLib(true);
				}
		};

		var actionSave  = {
				click: function(){
			
					self.params_.callbackSave(true);
					
				}
		};

		var actionShare  = {
				click: function(){
					self.params_.callbackShare(true);
				}
		};

		$(img_left).on(actionBack);

	
	var img_add  = $('<img></img>');
		img_add.addClass(this.params_.classe.icons + ' right');
		img_add.attr('src',this.params_.img.ic_add);
		img_add.attr('id','img_add');

	var img_lib  = $('<img></img>');
		img_lib.addClass(this.params_.classe.icons + ' right');
		img_lib.attr('src',this.params_.img.ic_lib);
		img_lib.css('display','none');
		img_lib.attr('id','img_lib');

	var img_save  = $('<img></img>');
		img_save.addClass(this.params_.classe.icons + ' right');
		img_save.attr('src',this.params_.img.ic_save);
		img_save.css('display','none');
		img_save.attr('id','img_save');

	var img_share  = $('<img></img>');
		img_share.addClass(this.params_.classe.icons + ' right');
		img_share.attr('src',this.params_.img.ic_share);
		img_share.attr('id','img_share');


	var title 		= $('<span></span>');
		title.addClass(this.params_.classe.font);
		title.text('Biblioteca IR');


	var fundo_left = $('<div></div>');
		fundo_left.addClass('fundo-modal '+ this.params_.classe.color);

	container.css('z-index','10');

	container.append(img_left);
	container.append(title);

	$(img_add).on(actionAdd);
	$(img_lib).on(actionLib);
	$(img_save).on(actionSave);
	$(img_share).on(actionShare);
	

	container.append(img_save);
	container.append(img_lib);
	container.append(img_add);
	container.append(img_share);
		

	self.params_.animation.animatePanelFundo(fundo_left);
	self.params_.animation.animateMenuBar(container);

}


/*
   Menu Bar Agendamentos
   
  
*/
cemf.js.Ferramentas.prototype.createMenuBarAgendamentos = function(params){
	void 0;

	this.params_ = jQuery.extend(this.params_, params);

	void 0;
	var self = this;

	var container 	= $('<div></div>');
	    container.addClass(this.params_.classe.menu_bar +" "+ this.params_.classe.color );

	
	var img_left  	= $('<img></img>');
		img_left.addClass(this.params_.classe.icons);
		//img_left.attr('id',this.params_.id_back);
		img_left.attr('src',this.params_.img.ic_back);

		var actionBack  = {
				click: function(){

						self.params_.callback(true);					
					
				}
		};
		
	
	$(img_left).on(actionBack);

	
	var title 		= $('<span></span>');
		title.addClass(this.params_.classe.font);
		title.text('Agendamentos');


	var fundo_left = $('<div></div>');
		fundo_left.addClass('fundo-modal '+ this.params_.classe.color);

	container.css('z-index','10');

	container.append(img_left);
	container.append(title);

		

	self.params_.animation.animatePanelFundo(fundo_left);
	self.params_.animation.animateMenuBar(container);

}

/*
   Menu Bar Componentes
   Option { voltar }
  
*/
/*

	<div class="menu-bar config-componentes color-bar-2 none">
			<img class="btn-icon" src="../img/icons/system/ic_arrow_back_white_18dp.png" id="menu-back">
			<span class="font-size-2" id="title-config-componente">Componentes</span>
			<p class="color-text-icons font-size-2" id="menu-proximo">Próximo</p>
		</div>

		
			
*/
cemf.js.Ferramentas.prototype.createMenuBarComponentes = function(params){
	void 0;

	this.params_ = jQuery.extend(this.params_, params);

	void 0;
	var menu = this;

	var container 	= $('<div></div>');
	var img_left  	= $('<img></img>');
	var title 		= $('<span></span>');
	var prox 		= $('<p></p>');


	var fundo_left 	= $('<div></div>');


	container.addClass(this.params_.classe.menu_bar +" "+ this.params_.classe.color+' config-componentes' );
	container.attr('id','title-config-componente');


	img_left.addClass(this.params_.classe.icons);
	img_left.attr('src',this.params_.img.ic_back);

	title.addClass(this.params_.classe.font);
	title.text('Componente');
	

	prox.addClass(this.params_.classe.color_text+" "+this.params_.classe.font);
	prox.attr('id','menu-proximo');
	prox.text('');

	fundo_left.addClass('fundo-modal '+ this.params_.classe.color);

		var actionBack  = {
				click: function(){
					menu.params_.callback(true);
					
				}
		};
		var actionNext  = {
				click: function(){
					menu.params_.callbackNext(true);
					
				}
		};
		

	$(img_left).on(actionBack);
	$(prox).on(actionNext);



	container.css('z-index','10');

	container.append(img_left);
	container.append(title);
	container.append(prox);

	menu.params_.animation.animatePanelFundo(fundo_left);
	menu.params_.animation.animateMenuBar(container);
	menu.createControlFloat(menu.params_.callbackFloat);
	

}


/* 

   Cria o Menu Float para criação das Ferramentos de alterações.

*/
 cemf.js.Ferramentas.prototype.createControlFloat = function(callback){
	void 0;

 	var createFloat = this;

 	
    var div_control = $("<div></div>");
    div_control.addClass('controle-float');


    var img_src= [
    			'ic_arrow_downward_white_24dp.png',
    			'ic_delete_black_24dp.png',
    			'ic_keyboard_arrow_up_black_24dp.png',
    			'ic_keyboard_arrow_down_black_24dp.png',
    			'ic_mode_edit_black_24dp.png',
    			'ic_add_circle_outline_black_24dp.png'
    			
    ];

  
   	var action = {
   					click:function(){
   						 callback($(this).attr('id'));
   					}
   	}
    
     for(var x = 0;  x < 6 ; x++){
     	
     	var div = $("<div></div>");
     	div.addClass('color-float-1 animation');
     	div.attr('id','option-'+x);

     	var img = $('<img></img>');
     	img.attr('src','../img/icons/system/'+ img_src[x]);
     	img.addClass('btn-icon');

     	div.append(img);
     	$(div).on(action);

     	div_control.append(div);
     }

     $('.dashboard').append(div_control);

     createFloat.params_.animation.animaControlFloat(true,false);

}






void 0;


var cemf =  cemf || {
  js: {}
};


/**
 * TemplatePage class holds all the support for the page to work
 * and interact with javascript controls.
 * @constructor
 */
cemf.js.Element = function(animationClass){
	this.animation = animationClass;
	
}

cemf.js.Element.prototype.dados_obj = null;

cemf.js.Element.prototype.idElementSelected  = null; // informa o ID do setor que está na Seleção

cemf.js.Element.prototype.posElementSelected = null; // informa a posição dentro da lista do setor selecionado

cemf.js.Element.prototype.idConfigElementSelected  = null; // identifica o setor selecionado quando em modo de configuração

cemf.js.Element.prototype.animation  = null;

cemf.js.Element.prototype.componentesCarregados  = null;  // guarda os componentes carregados.

cemf.js.Element.prototype.etapaConfigComponente = 0;  //  guarda as etapa atual do quando criando um novo componente

cemf.js.Element.prototype.auxElementComponente = null;

cemf.js.Element.prototype.limiteComandosMultiplos = 3;

cemf.js.Element.prototype.isPlanoPremium = function(){
		var self = this;
		var plano = self.dados_obj.get('usuario')[0].FK_tipo_plano;
		return (plano == 3 || plano == 4 || plano == 6)? true : false;
}

cemf.js.Element.prototype.isCliente = function(){
		var self = this;
		var plano = self.dados_obj.get('usuario')[0].FK_tipo_plano;
		return (plano == 2)? true : false;
}

cemf.js.Element.prototype.perfilUsuario = function(){
		var self = this;
		var usuario = self.dados_obj.get('usuario')[0];
		return usuario;
}


/*
    Cria Elementos Setor e SetorConfig
*/
cemf.js.Element.prototype.createSetor = function(dados,params){
	void 0;

		 var create = this;
			 	var defaultParams = {
						click :function(event){
						
								 create.idElementSelected = dados.PK_setor;
								 create.posElementSelected = $(this).index();

								  $(".painel-lista .lista-setores").find('li').removeClass('color-secondary');
								  $(this).addClass("color-secondary");

								 create.componentesCarregados = create.dados_obj.search({obj:'setores',PK_setor:dados.PK_setor}).componentes; 
								 //create.loadComponente(create.componentesCarregados,params.callbackRequest);

								 if(!create.loadComponente(create.componentesCarregados,params.callbackRequest)){
								 		$('.lista-componentes').html("");
								   		create.objetoVazio({element:$('.lista-componentes'),text:'Nenhum Componente Cadastrado !'});
								  }
								 create.animation.ajustaLayouts();

								 //console.log(dados);

							     create.params_.callback(dados);

							},
			};

			var configParams = {
							click :function(event){
								 create.idConfigElementSelected = $(this).index();
								 //console.log("ID Config Selececionado:" + $(this).index());
								 $(".lista-componentes .lista-setores").find('li').removeClass('selected');
								 $(this).addClass("selected");




							},
			}	

			
			create.item_selecionado = dados.nome_setor;
			var e = document.createElement('li');
			var i = document.createElement('img');
			var p = document.createElement('p');
			p.innerHTML = dados.nome_setor;
			i.src="../img/icons/setores/" + dados.icon_setor;

			e.appendChild(i);
			e.appendChild(p);

			
			$(e)
				.on((params.tiposModoMenu == null)? defaultParams : configParams);

				
				if(create.idElementSelected == dados.PK_setor && params.tiposModoMenu == null){
					 $(e).addClass("color-secondary");
				}

			$(e).css('opacity','0');
			return e;
};

/*
   Carrega Elementos Setor e SetorConfig de acordo com Dados ('setores')
*/
cemf.js.Element.prototype.loadSetor = function(params){
	void 0;
	this.params_ = jQuery.extend(this.params_,params);

	 var load = this;
	 	// console.log(params);
	 			load.dados_obj = params.dados;
	 			var lista = $("<ul></ul>");
	 	    	
				if((dados = params.dados.get().setores)){

							if(dados.length > 0){

								if(params.tiposModoMenu == null){
						 			params.element.html(lista);

						 		}else{
							 			var div =$('<div></div>');
							 			div.addClass('lista-setores');
							 			div.append(lista);
							 			load.animation.animaAreaControle(div);
						 		}


						 	dados.forEach(function(event, el) {
						 			var item = load.createSetor(event,params);
						 			lista.append(item);
						 			load.animation.adicionaItemLista(item,el);
							});	
						 	return true;
						}else{
							$('.lista-setores').html("");
						}

			    }else{

			    	void 0;
			    }

	return false;			   
}

/*
   Cria Componentes Iluminação de acordo com dados
*/

cemf.js.Element.prototype.createComponenteIluminacao= function(dados,callback){
	void 0;
			comp = this;
			var _central  = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});
			//console.log(_central);
			var valor_porta = null;
			var posicaoComponente = null

			//console.log(dados);
			
			  try{

			  		 //var letra = dados.prot_componente;
			  		 var letra = (dados.prot_componente).charAt((dados.prot_componente).length - 1);
					 var posicao = parseInt(dados.pos_componente);

 					// console.log(_central.data.status.charAt((_central.data.status).indexOf("R")));
					 //console.log(_central.data.status.charAt( (_central.data.status).indexOf("R") + posicao + 1));

					 if(letra.endsWith(letra)){

					 	posicaoComponente = (_central.data.status).indexOf(letra) + posicao + 1 ;
					 	valor_porta = _central.data.status.charAt(posicaoComponente);
					 	//console.log(valor_porta);
					 
					 }else{
						valor_porta = _central.data.status[dados.pos_componente]; 	
					 }
					
				}catch(e){
					void 0;
					void 0;

				}
			
			


			var li 		= document.createElement('li');
			var div_1 	= document.createElement('div');
			var div_2 	= document.createElement('div');
			var div_3 	= document.createElement('div');
			var i 		= document.createElement('img');
			var h3 		= document.createElement('h3');
			var label 	= document.createElement('label');
			var input 	= document.createElement('input');
			var p 		= document.createElement('p');
			

			var div_4 	= document.createElement('div');
			var span	= document.createElement('span');
			var small	= document.createElement('small');
			var img		= document.createElement('img');

			var d_data  = document.createElement('div');
			var i_data	= document.createElement('img');

			/*
			<div class="data">
									<img src="../img/icons/system/ic_date_range_black_24dp.png">
								</div>

			*/



			var actionDefault={
								click:function(){
									var _id = dados.PK_componente;
									//var _central = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});

									//console.log(_central);

										var _ip 		= _central.ip_central;
										var _porta 		= _central.porta_central;
										var _ddns 		= _central.ddns_central;
										var _prot 		=  dados.prot_componente;
										var _nome 		= _central.ident_central;
										var _id_central = _central.PK_central;
										var _model 		= _central.desc_modelo;
										var _codigo		= _central.codigo_central;


									if(_central.habilita_central == 1){
										var _ip 		= _central.ip_central;
										var _porta 		= _central.porta_central;
										var _ddns 		= _central.ddns_central;
										var _prot 		=  dados.prot_componente;
										var _nome 		= _central.ident_central;
										var _id_central = _central.PK_central;
										var _model 		= _central.desc_modelo;
										var _codigo		= _central.codigo_central;

										//var statusAtual = 0;  // define o estado atual da saida.
										//   012345 67 890123 45 67890 12 345 678 901 234								
										//" "P00000 A1 T+0000 M1 F0111 G1 C10 O00 U10 I00""}
									
										if(_central.hasOwnProperty("data")){
											 statusAtual = _central.data.status[posicaoComponente];
											//console.log("valor_porta -> "+ statusAtual);
											//console.log(((statusAtual == '1')? '0' : '1') + _prot+'!');
										} 

										void 0;
										callback({
													id_central:_id_central,
													ip:_ip,
													ddns:_ddns,
													porta:_porta,
													nome:_nome,
													data:{
															cod:_codigo,
															model:_model,
															prot:((statusAtual == '1')? '0' : '1')+_prot+"!"
														},
												});
									}else{

										if(_central.ident_central == undefined){
											comp.animation.toast("Módulo inexistente ou excluído");
										}else{
											comp.animation.toast(_central.ident_central+" Desativada");	
										}
										
									}

																		
								}
			}

	

			
		
			div_1.id = dados.PK_componente;
			div_1.className = "componente iluminacao";

			if(valor_porta == null)
					i.src="../img/icons/componentes/ic_exclamacao_24dp.png";
				else
					i.src="../img/icons/componentes/" + dados.icon_componente;

			
			/* Criando Titulo */
			div_2.className = "descricao-componente";
			h3.innerHTML = dados.nome_componente;
			p.innerHTML = dados.subnome_componente;


			/* Criando Switch */
			label.className = "switch";
			input.type = "checkbox";
			input.setAttribute('data-protol',dados.prot_componente);
			$(input).on(actionDefault);
			div_3.className = "slider round";

			if(valor_porta != null){
				$(input).attr("checked",((valor_porta == '1')? true : false ));
			}

			
			/* criando componente LDR 8*/
				div_4.className = "ldr";			  
				small.innerHTML = "automático";
				small.className = "font-orange";

				
			/* Criando Componente DATA*/
			d_data.className = "data";
			
			//console.log(_central);

			var auxAg 
			var temAg = false;
			try{
					if(_central.hasOwnProperty("data")){
						    var e = (_central.data.status).split("AG");
							//console.log(e);

							e.forEach(function(_e,_i){
								 if(_i > 0){
								 	var ponto = _e.search("S");
								 	if(ponto > -1 && parseInt(_e[ponto + 1] + _e[ponto + 2]) == dados.pos_componente){
								 		temAg = true;
								 	}
								 }
							});
					}

			}catch(e){
				void 0;
			}
			

				i_data.src = "../img/icons/system/" + ((temAg) ? 'ic_date_range_red_24dp.png':'ic_date_range_black_24dp.png');
			

			$(d_data).attr('value',dados.pos_componente);
			d_data.appendChild(i_data);

				var actionLdr = {
								click: function(){

									if(_central.habilita_central == 1){
										var _ip 		= _central.ip_central;
										var _porta 		= _central.porta_central;
										var _ddns 		= _central.ddns_central;
										//var _prot 		=  dados.prot_componente;
										var _prot 		= (dados.prot_componente).substring(0, (dados.prot_componente).length - 1) + 'L';
										var _nome 		= _central.ident_central;
										var _id_central = _central.PK_central;
										var _model 		= _central.desc_modelo;
										var _codigo		= _central.codigo_central;

										//var statusAtual = 0;  // define o estado atual da saida.
										if(_central.hasOwnProperty("data")){
											 statusAtual = _central.data.status[posicaoComponente];
											 void 0;
											  
											   if(parseInt(statusAtual) > 1){
													//label.className = 'none';
													img.src = "../img/icons/system/ic_radio_button_unchecked_black_24dp.png";
													li.style.background = "transparent";

												} else{
													img.src = "../img/icons/system/ic_radio_button_checked_black_24dp.png";
												}
											//console.log(((statusAtual == '1')? '0' : '1') + _prot+'!');
										} 

										void 0;
										callback({
													id_central:_id_central,
													ip:_ip,
													ddns:_ddns,
													porta:_porta,
													nome:_nome,
													data:{
															cod:_codigo,
															model:_model,
															prot:((parseInt(statusAtual) > 1)? '0' : '1')+_prot+"!"
														},
												});
									}else{
										if(_central.ident_central == undefined){
											comp.animation.toast("Módulo inexistente ou excluído");
										}else{
											comp.animation.toast(_central.ident_central+" Desativada");	
										}
									}

									

								}

				};

			 $(img).on(actionLdr);

			

			if(parseInt(valor_porta) > 1){
				label.style.display = 'none';
				img.src = "../img/icons/system/ic_radio_button_checked_black_24dp.png";
				li.style.background = (parseInt(valor_porta) == 3) ? "#f4efb6" : "transparent";
				
			} else{

				img.src = "../img/icons/system/ic_radio_button_unchecked_black_24dp.png";
				small.style.display = 'none';
				
			}
			


			div_2.appendChild(h3);
			div_2.appendChild(p);

			label.appendChild(input);
			label.appendChild(div_3);

			div_1.appendChild(i);
			div_1.appendChild(div_2);
			div_1.appendChild(div_4);
			div_1.appendChild(label);
		//	console.log("Tipo componente : " + dados.FK_tipo_componente);

			if(dados.FK_tipo_componente != '1'){
				span.appendChild(small);
				div_4.appendChild(span);
				div_4.appendChild(img);
			}else{

				// verifica se a central é do Tipo RTC para mostrar o item agendamento
				if(_central.ident_central.search("RTC") > -1 && (dados.prot_componente.search('R') > 0) && dados.FK_tipo_componente == '1'){
				    		
				    		$(d_data).on("click",function(){
				    			void 0;

				    			 void 0;

				    			 // atributo criado para identificar a posição do comando a ser agendado.
				    			 //dados.pos_componente = $(this).attr('value');
				    			 //console.log(dados);
	  			    			 comp.loadMyAgendamento({ultimaCentral:dados.FK_central,ultimaSaida:$(this).attr('value')},callback);
	  			    			 callback({pause:true});

				    		});
				    		div_1.appendChild(d_data);

				}
			}


			


			li.appendChild(div_1);
			
			$(li).css('opacity','0');
			return  li;

}


/*
   Cria Componentes Temperatura e Humidade de acordo com dados
*/

cemf.js.Element.prototype.createComponenteTempUmid= function(dados,callback){
	void 0;
			comp = this;
			var _central  = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});
			var valor_porta = null;
			var posicaoComponente = null
			var sinal = null;
			var temperatura = null;
			var umidade = null

			  try{

			  		 //console.log(dados);
			  		 
			  		 // captura a ultima letra da string
			  		 var letra = (dados.prot_componente).charAt((dados.prot_componente).length - 1);
					 var posicao = parseInt(dados.pos_componente);

					 	posicaoComponente = (_central.data.status).indexOf(letra) + 1;
					 	valor_porta = (_central.data.status).substring(posicaoComponente, posicaoComponente + 5); 

		 				sinal = valor_porta[0];
		 	
		 				temperatura = valor_porta[1] + valor_porta[2];
		 				umidade = valor_porta[3] + valor_porta[4] + "%";
		 					 	
					 
					
				}catch(e){
					void 0;
					void 0;
					temperatura = '-';
					umidade = '-';

				}
			
			


			var li 		= document.createElement('li');
			var div_1 	= document.createElement('div');
			var div_2 	= document.createElement('div');
			var i 		= document.createElement('img');
			var h3 		= document.createElement('h3');
			var p 		= document.createElement('p');

			var div_3 	= document.createElement('div');
			var temp 	= document.createElement('h3');
			var umid 	= document.createElement('h4');
			var img_umid = document.createElement('img');
			var small 	= document.createElement('small');
			
					
			div_1.id = dados.PK_componente;
			div_1.className = "componente temperatura comp-60";

			if(posicaoComponente == null)
					i.src="../img/icons/componentes/ic_exclamacao_24dp.png";
				else
					i.src="../img/icons/componentes/" + dados.icon_componente;

			div_2.className = "descricao-componente";
			h3.innerHTML = dados.nome_componente;
			p.innerHTML = dados.subnome_componente;

			div_3.className = "temp-umid";
			
			
			
			temp.className = (sinal == '+') ? "color-temp-hot" : "color-temp-ice";
			temp.innerHTML = ((sinal == '-') ? "-" : " ") + temperatura + "&deg;C";

			img_umid.src = "../img/icons/componentes/ic_gota_black_24dp.png";
			small.innerHTML = umidade;

			umid.appendChild(img_umid);
			umid.appendChild(small);

			div_3.appendChild(temp);
			div_3.appendChild(umid);


			div_2.appendChild(h3);
			div_2.appendChild(p);

			div_1.appendChild(i);
			div_1.appendChild(div_2);
			div_1.appendChild(div_3);
			li.appendChild(div_1);
			
			$(li).css('opacity','0');
			return  li;

}

/*
   Cria Componentes Alarme Switch
*/

cemf.js.Element.prototype.createComponenteConfigPercent= function(dados,callback){
			comp = this;
			var _central  = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});
			var valor_porta = null;
			var posicaoComponente = null
			var ldr = 'L';
			var pos_ldrAtual = null
			var valor_ldrAtual = null;
			
			  try{
			  		//console.log(_central.data.status);
			  		 
			  		 // captura a ultima letra da string
			  		 var letra = (dados.prot_componente).charAt((dados.prot_componente).length - 1);
					 //var posicao = parseInt(dados.pos_componente);

					 posicaoComponente = (_central.data.status).indexOf(letra) + 1;
					 valor_porta = (_central.data.status).substring(posicaoComponente, posicaoComponente + 2); 

					 pos_ldrAtual = (_central.data.status).indexOf(ldr) + 1;
					 valor_ldrAtual = (_central.data.status).substring(pos_ldrAtual, pos_ldrAtual + 2); 

					// console.log("valor porta ->" + valor_porta);


				}catch(e){
					void 0;
					void 0;

				}
			
			


			var li 		= document.createElement('li');
			var div_1 	= document.createElement('div');
			var div_2 	= document.createElement('div');
			var i 		= document.createElement('img');
			var h3 		= document.createElement('h3');
			var p 		= document.createElement('p');
			
			var div_3 	= document.createElement('div');
			var h4 		= document.createElement('h4');
			var img_up 		= document.createElement('img');
			var img_down 	= document.createElement('img');
			var img_refresh = document.createElement('img');
			var span	= document.createElement('span');

			
			var actionDefault={
								click:function(){
									var _id = dados.PK_componente;
									//var _central = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});

									//console.log(_central);

									if(_central.habilita_central == 1){
										var _ip 		= _central.ip_central;
										var _porta 		= _central.porta_central;
										var _ddns 		= _central.ddns_central;
										var _prot 		=  dados.prot_componente;
										var _nome 		= _central.ident_central;
										var _id_central = _central.PK_central;
										var _model 		= _central.desc_modelo;
										var _codigo		= _central.codigo_central;

										var statusAtual = $(h4).attr('value');  // define o estado atual da saida.
										
										void 0;
										callback({
													id_central:_id_central,
													ip:_ip,
													ddns:_ddns,
													porta:_porta,
													nome:_nome,
													data:{
															cod:_codigo,
															model:_model,
															prot:statusAtual+_prot+"!"
														},
												});
										
									 		$(this).fadeOut('slow');
									 	
									}else{
										if(_central.ident_central == undefined){
											comp.animation.toast("Módulo inexistente ou excluído");
										}else{
											comp.animation.toast(_central.ident_central+" Desativada");	
										}
									}

																		
								}
			}

			var action_acao={
								click:function(){

									//var $h4 = $(this).parent().find('h4');
									var $value = parseInt( ($(h4).html()).substring(0,($(h4).html()).indexOf('%')));
									var $id = $(this).attr('id');
									$(img_refresh).fadeIn('slow');

									//$(this).parent().find('#refresh').fadeIn('slow');

									void 0;

									
									if($value < 100 && $id == 'up'){
											$value ++;
									}else if($value > 0 && $id == 'down'){
										$value --;
									} 



									$(h4).attr('value',$value);
									$(h4).html($value + "%");

																		
								}
			}

			
			
			

					
			div_1.id = dados.PK_componente;
			div_1.className = "componente config-percent";

			if(valor_porta == null)
					i.src="../img/icons/componentes/ic_exclamacao_24dp.png";
				else
					i.src="../img/icons/componentes/" + dados.icon_componente;

			div_2.className = "descricao-componente";
			h3.innerHTML = dados.nome_componente;
			p.innerHTML = dados.subnome_componente;

			
			/* Criar Componente config*/

			div_3.className = 'config-valor';

			img_down.src = '../img/icons/system/ic_keyboard_arrow_down_black_24dp.png';
			img_down.id = 'down';

			img_up.src = '../img/icons/system/ic_keyboard_arrow_up_black_24dp.png';
			img_up.id = 'up';

			img_refresh.src = '../img/icons/system/ic_cached_black_24dp.png';
			img_refresh.id = 'refresh';
			img_refresh.style.display = 'none';

			span.className = 'ldr-atual';
			
			if(valor_ldrAtual == null){
				span.innerHTML = '--';
			}else{
				span.innerHTML = valor_ldrAtual + '%';
			}

			if(valor_porta == null){
				h4.innerHTML = '--';
			}else{
				h4.innerHTML = valor_porta + '%';	
				$(img_down).on(action_acao);
				$(img_up).on(action_acao);
				$(img_refresh).on(actionDefault);
			}
			
			
			div_3.appendChild(img_refresh);
			div_3.appendChild(img_down);
			div_3.appendChild(h4);
			div_3.appendChild(img_up);
			div_3.appendChild(span);




			
			div_2.appendChild(h3);
			div_2.appendChild(p);


			div_1.appendChild(i);
			div_1.appendChild(div_2);

			div_1.appendChild(div_3);

			
			li.appendChild(div_1);
			
			$(li).css('opacity','0');

			return  li;

}

/*
   Cria Componentes Sensor PIR
*/

cemf.js.Element.prototype.createComponenteNVD= function(dados,callback){
	void 0;
			comp = this;
			var _central  = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});
			var valor_porta = null;
			var posicaoComponente = null
			

			  try{

			  		// console.log(dados);
			  		 
			  		 // captura a ultima letra da string
			  		 var letra = (dados.prot_componente).charAt((dados.prot_componente).length - 1);
					 var posicao = parseInt(dados.pos_componente);

					 	posicaoComponente = (_central.data.status).indexOf(letra) + 1 + posicao;
					 	valor_porta = (_central.data.status).charAt(posicaoComponente);
					 
					
				}catch(e){
					void 0;
					void 0;
					

				}
			
			


			var li 		= document.createElement('li');
			var div_1 	= document.createElement('div');
			var div_2 	= document.createElement('div');
			var i 		= document.createElement('img');
			var h3 		= document.createElement('h3');
			var p 		= document.createElement('p');

			var div_3 	= document.createElement('div');
			var h4 	= document.createElement('h4');
						
					
			div_1.id = dados.PK_componente;
			div_1.className = "componente sensor-pir ";

			if(posicaoComponente == null)
					i.src="../img/icons/componentes/ic_exclamacao_24dp.png";
				else
					i.src="../img/icons/componentes/" + dados.icon_componente;

			div_2.className = "descricao-componente";
			h3.innerHTML = dados.nome_componente;
			p.innerHTML = dados.subnome_componente;

			div_3.className = "temp-umid";

			
			switch(valor_porta){
				case '0':
							h4.innerHTML = "Normal";
							h4.className = "color-temp-ice";
				break;
				case '1':
							h4.innerHTML = "Violado";
							h4.className = "color-temp-hot";
							li.className = "color-violado";
				break;
				default:
							h4.innerHTML = "Desativado";
							h4.className = "color-temp-disable";
				break;

			}
			
			
			div_3.appendChild(h4);


			div_2.appendChild(h3);
			div_2.appendChild(p);

			div_1.appendChild(i);
			div_1.appendChild(div_2);
			div_1.appendChild(div_3);
			li.appendChild(div_1);
			
			
			$(li).css('opacity','0');

			return  li;

}

/*
   Cria Componentes com Botão simples para envio de comandos
*/

cemf.js.Element.prototype.createComponenteSendButtom= function(dados,callback){
	void 0;
			comp = this;
			var _central  = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});
			var valor_porta = null;
			var posicaoComponente = null
			  try{

			  		 // captura a ultima letra da string
			  		 var letra = (dados.prot_componente).charAt((dados.prot_componente).length - 1);
					 var posicao = parseInt(dados.pos_componente);

					 	posicaoComponente = (_central.data.status).indexOf(letra) + 1 + posicao;
					 	valor_porta = (_central.data.status).charAt(posicaoComponente);
					
				}catch(e){
					void 0;
					void 0;
					

				}


			var li 		= document.createElement('li');
			var div_1 	= document.createElement('div');
			var div_2 	= document.createElement('div');
			var i 		= document.createElement('img');
			var h3 		= document.createElement('h3');
			var p 		= document.createElement('p');
			var div_3 	= document.createElement('div');
			var span 	= document.createElement('span');
						
					
			div_1.id = dados.PK_componente;
			div_1.className = "componente sensor-pir ";

			if(posicaoComponente == null)
					i.src="../img/icons/componentes/ic_exclamacao_24dp.png";
				else
					i.src="../img/icons/componentes/" + dados.icon_componente;

			div_2.className = "descricao-componente";
			h3.innerHTML = dados.nome_componente;
			p.innerHTML = dados.subnome_componente;

			div_3.className = "ir-btn";

			
			span.className = "ir-send";
			span.innerHTML = "Send";

			var actionDefault={
								click:function(){
									var _id = dados.PK_componente;
									//var _central = comp.dados_obj.search({obj:'central',PK_central:dados.FK_central});

									//console.log(_central);

									if(_central.habilita_central == 1){
										var _ip 		= _central.ip_central;
										var _porta 		= _central.porta_central;
										var _ddns 		= _central.ddns_central;
										var _prot 		=  dados.prot_componente;
										var _nome 		= _central.ident_central;
										var _id_central = _central.PK_central;
										var _model 		= _central.desc_modelo;
										var _codigo		= _central.codigo_central;

										//var statusAtual = $(h4).attr('value');  // define o estado atual da saida.
										
										void 0;

										/*
										  Verifica se tem comando IR no protocolo de envio,
										  Caso existe, começa a verificação para saber se são Multiplos comandos ou apenas um.
										  Se existir o '.' é porque é um comando Multiplo, então separace em um array.

										  E cria-se um SetTimeou para cada comando IR de tempo conforme a quantidade de 1S que tiver
										  antes do comando IR.

										*/
										if(_prot.indexOf('I') >= 0){
												if(_prot.indexOf('.') > 0){
													void 0;

													var comandos = _prot.split(".");
													void 0;

													 var tempo = 500;
													 comandos.forEach(function(element,index){

													 	var pos = element.indexOf('I');
													 	var t = element.indexOf('S');

													 	//console.log(element + "  pos :" + pos + " - t :" + t);

													 	if(t >= 0){
													 		tempo += 1000;

													 	}else if(pos >= 0){

													 		var libraries = comp.dados_obj.get('libraries_user');
													 		var PK_libraries_user = element.substr(1, pos - 1);
													 		var new_prot = _prot;
													 		var ativa_ir = false;

													 		void 0;

													 		libraries.forEach(function(element,index){
																if(element.PK_libraries_user == PK_libraries_user){
																	new_prot = element.desc_tipo_prot_ir+element.bits_libraries_user +"."+element.prot_libraries_user;
																	ativa_ir = true;
																}
															});

													 		if(ativa_ir){
														 		setTimeout(function(){


														 			callback({
																				id_central:_id_central,
																				ip:_ip,
																				ddns:_ddns,
																				porta:_porta,
																				nome:_nome,
																				data:{
																						cod:_codigo,
																						model:_model,
																						prot:new_prot+"!"
																					},
																			});
														 			void 0;

														 		},tempo);
														 	}else{
														 		comp.animation.toast("Existe um comando inexistente, providenciar alteração");

														 	}
													 	}

													 })

												}else{

													var libraries = comp.dados_obj.get('libraries_user');
													var PK_libraries_user = _prot.substr(0,_prot.indexOf('I'));

													void 0;

													libraries.forEach(function(element,index){
														if(element.PK_libraries_user == PK_libraries_user){
															_prot = element.desc_tipo_prot_ir+element.bits_libraries_user +"."+element.prot_libraries_user;
														}
													});

												}

										}


												/*
												  Envia o protocolo independente se são Multiplos comandos.
												  A central irá desconsiderar os comandos IR.
												*/

												callback({
														id_central:_id_central,
														ip:_ip,
														ddns:_ddns,
														porta:_porta,
														nome:_nome,
														data:{
																cod:_codigo,
																model:_model,
																prot:_prot+"!"
															},
													});


									}else{
										if(_central.ident_central == undefined){
											comp.animation.toast("Módulo inexistente ou excluído");
										}else{
											comp.animation.toast(_central.ident_central+" Desativada");	
										}
									}

																		
								}
			}

			$(span).on(actionDefault);
			
			
			div_3.appendChild(span);


			div_2.appendChild(h3);
			div_2.appendChild(p);

			div_1.appendChild(i);
			div_1.appendChild(div_2);
			div_1.appendChild(div_3);
			li.appendChild(div_1);
			
			
			$(li).css('opacity','0');

			return  li;

}



/*
   Carrega componentes de acordo com Tipo e mostra no Layout informado nos params
*/
cemf.js.Element.prototype.loadComponente = function(params,callback){
	void 0;
	 var load = this;
	 			
	 			
				var lista = $("<ul></ul>");
				$('.lista-componentes').html("");

				
	 	     	if((dados = params) && dados.length > 0){
	 	     		load.animation.animaAreaControle(lista,0);

				  	dados.forEach(function(element, event) {

				  			//console.log(element.FK_tipo_componente);
				  			var item;

				  			switch(element.FK_tipo_componente){
				  				case '1':
				  						item = load.createComponenteIluminacao(element, callback);
				  				break;
				  				case '2':
				  						item = load.createComponenteTempUmid(element, callback);
				  				break;
				  				case '3':
				  						item = load.createComponenteIluminacao(element, callback);
				  				break;
				  				// case '4':
				  				// 		item = load.createComponenteAlarme(element, callback);
				  				// break;
				  				case '4':
				  						item = load.createComponenteNVD(element, callback);
				  				break;
				  				case '5':
				  						item = load.createComponenteConfigPercent(element, callback);
				  				break;
				  				case '6':
				  						item = load.createComponenteSendButtom(element, callback);
				  				break;
				  				case '7':
				  						item = load.createComponenteSendButtom(element, callback);
				  				break;
				  			}
				  			
				  			lista.append(item);
				  			load.animation.adicionaItemLista(item,event);
				  	});	

				  	return true;

			     }else{
			     	// var div = $("<div></div>");
			     	// var img = $('<img></img>');
			     	// var span= $('<span></span>');

			     	// img.attr('src','../img/icons/system/ic_thumb_down_black_48dp.png');
			     	// span.html("Setor Vazio !");

			     	// var css = {
			     	// 			opacity:0.2,
			     	// 			width:'130px',
			     	// 			'margin-left':'28%',
			     	// 			'margin-top':'25%',
			     	// 			'text-align':'center',
			     	// 			'cursor':'pointer',
			     	// 			'font-size': '15px'
			     	// 	}

			     	// var acao = {
			     	// 			click: function(){
			     	// 				console.log("Adicione um novo Componente");
			     	// 			}
			     	// }
			     	

			     	// div.append(img);
			     	// div.append(span);
			     	
			     	// $(div).on(acao);

			     	// div.css(css);
			     	// lista.append(div);

			     	// load.animation.animaAreaControle(lista);
			     	// console.log(" Error --> Objeto Vazio");
			     	return false;
			     }

			     
}

cemf.js.Element.prototype.configComponentesEtapas = function( params ){
		void 0;
		var config = this;

		params = params || null;

		if(params != null && params.hasOwnProperty('dados')){
			if(params.dados == null){
				
				     config.auxElementComponente = {
				     								FK_central:"",
				     								FK_setor:config.idElementSelected,
				     								FK_tipo_componente:"",
				     								PK_componente:"",
				     								icon_componente:"ic_touch_app.png",
				     								nome_componente:"",
				     								pos_componente:"0",
				     								prot_componente:"",
				     								subnome_componente:"",
				     								tab_componente:10
				     								};

			}else{
				 config.auxElementComponente = jQuery.extend({},params.dados);
				 // console.log('---> params');
				 // console.log(config.auxElementComponente);
			}
		}else{
			void 0;
			void 0;

		}
						
		var div_container = $('<div></div>');
		div_container.addClass('layout-config-componente');
		$('#menu-proximo').text('Próximo');
				

		var div_etapas = $('<div></div>');
		div_etapas.addClass('etapas color-text-icons');

		for(var x = 1 ; x <= config.etapaConfigComponente; x++){
			var _etapa = $('<span></span>');	
			_etapa
					.addClass('etapa'+ (x))
					.text(x);
					div_etapas.append(_etapa);

		}
		
			
		div_container.append(div_etapas);
		
		if(config.etapaConfigComponente == 1) div_container.append(Etapa1);
		if(config.etapaConfigComponente == 2) div_container.append(Etapa2);
		if(config.etapaConfigComponente == 3) div_container.append(Etapa3);
		if(config.etapaConfigComponente == 4) div_container.append(Etapa4);

		
		config.animation.animaAreaControle(div_container);

		

		// <div class="layout-componente">
		// 				<img src="../img/icons/system/layout_switch_chk.png"/>
		// 			</div>

		function Etapa1(){  //  Selecionar o Tipo de Componente

				var div_layout 		= $('<div></div>');
				var h1 				= $('<h1></h1>');
				var div_select 		= $('<div></div>');
				var select 			= $('<select></select>');

				
				var div_icon 		= $('<div></div>');
				var img_icon		= $('<img></img>');

				var div_layout_comp = $('<div></div>');
				var img_layout		= $('<img></img>');


				div_layout.addClass('layout-etapa-1');
				h1.text('Escolha o layout e ícone');
				div_select.addClass('div-select');
				var opt			= $('<option></option>');
				opt.attr('value','');
				opt.text("Selecione");
				select.append(opt);


				div_layout_comp.addClass('layout-componente');
				img_layout.attr('src','../img/icons/system/layout_'+(config.auxElementComponente).FK_tipo_componente+'.png');
				div_layout_comp.html(img_layout);


				var _options = config.dados_obj.get('tipo_componente');
				_options.forEach(function(element, index){
					var option 			= $('<option></option>');
					option.attr('value',element.PK_tipo_componente);
					if(element.PK_tipo_componente == (config.auxElementComponente).FK_tipo_componente) option.attr('selected',true);
					option.text(element.desc_tipo);
					select.append(option);
				});
					
				var action = {
					change:function(){
						(config.auxElementComponente).FK_tipo_componente = $(this).val();
						img_layout.attr('src','../img/icons/system/layout_'+$(this).val()+'.png');
						void 0;

					},
					click:function(){
						$('.options-icon').fadeOut('fast',function(){
								$(this).remove()
						});
					}
				}

				var actionBtnIcon = {
					click:function(){


						var imageSelect = $(this).find('img').attr('src');
							
						img_icon.attr('src',imageSelect);
						
    					imageSelect = imageSelect.substring(imageSelect.lastIndexOf('/') + 1,imageSelect.length);
    					(config.auxElementComponente).icon_componente = imageSelect;
    					void 0;

						$('.options-icon').fadeOut('fast',function(){
								$(this).remove()
						});
					}
					
				}

				var action_premium = {	
										click:function(){
											config.animation.toast('Ícone Exclusivo Plano Premium !');
										}
									 }

				var actionIcon ={
					click:function(){
						void 0;
						if($('.options-icon').length > 0){
							$('.options-icon').remove();

						}else{

							if((config.auxElementComponente).FK_tipo_componente == ''){

								config.animation.toast("Precisa Selecionar um Layout");
								return;

							}

							/*
							   tipo_plano 
							   	1 - FREE
							   	3 - Premium

							   	1 - Switch
								2 - Temp/Humid
								3 - Switch + chk
								4 - Status NVD
								5 - Config (%)
								6 - Multiplos Comandos
								7 - Sinal IR
							*/
							var nome_images_list= [
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_lightbulb_outline_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_light_bulb_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_light_bulb_with_filament_black_24dp.png"},
												
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_candle.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_1.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_light_bulb.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_2.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_3.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_4.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_5.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_6.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_7.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_8.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_led.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_led_1.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_9.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_10.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_led_2.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lamp_11.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_abajur2_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_abajur_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_technology_controle_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_lamp_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_phone_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_post_black.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_robot_black_24dp.png"},

												{tipo_componente : 7, tipo_plano: 1 , src : "ic_airplay_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_air_conditioner_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_alarm_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_album_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_cam2_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_plug_1.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_power_supply.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_plug.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_supply.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_power.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_battery_level.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_battery_level_1.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_battery_level_2.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_battery_level_3.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_ecology_and_environment.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_ecology_and_environment_1.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_ecology_and_environment_2.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_farming_and_gardening.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_gas.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_poles.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_ecology_and_environment_3.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_energy.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_low_energy_light_bulb_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_spot_lights_color_24dp.png"},
												
												
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_countertop.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_furniture_and_household.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_tip.png"},
												
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_padlock.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_logout.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_parking.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_door.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_key.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_fence.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_fence_1.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_lift.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_timing_belt.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_garage.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_car.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_blinds.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_window.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_cam_3_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_cam_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_desktop_monitor_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_emergency_exit_black.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_equalizer_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_fingerprint_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_fire_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_fire_extinguisher_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_games_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_gas_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_gota_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_highlight_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_history_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_home_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_idea_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_kitchen_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_laser_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_leaf_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_medical_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_mercury_thermometer_with_sun_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_nature_mato_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_nature_water_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_police_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_police_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_power_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_power_settings_new_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_radio_antenna_color_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_radio_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_raindrops_falling_of_a_black_cloud_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_secure_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_security2_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_security_algemas_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_senha_black_24dp.png"},
												{tipo_componente : 4, tipo_plano: 1 , src : "ic_sensor_parede_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_settings_backup_restore_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_settings_remote_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_snowflake_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_social_security_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_storm_blue_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_storm_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_stove_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_stove_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_stove_ind_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_switch_on_black_24dp.png"},
												
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_television_person_color_24dp.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_television_wifi_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_temperature_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_temperature_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_termometro_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_thermometer_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_thermometer_red_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_touch_app.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_toys_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_tree_silhouette_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_umbrela_rain_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_umbrella_and_rain_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_videocam_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_volume_up_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_vpn_key_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_water_tap_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_wb_incandescent_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_weather_temp_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_window_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_ac_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_armchair2_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_armchair_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_bath_bubbles_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_battery2_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_battery_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_battery_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_chair_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_coffee_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_cooler_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_dinner_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_door_knob_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_door_trava_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_drink_beer_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_engine2_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_engine3_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_engine_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_engine_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_exposure_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_glass_wine_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_hanger_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_key_security_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_locker_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_motion_sensor_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_oil_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_plug2_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_plug_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_pool_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_power_cord_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_sensor_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_shower_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_sirene_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_small_fan_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_smoke_detector_color_24dp.png"},
												
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_swimmer_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_swimming_pool_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_table_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology3_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_technology_bateria_cheia_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_technology_painel_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_toilet2_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_toilet_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_tools_utensils_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_turn_notifications_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_vehicle_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 3 , src : "ic_wardrobe_color_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_wc_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_window2_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_vehicle_black_24dp.png"},
												{tipo_componente : 0, tipo_plano: 1 , src : "ic_car_in_garage_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_tele_cine.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_axn.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_cinemax.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_fox.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_tnt.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_wb.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_espn.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_foxesport.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_boomerang.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_cartoon.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_discoverykids.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_disneyxd.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_disney.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_nickjr.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_disneyjr.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_ratimbum.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_cnn.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_animalplanet.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_discovery.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_nationalgeografic.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_history.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_cancaonova.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_band.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_cultura.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_globo.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_record.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_sbt.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_sportv.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_sexzone.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_playboy.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_adulto.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_redevida.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_megapix.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_multishow.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_viva.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_space.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_globonews.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_homehelt.png"},
												{tipo_componente : 7, tipo_plano: 3 , src : "ic_canal_pfc.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_0_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_1_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_2_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_3_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_4_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_5_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_6_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_7_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_8_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_filter_9_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_closed_caption_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_fast_forward_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_fast_rewind_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_fiber_dvr_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_fiber_manual_record_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_fiber_new_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_hd_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_hearing_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_library_music_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_loop_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_mic_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_mic_off_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_movie_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_music_video_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_pause_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_play_arrow_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_queue_music_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_radio_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_replay_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_skip_next_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_skip_previous_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_stop_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_volume_mute_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_volume_off_black_24dp.png"},
												{tipo_componente : 7, tipo_plano: 1 , src : "ic_volume_up_black_24dp.png"},
												
												];


							

							var listaIcon = $("<div></div>");
							var ul = $("<ul></ul>");

							// var usuario = config.perfilUsuario(); // config.dados_obj.get('usuario',0);
							// console.log(usuario);

							nome_images_list.forEach(function(element,index){

								
										var img = $("<img></img>");
										var li = $("<li></li>");
										var span = $("<span></span>")
										var img_premium = $("<img></img>");

										img.attr('src','../img/icons/componentes/'+element.src);
										
										/*
										 Verifica o tipo de plano ára liberar os icones
										 1 - Free
										 2 - Cliente
										 3 - Premium
										 4 - Integrador
										   5 - LEAD_FREE
										   6 - LANCA_AV_001
										*/
										

										if(element.tipo_plano == 3){

											img_premium.attr('src','../img/icons/system/ic_crown_color_16dp.png');
											span.append(img_premium);

											if(config.isPlanoPremium()){
												$(li).on(actionBtnIcon);
											}else{
												li.addClass('cursor-none');
												$(li).on(action_premium);
											}

										}else{

												span.text("Free");
												$(li).on(actionBtnIcon);
										}


										li.append(img);
										li.append(span);

										/*
											Mostrar os Icones de acordo com o Layout Escolhido
											 1 - Switch
											 2 - Temp/Humid
											 3 - Switch + chk
											 4 - Status NVD
											 5 - Confiog(%)
											 6 - Multiplos Comandos
											 7 - Sinal IR
										*/

										void 0;

										switch((config.auxElementComponente).FK_tipo_componente){
											case '1':
													if(element.tipo_componente == 1
															|| element.tipo_componente == 3
																|| element.tipo_componente == 0){
														ul.append(li);
													}
											break;
											case '2':
													if(element.tipo_componente == 2
															|| element.tipo_componente == 0){
														ul.append(li);
													}
											break;
											case '3':
													if(element.tipo_componente == 1
															|| element.tipo_componente == 3
																|| element.tipo_componente == 0){
														ul.append(li);
													}
											break;
											case '4':
													if(element.tipo_componente == 4
															|| element.tipo_componente == 0){
														ul.append(li);
													}
											break;
											case '5':
													if(element.tipo_componente == 5
															|| element.tipo_componente == 0){
														ul.append(li);
													}
											break;
											case '6':
													if(element.tipo_componente == 6
															||  element.tipo_componente == 7
																|| element.tipo_componente == 0){
														ul.append(li);
													}
											break;
											case '7':
													if(element.tipo_componente == 7
															|| element.tipo_componente == 0){
														ul.append(li);
													}
											break;
											default:
													if(element.tipo_componente == 0){
														ul.append(li);
													}
											break;



										}
										
								
								
							});
							
							
							// nome_images_list.forEach(function(element,index){
							// 	var img = $("<img></img>");
							// 	var li = $("<li></li>");
							// 	img.attr('src','../img/icons/componentes/'+nome_images_list[index]);
							// 	li.append(img);
							// 	ul.append(li);
							// 	$(li).on(actionBtnIcon);

							// });

							listaIcon.addClass("options-icon shadow-bottom-z-4");
														
							void 0;
							
							listaIcon.append(ul);
							div_layout.prepend(listaIcon);
							listaIcon.fadeIn('fast');
						}

					}
				}
				
				$(select).on(action);


				div_icon.addClass('icon-escolha');
				img_icon.attr('src','../img/icons/componentes/'+(config.auxElementComponente).icon_componente);
				$(div_icon).on(actionIcon);
				
				div_select.append(select);
				div_icon.append(img_icon);

				div_layout.append(h1);
				div_layout.append(div_layout_comp);
				div_layout.append(div_select);
				div_layout.append(div_icon);
				$(select).focus();

				

			return div_layout;
		}

		function Etapa2(){ // Selecionar a Central que será vinculada o comando
			
			var div_layout 		= $('<div></div>');
			var h1 				= $('<h1></h1>');
			var div_centrais 	= $('<div></div>');
			//var ul 				= $('<ul></ul>');

			div_layout.addClass('layout-etapa-2');
			h1.text('Escolha o módulo que será vinculada');

			var params = {
					element: div_centrais,
					dados: config.dados_obj,
					habilitado:false,
					callbackCentral:function(data){
							callbackSelecionarCentral(data);
						}
					};

			 if(!config.loadCentral(params)){
				   		config.objetoVazio({element:div_centrais,text:'Nenhum módulo Cadastrado !'})
				   		void 0;
			 }
			//config.loadCentral(params);

			div_layout.append(h1);
			div_layout.append(div_centrais);

			
			$(div_centrais).find('li').each(function(el,index){
				var id = $(this).attr('id');
				//console.log( id +"=="+ (config.auxElementComponente).FK_central);
				if( id == (config.auxElementComponente).FK_central) $(this).addClass('selected');
			});

			

			function callbackSelecionarCentral(data){
					var prop = data.proprietario_central;
				 	var itemId = data.PK_central;

				    void 0;
					(config.auxElementComponente).FK_central = itemId;
					void 0;
					if((config.auxElementComponente).subnome_componente.length == 0){
						(config.auxElementComponente).subnome_componente = data.ident_central;
					}
					void 0;
			}

			
			return div_layout;
		}
		function Etapa3(){ // Escolher o comando da central escolhida
			
			var div_layout 	= $('<div></div>');
			var h1 			= $('<h1></h1>');
			var div_select 	= $('<div></div>');
			var select 		= $('<select></select>');
			//var input 		= $('<input></input>');
			

			

			var opt			= $('<option></option>');
			opt.attr('value','');
			opt.text("Selecione");
			select.append(opt);

			div_layout.addClass('layout-etapa-3');
			/*input.addClass('color-secondary-text');
			input.attr({
					'id':'prot_componente',
					'type':'hidden',
					'placeholder':'Escolha ou define o seu comando',
					'readonly':'true'

				});*/

			div_select.addClass('div-select');
			

			var comandos = config.dados_obj.search({obj:'central',PK_central:(config.auxElementComponente).FK_central}).comandos;
			void 0;

			

				if(comandos){
								comandos.forEach(function(element,index){
								var option 		= $('<option></option>');
								option.attr('value',element.prot_comando_modelo+":"+element.pos_comando_modelo);
								option.text(element.desc_comando_modelo);

								if(element.prot_comando_modelo == (config.auxElementComponente).prot_componente){
									 option.attr('selected',true);
									// input.val((config.auxElementComponente).prot_componente + ":" + element.pos_comando_modelo);
								}

								/*
									Mostrar os comandos de acordo com o Layout Escolhido
									 1 - Switch
									 2 - Temp/Humid
									 3 - Switch + chk
									 4 - Status NVD
									 5 - Confiog(%)
									 6 - Multiplos Comandos
									 7 - Sinal IR
								*/
								switch((config.auxElementComponente).FK_tipo_componente){
									case '1':
											if( element.FK_tipo_componente == 1 
													|| element.FK_tipo_componente == 3){
											  		select.append(option)
											}
									break;
									case '4':
											if( element.FK_tipo_componente == 1 
													|| element.FK_tipo_componente == 3
														|| element.FK_tipo_componente == 4){
											  		select.append(option)
											}
									break;
									case '6':
												if(	element.FK_tipo_componente == 1 
															|| element.FK_tipo_componente == 3 
												  				|| element.FK_tipo_componente == 6
												  					|| element.FK_tipo_componente == 7){
												  		select.append(option)
												  }
									break;
									default:
										if(element.FK_tipo_componente ==  (config.auxElementComponente).FK_tipo_componente){
											  		select.append(option)
											}
									break;

								}

								

								
							});

								if((config.auxElementComponente).FK_tipo_componente == 7 || (config.auxElementComponente).FK_tipo_componente == 6){	

								var libraries = config.dados_obj.get('libraries_user');
								void 0;

									if(libraries.length > 0){
										
											libraries.forEach(function(element,index){
												var option 		= $('<option></option>');
												option.attr('value',element.PK_libraries_user+"I:0");
												option.text(element.desc_marca_ap+" : "+element.desc_libraries_user);
												select.append(option);
												void 0;
												void 0;
												void 0;
												if((element.PK_libraries_user + "I") == (config.auxElementComponente).prot_componente){
													 option.attr('selected',true);
													// input.val((config.auxElementComponente).prot_componente + ":" + element.pos_comando_modelo);
												}
											});
									}else{
											 (config.auxElementComponente).prot_componente = '';
										     config.animation.toast("Biblioteca vazia, nenhum comando cadastrado.");
									}

								}

							var action = {
								change:function(){
									
									var data = $(this).val().split(":");

									(config.auxElementComponente).prot_componente = data[0];
									(config.auxElementComponente).pos_componente = data[1];
									(config.auxElementComponente).nome_componente = select.find(':selected').text();
									void 0;

									//input.val($(this).val());
									//console.log(config.auxElementComponente);
								}
							}
							

							$(select).on(action);

							h1.text('Adicione o comando.');

							div_select.append(select); 
							
							div_layout.append(h1); // adicionado texto
							div_layout.append(div_select); // adicionado switch
							//div_layout.append(input);


						}

						if(config.auxElementComponente.FK_tipo_componente == '6'){

								var div_add 	= $('<div></div>');
								var img_icon 	= $('<img></img>');
								
								var div_sub_select 	= $('<div></div>');
								var sub_select 		= $('<select></select>');
								var sub_option1		= $('<option></option>');
								var sub_option2		= $('<option></option>');
								
								var div_tempo		= $('<div></div>');
								var img_tempo		= $('<img></img>');

								var div_area_select = $('<div></div>');

								h1.text('Adicione Multiplos comandos.');
								div_add.addClass('btn btn-default color-bar-2');
								div_add.attr('id','add-comando');

								// option ON OFF
								sub_option1.text("OFF");
								sub_option1.attr('value','0');
								sub_option2.text("ON");
								sub_option2.attr('value','1');

								sub_select.append(sub_option1,sub_option2);

								div_sub_select.addClass('option-select');
								div_sub_select.append(sub_select);

								// Btn Tempo

								div_tempo.addClass('btn btn-default color-bar-2');
								div_tempo.attr('id','add-tempo');
								img_tempo.attr('src',"../img/icons/system/ic_update_white_24dp.png");

								div_tempo.append(img_tempo);

								// Area de Comandos

								div_area_select.addClass('area-select-item');

									var action_add = {	
													click:function(){


														var span = $("<span></span>");
														//var option1 = $(".div-select select :selected").text();
														var option1 = select.find(':selected').text();
														//var prot = $(".div-select select :selected").val().split(":")[0];

														if(option1 == 'Selecione')
																return;

														var prot = select.find(":selected").val().split(":")[0];
														var option2 = sub_select.val();
														void 0;
														var isIR = prot.indexOf('I');  // verifica se é um comando IR

														span.attr('value',option2+prot);
														span.text(option1 + ((isIR >= 0) ? "": (" - " + ((option2 == '0') ? 'OFF' : 'ON'))) );
														var p = $("<p></p>");
														p.text('x');
														p.addClass('item');
														p.on('click',function(){

															$(this).parent().fadeOut('slow',function(){
																	$(this).remove();
																	atualizaDadosProt();		
															})
															
														
														});
														span.append(p);

														div_area_select.append(span);
														atualizaDadosProt();


													}

									};
									var action_tempo = {	
													click:function(){
														var span = $("<span></span>");
														span.text('1s');
														var p = $("<p></p>");
														p.text('x');
														p.addClass('item');
														p.on('click',function(){

															$(this).parent().fadeOut('slow',function(){
																	$(this).remove();	
																	atualizaDadosProt();	
															})
															
														
														});
														span.attr('value',"1S");
														span.append(p);
														div_area_select.append(span);
														atualizaDadosProt();
													}

									};

								div_add.on(action_add);
								div_tempo.on(action_tempo);


								/*
								   Atualizando dados Caso o prot esteja com informações
								   significa que está no modo Edição.
								*/


								if((config.auxElementComponente).prot_componente.length > 1){
									var ler_prot = (config.auxElementComponente).prot_componente.split(".");
									void 0;
									ler_prot.forEach(function(element,index){

										if(index > 0){ // desconsidera o comando 'E'

												var letra = element.charAt(element.length -1);
												var pos   = parseInt(element.substr(element.length -3,element.length -2)) + 1;
												var estado = element.charAt(0);

												void 0;

												var span = $("<span></span>");
												var p = $("<p></p>");
												p.text('x');
												p.addClass('item');
												p.on('click',function(){

													$(this).parent().fadeOut('slow',function(){
															$(this).remove();
															atualizaDadosProt();		
													})
													
												
												});
												
												
												span.attr('value',element);	

												switch(letra){
													case 'R':
														
														span.text('Saída R0'+pos + " - "+ ((estado == '0') ? "OFF" : "ON" ));

													break;
													case 'S':
														span.text('1s')
														
													break;
													case 'A':
														span.text('Alarme - '+ ((estado == '0') ? "OFF" : "ON" ));
													break;
													case 'I':

															var libraries = comp.dados_obj.get('libraries_user');
													 		var PK_libraries_user = element.substr(1, element.indexOf('I') - 1 );
													 		var localiza_ir = false;
													 		
													 		void 0;
													 		var new_text = "IR";

													 		libraries.forEach(function(element2,index2){
																if(element2.PK_libraries_user == PK_libraries_user){
																	new_text = element2.desc_marca_ap+":"+element2.desc_libraries_user;
																	localiza_ir = true;
																}
															});
														 
														 	if(localiza_ir){
														 		span.text(new_text);
														 	}else{
														 		span.text(" ? IR inexistente");
														 	}
													break;

												}

												span.append(p);

												div_area_select.append(span);
										}
									});
									
								}
								
								img_icon.attr('src',"../img/icons/system/ic_arrow_downward_white_24dp.png");
								div_add.html(img_icon);
								div_layout.append(div_add); // adiciona Add Comando
								div_layout.append(div_sub_select); // Adiciona Select option
								div_layout.append(div_tempo); // adiciona Btn Tempo
								div_layout.append(div_area_select); // adiciona Area de Comandos.

						}



						function atualizaDadosProt(){

							var itens = $('.area-select-item').find('span');
							var prot = "E.";  // informa o Arduino que é um s]ao Multiplos Comandos
							void 0;

							if(itens.length > config.limiteComandosMultiplos && !config.isPlanoPremium() && !config.isCliente() ){
								
									config.animation.toast("Limite Excedido, adquira a conta PREMIUM !");
										itens.each(function(index, el) {
											if(index > (config.limiteComandosMultiplos - 1))
												$(el).fadeOut('slow', function() {
													$(el).remove();	
													itens = $('.area-select-item').find('span');

													itens.each(function(event,el){
														prot += $(el).attr('value') + ((event < (itens.length -1)) ? "." : "");
													});

													(config.auxElementComponente).prot_componente = prot;
													void 0;

												});
												 
										});
									
																
							}else{
									itens.each(function(event,el){
										prot += $(el).attr('value') + ((event < (itens.length -1)) ? "." : "");
									});

									(config.auxElementComponente).prot_componente = prot;
									void 0;

							}
							

							
						}
					
			return div_layout;
		}
		function Etapa4(){ // Definir o Nome, Subnome e finalizar.
			
			var div_layout 	= $('<div></div>');
			var h1 			= $('<h1></h1>');
			var input_1 	= $('<input></input>');
			var input_2 	= $('<input></input>');

			div_layout.addClass('layout-etapa-4');

			var action_1 = {
					change:function(){
						(config.auxElementComponente).nome_componente = $(this).val();
					}
			}
			var action_2 = {
					change:function(){
						(config.auxElementComponente).subnome_componente = $(this).val();
					}
			}
			input_1.attr({
					'id':'nome_componente',
					'type':'text',
					'placeholder':'Nome Principal',
				});
			input_2.attr({
					'id':'subnome_componente',
					'type':'text',
					'placeholder':'Nome Secundario',
				});

			$(input_1).on(action_1);
			$(input_2).on(action_2);

			if($(input_2).val().length == 0){
				$(input_2).val("");
			}

			h1.text('Nome do Componente.');

			if((config.auxElementComponente).nome_componente != '') input_1.val((config.auxElementComponente).nome_componente);
			if((config.auxElementComponente).subnome_componente != '') input_2.val((config.auxElementComponente).subnome_componente);


			div_layout.append(h1);
			div_layout.append(input_1);
			div_layout.append(input_2);

			$('#menu-proximo').text('Finalizar');


			return div_layout;
		}


}


/*
    Cria item Central <li>


*/
cemf.js.Element.prototype.createCentral = function(dados){
	void 0;
	 var create = this;

	 		var li 			= $('<li></li>');
         	var i_1 		= $('<img></img>');
         	var div 	 	= $('<div></div>');
         	var p_1 		= $('<p></p>');
         	var p_2 		= $('<p></p>');
         	var p_3 		= $('<p></p>');
         	var p_4 		= $('<p></p>');
         	var i_2 		= $('<img></img>');


         	 li.attr('id',dados.PK_central);
         	 i_1.attr('src','../img/icons/system/ic_router_black_36dp.png');
    		
    		div.addClass("dados-central font-size-2 color-primary-text");
    		p_1.text(dados.ident_central);
    		p_2.text(dados.ip_central + ":"+dados.porta_central);
    		p_3.text('Chave:'+dados.hash_central);
    		p_4.text('Model:'+dados.desc_modelo);

    		


    		var action_prop ={ // Central do Proprietario
    			click:function(){
    				create.idConfigElementSelected = $(this).index();
    				// create.params_.callbackCentral(dados.PK_central,dados.proprietario_central);
    				create.params_.callbackCentral(dados);
    			}
    		}


    		/* proprietario_central
    		     1 = Proprietario
    		     2 = Compartilhada

    		    habilita_central
    		    1 = Ativa
    		    0 = desativada
    		*/


	   		if(dados.proprietario_central == 2){ // se a central é compartilhada
    			i_2.attr('src','../img/icons/system/ic_group_black_32dp.png');
    			
    			if(dados.habilita_central == 0){  // Se a central foi desabilitada pelo proprietário
    				i_2.css('opacity','0.2');
	    			i_1.css('opacity','0.3');
	    			div.css({'opacity':'0.4'});
					i_2.attr('src','../img/icons/system/ic_group_black__off_32dp.png');	    									

    			}
    			
    		}else if(dados.proprietario_central == 1){ // Se a central é do proprietario
    			if(dados.habilita_central == 1){
    				i_2.attr('src','../img/icons/system/icon-check.png');
    				
    			}else{
					i_2.attr('src','../img/icons/system/icon-do-not.png');
    				
    			}
    			
    		}else if(dados.proprietario_central == 0){
    			i_2.attr('src','../img/icons/system/ic_group_black_32dp.png');	

    			if(dados.habilita_central == 0){
    				i_2.css('opacity','0.2');
	    			i_1.css('opacity','0.3');
	    			div.css({'opacity':'0.4'});
    			}

    			
    		}

    		try{
    			void 0;
    			if(dados.error > 0){
    				if(dados.proprietario_central == 1){
						i_2.attr('src','../img/icons/system/ic_portable_wifi_off_black_36dp.png');	    									
					}else if(dados.proprietario_central == 2){
						i_2.attr('src','../img/icons/system/ic_group_black_wifi_off_32dp.png');	    									
					}
    			}
    		}catch(e){
    			void 0;
    		}

    		$(li).on(action_prop);
    		
    		div.append(p_1);
    		div.append(p_2);
    		div.append(p_3);
    		div.append(p_4);

    		li.append(i_1);
    		li.append(div);
    		li.append(i_2);



    		$(li).css('opacity','0');
    		return li;
}

/*
   Carrega Centrais de acordo com Dados ('central')
*/
cemf.js.Element.prototype.loadCentral = function(params){
	void 0;
	this.params_ = jQuery.extend(this.params_,params);

	 var load = this;
	 	
	 			var div = $("<div></div>");
	 			div.addClass('lista-centrais');
	 			var lista = $("<ul></ul>");
	 	    	 	
	 	    	div.append(lista);
	 	    	params.element.html(div);
				 

				 	//console.log(params);

	 	    	if((dados = params.dados.get().central)){

	 	    		if(dados.length > 0){
	 	    			
					 	dados.forEach(function(event, el){
					 				var item = load.createCentral(event)
					 				if(params.habilitado){
					 					if(event.habilita_central == 1){
					 						lista.append(item);
					 						load.animation.adicionaItemLista(item,el);
					 					}
					 				}else{
					 					lista.append(item);
					 					load.animation.adicionaItemLista(item,el);
					 				}
					 				
					 	});

					 	return true;

					 }				
	
			    }else{
			    	void 0;
			    }

return false;			   

}

cemf.js.Element.prototype.objetoVazio = function(params){
	var self = this;
						var div2 = $("<div></div>");
				     	var img = $('<img></img>');
				     	var span= $('<span></span>');

				     	img.attr('src','../img/icons/system/ic_thumb_down_black_48dp.png');
				     	span.html(params.text);

				     	var css = {
				     				opacity:0.2,
				     				width:'130px',
				     				'margin-left':'28%',
				     				'margin-top':'25%',
				     				'text-align':'center',
				     				'cursor':'pointer',
				     				'font-size': '15px',
				     		}


				     	div2.append(img);
				     	div2.append(span);
				     	
				     	div2.css(css);
				     	params.element.append(div2);

				     	void 0;

}

/*
   Carrega as Bibliotecas IR do Usuario

*/
cemf.js.Element.prototype.loadMyLibraries = function(params){
	void 0;
	this.params_ = jQuery.extend(this.params_,params);

	 var load = this;
	 	
	 			var lista = $("<ul></ul>");
	 	    	params.element.html(lista);

	 	    	if((dados = params.dados.get().libraries_user)){

	 	    		if(dados.length > 0){
					 	dados.forEach(function(event, el) {
					 			    //console.log(event);
					 				 var item = load.createMyLibrarieList(event,params)
					 				 lista.append(item);
					 				 load.animation.adicionaItemLista(item,el);
					 	});	

				 		return true;
					}
	
			    }else{
			    	void 0;
			    }

return false;			    

}

/*
   Cria Componentes Sensor PIR
*/

cemf.js.Element.prototype.createMyLibrarieList= function(dados,callback){
	void 0;

			comp = this;
			


			var li 		= document.createElement('li');
			var div_1 	= document.createElement('div');
			var div_2 	= document.createElement('div');
			var i 		= document.createElement('img');
			var h3 		= document.createElement('h3');
			var p 		= document.createElement('p');

			var div_3 	= document.createElement('div');
			var i_del   = document.createElement('img');
			var i_edit   = document.createElement('img');


			void 0;

			div_1.id = dados.PK_libraries_user;
			div_1.className = "componente config-percent";

			
			i.src="../img/icons/system/ic_technology_controle_black_24dp.png";

			div_2.className = "descricao-componente";
			h3.innerHTML = "["+dados.desc_marca_ap+"] - " + dados.desc_libraries_user;
			p.innerHTML = dados.desc_familia_ap;

			i_del.src="../img/icons/system/ic_delete_black_24dp.png";
			i_edit.src="../img/icons/system/ic_mode_edit_black_24dp.png";

			div_3.className = "config-valor";

			var alterar_action = {
								click:function(){
									callback.callbackAlterar(dados);
								}
			};

			var excluir_action = {
								click:function(){
									callback.callbackExcluir(dados);
								}
			}

			var shared_action = {
								click:function(){
									comp.animation.toast("Não é possivel editar, Item compartilhado !");
								}
			}

			void 0;


			if((comp.dados_obj.get('usuario')[0].PK_usuario) == dados.FK_usuario){
				$(i_edit).on(alterar_action);
				$(i_del).on(excluir_action);

				div_3.appendChild(i_edit);
				div_3.appendChild(i_del);
			} else{
				i_edit.src = "../img/icons/system/ic_group_black_32dp.png";
				$(i_edit).on(shared_action);

				div_3.appendChild(i_edit);
			}

			div_2.appendChild(h3);
			div_2.appendChild(p);

			div_1.appendChild(i);
			div_1.appendChild(div_2);
			div_1.appendChild(div_3);
			
			li.appendChild(div_1);

			li.className = "config-libraries";

			
			
			$(li).css('opacity','0');

			return  li;

}



cemf.js.Element.prototype.criaComponenteCompartilhado = function(dados,params){
	void 0;

			var self = this;
			
			var id_usuario_atual = params.dados.get('usuario')[0].PK_usuario;
			var email_usuario_atual = params.dados.get('usuario')[0].email_usuario;

			var li 		= document.createElement('li');
			var div_1 	= document.createElement('div');
			var div_2 	= document.createElement('div');
			var i 		= document.createElement('img');
			var h3 		= document.createElement('h3');
			var p 		= document.createElement('p');

			var div_3 	= document.createElement('div');
			var i_del   = document.createElement('img');
			var i_person   = document.createElement('img');

			div_1.className = "componente config-percent";
			div_2.className = "descricao-componente";

			i_del.src="../img/icons/system/ic_delete_black_24dp.png";
			i_person.src="../img/icons/system/ic_person_black_24dp.png";

			div_3.className = "config-valor";

			var excluir_centrais = {
								click:function(){
									params.callbackCentrais(dados);
								}
			}

			var excluir_libraries = {
								click:function(){
									params.callbackLibraries(dados);
								}
			}

			var person_action = {
								click:function(){
									params.callbackPerson(dados);
								}
			}

			

			switch(params.tipo){
				case 'centrais':

					i.src="../img/icons/system/ic_router_black_24dp.png";
					h3.innerHTML = dados.ident_central;
					if(email_usuario_atual == dados.email_usuario){
						p.innerHTML = '<font color="green">Compartilhado comigo</font>';
						div_3.appendChild(i_person);
						$(i_person).on(person_action);
					}else{
						p.innerHTML = 'com :' + dados.email_usuario;	
					}
					
					$(i_del).on(excluir_centrais);

				break;
				case 'libraries':
					i.src="../img/icons/system/ic_technology_controle_black_24dp.png";
					h3.innerHTML = 'Biblioteca IR';
					if(email_usuario_atual == dados.email_usuario){
						p.innerHTML = '<font color="green">Compartilhado Comigo</font>';
						div_3.appendChild(i_person);
						$(i_person).on(person_action);
					}else{
						p.innerHTML = 'com :' + dados.email_usuario;	
					}
					
					$(i_del).on(excluir_libraries);

				break;

			}
	
			
			div_3.appendChild(i_del);
			div_2.appendChild(h3);
			div_2.appendChild(p);

			div_1.appendChild(i);
			div_1.appendChild(div_2);
			div_1.appendChild(div_3);
			
			li.appendChild(div_1);

			li.className = "config-libraries";
		
			
			$(li).css('opacity','0');

			return  li;

}



/*

   Carregando todos os compoentes compartilhados com terceiros e comigo

*/

cemf.js.Element.prototype.loadCompartilhamento = function(params){
	void 0;
	var load = this;
	 	
	 			var lista1 = $("<ul></ul>");
	 			//var lista2 = $("<ul></ul>");
	 	    	
	 	    	var centrais;
	 	    	var libraries;


	 	    	//var span1 = $('<span></span>');
	 	    	var img1 = $('<img></img>');
	 	    	var img2 = $('<img></img>');

	 	    	img1.attr('src','../img/icons/system/ic_people_black_36dp.png');

	 	    	// span1.append(img1);

	 	    	// span1.append('Meus Recursos Compartilhados');

	 	    	// span1.addClass('compartilhados');

	 	    	//params.element.html(span1);
	 	    	params.element.html(lista1);
	 	    	



	 	    	try{
	 	    		centrais = (params.result).centrais;
	 	    		libraries = (params.result).libraries;

	 	    		void 0;
	 	    		void 0;

	 	    	}catch(e){
	 	    		void 0

	 	    	}


	 	    	try{
		 	    	centrais.forEach(function(element,index){
		 	    		params.tipo = 'centrais';
		 	    		var item = load.criaComponenteCompartilhado(element,params);
		 	    		lista1.append(item);
		 	    		load.animation.adicionaItemLista(item,index);
		 	    	});
		 	    }catch(e){
		 	    	load.animation.toast("Problema ao carregar módulos compartilhados");
		 	    	void 0;
		 	    }

		 	    try{
		 	    	libraries.forEach(function(element,index){
		 	    		params.tipo = 'libraries';
		 	    		var item = load.criaComponenteCompartilhado(element,params);
		 	    		lista1.append(item);
		 	    		load.animation.adicionaItemLista(item,index);
		 	    	});
		 	    }catch(e){
		 	    	load.animation.toast("Problema ao carregar Bibliotecas compartilhadas");
		 	    	void 0;
		 	    }


}

/*
   Carrega os Agendamentos

*/
cemf.js.Element.prototype.loadMyAgendamento = function(params,callback){
	void 0;
	var self = this;
	self.params_ = jQuery.extend(self.params_,params);
	void 0;

	var centralAgendaSelecionada = self.params_.ultimaCentral || -1;
	var saidaSelecionada = self.params_.ultimaSaida || -1 ;
	var status = '';
	
  	
  	// Criando a Tela inicial de Componentes
	 var d_agendador 		= $("<div></div>");
	 d_agendador.addClass('agendador');


	  /************************
	   * Criando o campo de seleção do módulo

	   ************************/
		 var d_form_modulo 		= $("<div></div>");
		 var d_sub_form_modulo 	= $("<div></div>");
		 var d_title_modulo 	= $("<div></div>");
		 var s_modulo 			= $("<span></span>");
		 var l_modulo 			= $("<label></label>");
		 var i_modulo 			= $("<img></img>");
		 var select_modulo   	= $("<select></select>");

		 var p_datahora 			= $("<p></p>");
		 p_datahora.addClass('title-1');
//		 p_datahora.text("Sexta feira 14/05/2017 as 10:28");
		 d_agendador.append(p_datahora);


		  d_form_modulo 			.addClass('form pt-10 pb-10 pl-10 pr-10 mt-10');
		  d_sub_form_modulo 		.addClass('border pb-20 pl-20 pr-20');
		  d_title_modulo 			.addClass('title-form');
		  s_modulo 					.addClass('title-2 color-text-primary');
		  l_modulo 					.addClass('title-2 nobold mt-10');
		  select_modulo 			.addClass('select-default color-white');


		  s_modulo.text("Módulos RTC");
		  l_modulo.text("Módulo");
		  i_modulo.attr("src","../img/icons/system/ic_location_searching_black_24dp.png");


		  var centrais = self.params_.dados.get('central');

		   if(centralAgendaSelecionada != -1){
			select_modulo
							.attr({
									disabled:true,
									
								})		 
							.addClass('disable');
		  }

		  
		  centrais.forEach(function(el,ind){
			//	console.log(el);
				if(el.desc_modelo.search("RTC") > -1 || true){
					 // Caso não seja informado o Numero da Central, mostra a primeira.
				 	if(centralAgendaSelecionada == -1)
				 		centralAgendaSelecionada = el.PK_central;

					var opt = $("<option></option>");
					opt.attr('value',el.PK_central);
					opt.text(el.desc_modelo + " - " + el.ident_central);
									select_modulo.append(opt);

					if(centralAgendaSelecionada == el.PK_central){
						opt.attr('selected',true);
					}
			 	}
		   });

		  atualizarStatus();

		  var action_select = {
		  	change:function(){
		  					//console.log("Click" + $(this).val());
						  	 centralAgendaSelecionada = $(this).val();
						  	 var par = {
						  	 			id_central : centralAgendaSelecionada,
						  	 			id_saida : saidaSelecionada,
						  	 }
						  	 alimentarSelectSaidas(par);
						  	 atualizarStatus();
						  	 atualizaAgendamentos();

		  	}
		  }
		  
		  select_modulo.on(action_select);


		  d_title_modulo.append(s_modulo);
		  d_sub_form_modulo.append(d_title_modulo,l_modulo,i_modulo,select_modulo);
		  d_form_modulo.append(d_sub_form_modulo);
		  


		  /************************
		  	   Agendar Eventos

		  ************************/

			var d_form_eventos    	 = $("<div></div>");
			var d_sub_form_eventos 	 = $("<div></div>");
			var d_title_eventos 	 = $("<div></div>");

			var s_eventos 			= $("<span></span>");
			var l_eventos			= $("<label></label>");
			var i_eventos 			= $("<img></img>");
			var select_saida   		= $("<select></select>");

			var d_ligar 			= $("<div></div>");
			var l_ligar				= $("<label></label>");
			var i_ligar 			= $("<img></img>");
			var input_ligar 		= $("<input></input>");

			var d_desligar 			= $("<div></div>");
			var l_desligar			= $("<label></label>");
			var i_desligar 			= $("<img></img>");
			var input_desligar 		= $("<input></input>");




			d_form_eventos 				.addClass('form pt-10 pb-10 pl-10 pr-10 ');
			d_sub_form_eventos 			.addClass('border pb-20 pl-20 pr-20');
			d_title_eventos 			.addClass('title-form');
			s_eventos 					.addClass('title-2 color-text-primary');
			l_eventos 					.addClass('title-2 nobold mt-10');
			select_saida 				.addClass('select-default color-white');
			d_ligar 					.addClass('horas mr-10');
			l_ligar 					.addClass('title-2 nobold mt-10');
			input_ligar 				.addClass('input-default color-white');

			d_desligar 					.addClass('horas');
			l_desligar 					.addClass('title-2 nobold mt-10');
			input_desligar 				.addClass('input-default color-white');


			s_eventos.text("Agendar Eventos");
			l_eventos.text("Saída");
			l_ligar.text("Ligar :");
			l_desligar.text("Desligar :");

			i_eventos.attr('src','../img/icons/system/ic_location_searching_black_24dp.png');
			i_ligar.attr('src','../img/icons/system/ic_access_alarms_black_24dp.png');
			i_desligar.attr('src','../img/icons/system/ic_access_alarms_black_24dp.png');

			input_ligar.attr({
						type:'time',
						placeholder:"",
			})

			input_desligar.attr({
						type:'time',
						placeholder:"",
			})


			if(saidaSelecionada != -1){
				select_saida
								.attr({
										disabled:true,
										
									})		 
								.addClass('disable');
		  	}


			 var par = {
		  	 			id_central : centralAgendaSelecionada,
		  	 			id_posSaida : saidaSelecionada,
		  	 }
		  	 alimentarSelectSaidas(par);

			function alimentarSelectSaidas(par){
				// console.log("########################################");
				// console.log(par);
				// console.log(centrais);
				
				select_saida.html("");
				   centrais.forEach(function(el,ind){
						//console.log(el);

						 // Verificar se o ID da Central é o mesmo selecianado no Switch
						 if(el.PK_central == par.id_central){

							 	(el.comandos).forEach(function(el2,ind2){

							 		/* Mostrar somente os comandos do modelo Switch*/
							 		if(el2.FK_tipo_componente == 3){
							 			//console.log(el2);
								 		var opt = $("<option></option>");
								 		opt.attr('value',el2.pos_comando_modelo);
									 	opt.text(el2.desc_comando_modelo);
										select_saida.append(opt);

										if(el2.pos_comando_modelo == par.id_posSaida){
											void 0;
											opt.attr(
														'selected',true
													);
												status = el.data.status;
										}
									}
							 	});
						 	 
						 }

				   });
				 
			}

			
			d_title_eventos.append(s_eventos);
			d_ligar.append(l_ligar,i_ligar,input_ligar);
			d_desligar.append(l_desligar,i_desligar,input_desligar);
			d_sub_form_eventos.append(d_title_eventos,l_eventos,i_eventos,select_saida,d_ligar,d_desligar);
			d_form_eventos.append(d_sub_form_eventos);
			

			



            // Atualizar Status da Central Selecionada para atualizar interface

            function atualizarStatus(){
            	status = "";
	            centrais.forEach(function(el,ind){
					if(el.desc_modelo.search("RTC") > -1){
					 	if(centralAgendaSelecionada == el.PK_central){
					 			try{
								 	if(el.hasOwnProperty("data")){
								 		 status = el.data.status;
								 		 	// if(status > 0){
								 		 	// }
								 	}
								 }catch(e){
								 	void 0;
								 }

					 	}
					 		
				 	}
			   });

	           // Atualiza informações da Data e Hora do RTC na interface

	           var txt_dias = ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'];

	           void 0;
	           var _rtc = status.substr(status.search("RTC"),22);
	           // RTCH00:26D15/05/2019S3
	           void 0;
	           
	           var txt_datahora = txt_dias[parseInt(_rtc[21])] + ", "; // dia da Semana
	           txt_datahora += _rtc.substr(_rtc.search("D") + 1,10) + " às ";
	           txt_datahora += _rtc.substr(_rtc.search("H") + 1,5);

	           p_datahora.text(txt_datahora);
	           // console.log(status);
            }

		/******************************
	    * Criando os dia das semanas
	   
	    ******************************/

	    	var dias = [
	    				 {
	    				 	title:'Domingo',
	    				 },
	    				 {
	    				 	title:'Segunda',
	    				 },
	    				 {
	    				 	title:'Terça',
	    				 },
	    				 {
	    				 	title:'Quarta',
	    				 },
	    				 {
	    				 	title:'Quinta',
	    				 },
	    				 {
	    				 	title:'Sexta',
	    				 },
	    				 {
	    				 	title:'Sábado',
	    				 },
	    				 {
	    				 	title:'Repetir',
	    				 },
						];

			var d_form_semana 		= $("<div></div>");
			var d_sub_form_semana 	= $("<div></div>");
			var d_title_semana 		= $("<div></div>");
			var s_semana 			= $("<span></span>");
			var d_coluna1_semana 	= $("<div></div>");
			var d_coluna2_semana 	= $("<div></div>");


			d_form_semana 			.addClass('form pt-10 pb-10 pl-10 pr-10 mt-10');
			d_sub_form_semana 		.addClass('border pb-20 pl-20 pr-20');
			d_title_semana 			.addClass('title-form');
			s_semana 				.addClass('title-2 color-text-primary');
			d_coluna1_semana 		.addClass('sem-r');
			d_coluna2_semana 		.addClass('sem-r');

			s_semana.text("Dias da Semana");

			dias.forEach(function(element,index){
			//	console.log(element);

				var d_dia   		= $("<div></div>");
				var l_title_dia 	= $("<label></label>");
				var l_container_dia = $("<label></label>");
				var input_dia 		= $("<input></input>");
				var s_dia 			= $("<span></span>");

				d_dia 			.addClass('semana');
				l_title_dia 	.addClass('title-2');
				l_container_dia .addClass('container ml-5');
				input_dia 		.addClass('title-2 nobold');
				s_dia 			.addClass('checkmark');

				l_title_dia.text(element.title);

				input_dia.attr(
								{
									type:"checkbox",
									style:'width:50px',
									id:index
								}
							  );

				l_container_dia.append(input_dia,s_dia);
			 	d_dia.append(l_title_dia,l_container_dia);


				if(index < 4 ){
					d_coluna1_semana.append(d_dia);
				}else{
					d_coluna2_semana.append(d_dia);
				}

			})

			/*
				recebe a sequencia de dados e atualiza o que está checado e não.
				01000101
			*/
			function atualizaCheckBox(lista){
				void 0;
				var comp = d_sub_form_semana.find('input');
				dias.forEach(function(element,index){
					$(comp[index]).attr('checked',lista[index] == 1 ? true : false);
				});
			}

			d_title_semana.append(s_semana);
			d_sub_form_semana.append(d_title_semana,d_coluna1_semana,d_coluna2_semana);
			d_form_semana.append(d_sub_form_semana);


			
		
        /*
        	Criar Botão Salvar
        */

        	var d_salvar 		= $("<div></div>");
        	var d_btn 			= $("<div></div>");

        	d_salvar 		.addClass('form pl-10 pr-10 mb-20');
        	d_btn 			.addClass('btn btn-100 color-bordo mt-20 color-text-2')
        					.text("AGENDAR");

        	d_salvar.append(d_btn);

        	
	
		    d_salvar.on("click",function(){

		    	void 0;
		    	sendAgendaModulo();
		    		
		    });


	
		/*
			Concatena todas os CheckBox para
		*/
		function concatenaSemana(){
				var string_semana = "";
				var comp = d_sub_form_semana.find('input');
				comp.each(function(index,element){
					string_semana += ($(element).is(":checked"))?"1":"0";
				});
				return  string_semana;
		}
        	

		function sendAgendaModulo(){
			
			//     comp.  liga    deslg  semana   repete
			// AG1  S1    L00:00  D00:00  W0001001    0
			// AG1  S1    L10:45  D11:00  W1111111	  1

			var _central ;
			centrais.forEach(function(el,ind){
			//	console.log(el);
				if(el.desc_modelo.search("RTC") > -1){
					if(centralAgendaSelecionada == el.PK_central){
						_central = el;
						void 0;
					}
			 	}
		   });

			// callback({
			// 										id_central:_id_central,
			// 										ip:_ip,
			// 										ddns:_ddns,
			// 										porta:_porta,
			// 										nome:_nome,
			// 										data:{
			// 												cod:_codigo,
			// 												model:_model,
			// 												prot:((statusAtual == '1')? '0' : '1')+_prot+"!"
			// 											},
			// 									});

			
			var _send = "AG1S";
			var saida  = select_saida.val();

			if(parseInt(saida) < 10){
				saida = "0" + saida;
			}

			_send += saida;
			_send += "L";
			_send += input_ligar.val() || "00:00"
			_send += "D";
			_send += input_desligar.val() || "00:00"
			_send += "W";
			var semana = concatenaSemana();
			_send += semana;

			//0000000
			semana = semana.substr(0,7);
			if(input_ligar.val() == ""){
				self.animation.toast("Precisa INFORMAR a HORA DE LIGAR   : )");
				return false;

			}else if(input_desligar.val() == ""){
				self.animation.toast("Precisa INFORMAR a HORA DE DESLIGAR   : )");
				return false;

			}else if(semana.search('1') < 0){
				self.animation.toast("É necessário SELECIONAR um DIA DA SEMANA   : )");
				void 0;
				return false;
			}

			_send = _send.split(":").join('.')
			

			var response = {
								id_central:_central.PK_central,
								ip: _central.ip_central,
								ddns:_central.ddns_central,
								porta:_central.porta_central,
								nome:_central.ident_central,
								data:{cod:_central.codigo_central,model:_central.desc_modelo,prot:_send+"!"},
								ultimaCentral: centralAgendaSelecionada,
								ultimaSaida: select_saida.val(),
								pause:true,

							 };

			void 0;
			//self.params_.callback(response);

			callback(response);

			return true;
		}


       /**********************
			Mostrar Agendamentos Salvos
		
       ***********************/

	       	var d_form_agendado 		= $("<div></div>");
			var d_sub_form_agendado 	= $("<div></div>");
			var d_title_agendado 		= $("<div></div>");
			var s_agendado 				= $("<span></span>");

			var d_lista_agendado 		= $("<div></div>");
			var u_agendado 				= $("<ul></ul>");


			d_form_agendado 		.addClass('form pt-10 pb-10 pl-10 pr-10 mt-10');
			d_sub_form_agendado 	.addClass('border pb-20 pl-10 pr-10');
			d_title_agendado 		.addClass('title-form');
			s_agendado 				.addClass('title-2 color-text-primary');
			d_lista_agendado		.addClass('lista mt-10');

			s_agendado.text("Eventos Agendados");

			d_form_agendado.attr('id','lista-agendados');  // identificação para atualiza interface

			/*
				 "P11111A1T+2410M0F1G0C1L15D49R00111111000O00U01I00RTCH05:08D02/01/2000S2AG0S1L10:45D17:34W00100001AG1S2L03:20D06:00W01000001AG2S3L14:10D15:27W10000001AG3S4L23:00D01:00W11111101AG4?"
			*/

			atualizaAgendamentos();

			function atualizaAgendamentos(){


				 centrais.forEach(function(el,ind){
						if(el.PK_central == centralAgendaSelecionada){
								d_lista_agendado.html("");
							 	try{
							 		 if(status.length > 0){
							 		 	var inicio = status.search("AG"); 		
							 		 	if(inicio > 0){

							 		 		var element = status.substring(inicio);
							 		 		element = element.split("AG");
							 		 		void 0;

							 		 		element.forEach(function(el2,ind2){
							 		 			if(ind2 > 0 && el2[1] != '?'){
						 		 				
							 		 				//AG0S1L1045D1734W00100001AG1S2L0320D0600W01000001AG2S3L1410D1527W10000001AG3S4L2300D0100W11111101AG4?5L0000D0000W00000000
	
															/*
														    //  lista  comp.  liga    deslg  semana   repete
																AG0     S1    L10:45   D17:34  W0010000   1

																AG1S2L0320D0600W01000001
																AG2S3L1410D1527W10000001
																AG3S4L2300D0100W11111101
																AG4?5L0000D0000W00000000
															*/

																	//0 S1 L1045 D1734 W0010000 1

																	/*
																		Separar bloco do ID da posição dentro da String
																		S19L
																		Return 19
																		
																	 */
																	id_posicao 		= el2.substring(el2.indexOf("S")+1,el2.indexOf("L"));
																	void 0;
											
																	var li 		= $("<li></li>");
																	var p_title = $("<p></p>");
																	var p_dados = $("<p></p>");
																	var d_btn 	= $('<div></div>');
																	var img 	= $("<img></img>");
																	var info = "";

																	
																	p_title
																			.addClass('title-2 inline-b mr-10')
																			.text("Saida");
																			//.text(self.lista_saidas[parseInt(el2[2])]);

																			(el.comandos).forEach(function(elem,inde){
																				if(elem.FK_tipo_componente == 3){
																				//	if(elem.pos_comando_modelo == el2[2]){
																					if(elem.pos_comando_modelo == id_posicao){
																						p_title.text(elem.desc_comando_modelo);
																					}
																				}

																			});
																			

																	 var hora_liga_agenda, hora_desliga_agenda;

																	 hora_liga_agenda 		= el2.substring(el2.indexOf("L")+1,el2.indexOf("D"));
																	 hora_desliga_agenda 	= el2.substring(el2.indexOf("D")+1,el2.indexOf("W"));
																	

																	 info += "Lig ("+hora_liga_agenda+") - ";
																	 info += "Des ("+hora_desliga_agenda+")";

																	 var W = el2.substring(el2.indexOf("W")+1);
																	 info += atualizaTextoSemana(W);


																	 //	console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
																	// 	console.log(el2.substr(el2.indexOf("S") + 1,1) +" == "+ saidaSelecionada);

																	 if(ind2 % 2){
																		li.css({'background':'#f4f7f7'});
																	 } 
																	 	
																	if(el2.substr(el2.indexOf("S") + 1,1) == saidaSelecionada){
																		
																		li.css({'background':'#af2f2f '});
																	}

																	 
																	p_dados
																			.addClass('title-2 nobold color-text-7 inline-b desc-agenda no-lsp')
																			.html(info);

																	 img	
																	 	.attr('src','../img/icons/system/ic_delete_black_36dp.png');

																	  d_btn
																	  		.addClass('btn icon')
																	 		.append(img)
																	 	 	.attr('id',(ind2-1));
																	 li		
																	 	.append(p_title,p_dados,d_btn);

																

																		d_btn.on("click",function(){
																			void 0;

																			//self.disparaRequest("EXCLUIR"+$(this).attr('id'));
																			//$(this).parent().remove();

																			 
																			choiceCallbackExcluir($(this).attr('id'));
																			

																		 })

																	d_lista_agendado.append(li);
							 		 			}
							 		 		});
							 		 	}
							 		 }

							 	}catch(e){
							 		void 0;
							 	}
						 }
				 });

			}


			function choiceCallbackExcluir(reg){
				void 0;
				if(parseInt(reg) < 10){
					 reg = "0" + reg;
				 }
				 
			 	var params_dialog = {
								mensagem:'Confirma a <b><font color="red">Exclusão</font></b> do Agendamento ?',
								style:{'text-align':'left'},
								callbackDialog:function(result){
									callbackDialog(result);
								}
  							};


					self.templateMensagemConfirmacao(params_dialog);
		
					function callbackDialog(result){

						
						if(result){
								var _central ;
								centrais.forEach(function(el,ind){
								//	console.log(el);
									if(el.desc_modelo.search("RTC") > -1){
										if(centralAgendaSelecionada == el.PK_central){
											_central = el;
											void 0;
										}
								 	}
							   });

								var resp = "EXC_AG"+reg;

							var response = {
												id_central:_central.PK_central,
												ip: _central.ip_central,
												ddns:_central.ddns_central,
												porta:_central.porta_central,
												nome:_central.ident_central,
												data:{cod:_central.codigo_central,model:_central.desc_modelo,prot:resp+"!"},
												pause:true,
												ultimaCentral: centralAgendaSelecionada,
												ultimaSaida: select_saida.val(),

											 };

							void 0;
							callback(response);
																
						}
					}
			 }


			/*	
				recebe a sequencia de dados e retorna o texto com os valores da Semana
				100100011
				Dom-Seg-Ter-Qua-Qui-Sex-Sab-Repetir
			*/
			function atualizaTextoSemana(semana){

				//console.log(semana);
				var inicio = 0;
				var texto = "<br>";
				
					texto += (semana[inicio++] == 1) ? "Dom-" : "";
					texto += (semana[inicio++] == 1) ? "Seg-" : "";
					texto += (semana[inicio++] == 1) ? "Ter-" : "";
					texto += (semana[inicio++] == 1) ? "Qua-" : "";
					texto += (semana[inicio++] == 1) ? "Qui-" : "";
					texto += (semana[inicio++] == 1) ? "Sex-" : "";
					texto += (semana[inicio++] == 1) ? "Sab-" : "";
					texto += (semana[inicio++] == 1) ? "Rep." : "";

				return texto;
			}

			d_title_agendado.append(s_agendado);
			d_sub_form_agendado.append(d_title_agendado,d_lista_agendado);
			d_form_agendado.append(d_sub_form_agendado);
		

			d_agendador.append(d_form_modulo);
			d_agendador.append(d_form_eventos);
			d_agendador.append(d_form_semana);
			d_agendador.append(d_salvar);
			d_agendador.append(d_form_agendado);

		   $(".lista-componentes").html(d_agendador);

return true;			    

}

/*

   Layout para mensagens de confirmação.
   {callback, mensagem, style}
*/

cemf.js.Element.prototype.templateMensagemConfirmacao = function(params){
	var list = this;

	list.animation.animaControlFloat(false,false);		

	var div_fundo		= $('<div></div>');
	var div 			= $('<div></div>');
	
	var p 				= $('<p></p>');
	var span_conf 		= $('<span></span>');
	var span_canc 		= $('<span></span>');

	div_fundo.css({'position':'absolute','top':'0px','width':'100%','height':'120%'});

	

	div_fundo.addClass('fundo-add-setores');
	div.addClass('excluir-agendamento shadow-bottom-z-4');
	p.html(params.mensagem);
	try{
		div.css(params.css);
	}catch(e){
		void 0;
	}
	
	span_conf.addClass('right font-size-2');
	span_conf.attr('id','add-setor');
	span_conf.text("Confirmar");

	span_canc.addClass('right font-size-2');
	span_canc.text("Cancelar");
	span_canc.css({'margin-right':'20px','color':'#787878'});

	if(params.hasOwnProperty('style'))
					 div.css(params.style);



	var action_confirmar = {
			click: function(event){
				
				$(div_fundo).remove();
				$(div).remove();
				params.callbackDialog(true);
				
			}
		
	}

	var action_cancelar = {
						click:function(){
							
							$(div_fundo).remove();
							$(div).remove();
							params.callbackDialog(false);
							
						}
	}
	
	$(span_conf).on(action_confirmar);
	$(span_canc).on(action_cancelar);
	$(div_fundo).on(action_cancelar);

	div.append(p);
	div.append(span_conf);
	div.append(span_canc);

	
	
	$('.area-controle').append(div_fundo);
	$('.area-controle').append(div);


	
}



/*
CryptoJS v3.1.2
code.google.com/p/crypto-js
(c) 2009-2013 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
var CryptoJS=CryptoJS||function(s,p){var m={},l=m.lib={},n=function(){},r=l.Base={extend:function(b){n.prototype=this;var h=new n;b&&h.mixIn(b);h.hasOwnProperty("init")||(h.init=function(){h.$super.init.apply(this,arguments)});h.init.prototype=h;h.$super=this;return h},create:function(){var b=this.extend();b.init.apply(b,arguments);return b},init:function(){},mixIn:function(b){for(var h in b)b.hasOwnProperty(h)&&(this[h]=b[h]);b.hasOwnProperty("toString")&&(this.toString=b.toString)},clone:function(){return this.init.prototype.extend(this)}},
q=l.WordArray=r.extend({init:function(b,h){b=this.words=b||[];this.sigBytes=h!=p?h:4*b.length},toString:function(b){return(b||t).stringify(this)},concat:function(b){var h=this.words,a=b.words,j=this.sigBytes;b=b.sigBytes;this.clamp();if(j%4)for(var g=0;g<b;g++)h[j+g>>>2]|=(a[g>>>2]>>>24-8*(g%4)&255)<<24-8*((j+g)%4);else if(65535<a.length)for(g=0;g<b;g+=4)h[j+g>>>2]=a[g>>>2];else h.push.apply(h,a);this.sigBytes+=b;return this},clamp:function(){var b=this.words,h=this.sigBytes;b[h>>>2]&=4294967295<<
32-8*(h%4);b.length=s.ceil(h/4)},clone:function(){var b=r.clone.call(this);b.words=this.words.slice(0);return b},random:function(b){for(var h=[],a=0;a<b;a+=4)h.push(4294967296*s.random()|0);return new q.init(h,b)}}),v=m.enc={},t=v.Hex={stringify:function(b){var a=b.words;b=b.sigBytes;for(var g=[],j=0;j<b;j++){var k=a[j>>>2]>>>24-8*(j%4)&255;g.push((k>>>4).toString(16));g.push((k&15).toString(16))}return g.join("")},parse:function(b){for(var a=b.length,g=[],j=0;j<a;j+=2)g[j>>>3]|=parseInt(b.substr(j,
2),16)<<24-4*(j%8);return new q.init(g,a/2)}},a=v.Latin1={stringify:function(b){var a=b.words;b=b.sigBytes;for(var g=[],j=0;j<b;j++)g.push(String.fromCharCode(a[j>>>2]>>>24-8*(j%4)&255));return g.join("")},parse:function(b){for(var a=b.length,g=[],j=0;j<a;j++)g[j>>>2]|=(b.charCodeAt(j)&255)<<24-8*(j%4);return new q.init(g,a)}},u=v.Utf8={stringify:function(b){try{return decodeURIComponent(escape(a.stringify(b)))}catch(g){throw Error("Malformed UTF-8 data");}},parse:function(b){return a.parse(unescape(encodeURIComponent(b)))}},
g=l.BufferedBlockAlgorithm=r.extend({reset:function(){this._data=new q.init;this._nDataBytes=0},_append:function(b){"string"==typeof b&&(b=u.parse(b));this._data.concat(b);this._nDataBytes+=b.sigBytes},_process:function(b){var a=this._data,g=a.words,j=a.sigBytes,k=this.blockSize,m=j/(4*k),m=b?s.ceil(m):s.max((m|0)-this._minBufferSize,0);b=m*k;j=s.min(4*b,j);if(b){for(var l=0;l<b;l+=k)this._doProcessBlock(g,l);l=g.splice(0,b);a.sigBytes-=j}return new q.init(l,j)},clone:function(){var b=r.clone.call(this);
b._data=this._data.clone();return b},_minBufferSize:0});l.Hasher=g.extend({cfg:r.extend(),init:function(b){this.cfg=this.cfg.extend(b);this.reset()},reset:function(){g.reset.call(this);this._doReset()},update:function(b){this._append(b);this._process();return this},finalize:function(b){b&&this._append(b);return this._doFinalize()},blockSize:16,_createHelper:function(b){return function(a,g){return(new b.init(g)).finalize(a)}},_createHmacHelper:function(b){return function(a,g){return(new k.HMAC.init(b,
g)).finalize(a)}}});var k=m.algo={};return m}(Math);
(function(s){function p(a,k,b,h,l,j,m){a=a+(k&b|~k&h)+l+m;return(a<<j|a>>>32-j)+k}function m(a,k,b,h,l,j,m){a=a+(k&h|b&~h)+l+m;return(a<<j|a>>>32-j)+k}function l(a,k,b,h,l,j,m){a=a+(k^b^h)+l+m;return(a<<j|a>>>32-j)+k}function n(a,k,b,h,l,j,m){a=a+(b^(k|~h))+l+m;return(a<<j|a>>>32-j)+k}for(var r=CryptoJS,q=r.lib,v=q.WordArray,t=q.Hasher,q=r.algo,a=[],u=0;64>u;u++)a[u]=4294967296*s.abs(s.sin(u+1))|0;q=q.MD5=t.extend({_doReset:function(){this._hash=new v.init([1732584193,4023233417,2562383102,271733878])},
_doProcessBlock:function(g,k){for(var b=0;16>b;b++){var h=k+b,w=g[h];g[h]=(w<<8|w>>>24)&16711935|(w<<24|w>>>8)&4278255360}var b=this._hash.words,h=g[k+0],w=g[k+1],j=g[k+2],q=g[k+3],r=g[k+4],s=g[k+5],t=g[k+6],u=g[k+7],v=g[k+8],x=g[k+9],y=g[k+10],z=g[k+11],A=g[k+12],B=g[k+13],C=g[k+14],D=g[k+15],c=b[0],d=b[1],e=b[2],f=b[3],c=p(c,d,e,f,h,7,a[0]),f=p(f,c,d,e,w,12,a[1]),e=p(e,f,c,d,j,17,a[2]),d=p(d,e,f,c,q,22,a[3]),c=p(c,d,e,f,r,7,a[4]),f=p(f,c,d,e,s,12,a[5]),e=p(e,f,c,d,t,17,a[6]),d=p(d,e,f,c,u,22,a[7]),
c=p(c,d,e,f,v,7,a[8]),f=p(f,c,d,e,x,12,a[9]),e=p(e,f,c,d,y,17,a[10]),d=p(d,e,f,c,z,22,a[11]),c=p(c,d,e,f,A,7,a[12]),f=p(f,c,d,e,B,12,a[13]),e=p(e,f,c,d,C,17,a[14]),d=p(d,e,f,c,D,22,a[15]),c=m(c,d,e,f,w,5,a[16]),f=m(f,c,d,e,t,9,a[17]),e=m(e,f,c,d,z,14,a[18]),d=m(d,e,f,c,h,20,a[19]),c=m(c,d,e,f,s,5,a[20]),f=m(f,c,d,e,y,9,a[21]),e=m(e,f,c,d,D,14,a[22]),d=m(d,e,f,c,r,20,a[23]),c=m(c,d,e,f,x,5,a[24]),f=m(f,c,d,e,C,9,a[25]),e=m(e,f,c,d,q,14,a[26]),d=m(d,e,f,c,v,20,a[27]),c=m(c,d,e,f,B,5,a[28]),f=m(f,c,
d,e,j,9,a[29]),e=m(e,f,c,d,u,14,a[30]),d=m(d,e,f,c,A,20,a[31]),c=l(c,d,e,f,s,4,a[32]),f=l(f,c,d,e,v,11,a[33]),e=l(e,f,c,d,z,16,a[34]),d=l(d,e,f,c,C,23,a[35]),c=l(c,d,e,f,w,4,a[36]),f=l(f,c,d,e,r,11,a[37]),e=l(e,f,c,d,u,16,a[38]),d=l(d,e,f,c,y,23,a[39]),c=l(c,d,e,f,B,4,a[40]),f=l(f,c,d,e,h,11,a[41]),e=l(e,f,c,d,q,16,a[42]),d=l(d,e,f,c,t,23,a[43]),c=l(c,d,e,f,x,4,a[44]),f=l(f,c,d,e,A,11,a[45]),e=l(e,f,c,d,D,16,a[46]),d=l(d,e,f,c,j,23,a[47]),c=n(c,d,e,f,h,6,a[48]),f=n(f,c,d,e,u,10,a[49]),e=n(e,f,c,d,
C,15,a[50]),d=n(d,e,f,c,s,21,a[51]),c=n(c,d,e,f,A,6,a[52]),f=n(f,c,d,e,q,10,a[53]),e=n(e,f,c,d,y,15,a[54]),d=n(d,e,f,c,w,21,a[55]),c=n(c,d,e,f,v,6,a[56]),f=n(f,c,d,e,D,10,a[57]),e=n(e,f,c,d,t,15,a[58]),d=n(d,e,f,c,B,21,a[59]),c=n(c,d,e,f,r,6,a[60]),f=n(f,c,d,e,z,10,a[61]),e=n(e,f,c,d,j,15,a[62]),d=n(d,e,f,c,x,21,a[63]);b[0]=b[0]+c|0;b[1]=b[1]+d|0;b[2]=b[2]+e|0;b[3]=b[3]+f|0},_doFinalize:function(){var a=this._data,k=a.words,b=8*this._nDataBytes,h=8*a.sigBytes;k[h>>>5]|=128<<24-h%32;var l=s.floor(b/
4294967296);k[(h+64>>>9<<4)+15]=(l<<8|l>>>24)&16711935|(l<<24|l>>>8)&4278255360;k[(h+64>>>9<<4)+14]=(b<<8|b>>>24)&16711935|(b<<24|b>>>8)&4278255360;a.sigBytes=4*(k.length+1);this._process();a=this._hash;k=a.words;for(b=0;4>b;b++)h=k[b],k[b]=(h<<8|h>>>24)&16711935|(h<<24|h>>>8)&4278255360;return a},clone:function(){var a=t.clone.call(this);a._hash=this._hash.clone();return a}});r.MD5=t._createHelper(q);r.HmacMD5=t._createHmacHelper(q)})(Math);
void 0;
'use strick';

var cemf =  cemf || {
  js: {}
};

cemf.js.TemplatePage = function(){}

/*
	Recebe a instancia da comunicação
*/
cemf.js.TemplatePage.prototype.connection = null;

cemf.js.TemplatePage.prototype.element = null;

cemf.js.TemplatePage.prototype.dados = null;

cemf.js.TemplatePage.prototype.ferramentas = null;

cemf.js.TemplatePage.prototype.animation = null;

//cemf.js.TemplatePage.prototype.setorAtualSelecionado = null;

/*
   Tipo de Menu que foi selecionado
*/
cemf.js.TemplatePage.prototype.menuSelected = null;

/*
    Armazena o tamanho da tela width e heigth
*/
cemf.js.TemplatePage.prototype.screen = null


// Recebe o objeto Loading
cemf.js.TemplatePage.prototype.loading = null;

/*
  Variavel que controla quanto o acesso será externo ou interno
*/
cemf.js.TemplatePage.prototype.acesso_externo = false;

/*
   Ativa e Pausa frequencia de sincronização das Centrais
*/
cemf.js.TemplatePage.prototype.sincronizaCentrais = true;
/*
  	Tempo que a central deverá sincronizar com as Centrais
*/
cemf.js.TemplatePage.prototype.tempoSincronizaCentrais = 10000;

/*
   Quando existe uma noticia abaixo de 10 publicada, é colocada a palavra NEW no item do menu Panel.
*/
cemf.js.TemplatePage.prototype.data_limite_mostra_new = 5;


/*
	Identifica o Libraries_user selecionado para Alterar ou incluir novo
*/
cemf.js.TemplatePage.prototype.libraries_user_selecionado = null;

// cemf.js.TemplatePage.prototype.getMessageError = function(){
	
// };

cemf.js.TemplatePage.prototype.load_libraries = null;

//cemf.js.TemplatePage.prototype.PK_usuario = null;


cemf.js.TemplatePage.prototype.centralSelecionada = null;

/*
   informa o caminho onde encontra-se o script personalizado para o usuario
*/
cemf.js.TemplatePage.prototype.path_person = null;

/*
   Se plano 
    1 - FREE
    2 - STANDAR
    3 - PREMIUM
    4 - INTEGRADOR
*/

cemf.js.TemplatePage.prototype.isPlanoPremium = function(){
		var self = this;
		var plano = self.dados.get('usuario')[0].FK_tipo_plano;
		return (plano == 3 || plano == 4 || plano == 6)? true : false;
}

cemf.js.TemplatePage.prototype.isIntegrador = function(){
		var self = this;
		var plano = self.dados.get('usuario')[0].FK_tipo_plano;
		return (plano == 4)? true : false;
}

cemf.js.TemplatePage.prototype.isCliente = function(){
		var self = this;
		var plano = self.dados.get('usuario')[0].FK_tipo_plano;
		return (plano == 2)? true : false;
}

cemf.js.TemplatePage.prototype.perfilUsuario = function(){
		var self = this;
		var usuario = self.dados.get('usuario')[0];
		return usuario;
}


var count = 0;




cemf.js.TemplatePage.prototype.createLoading = function (msg){
	void 0;

	ul			= $("<ul></ul>")
	container  	= $("<div></div>");
	circle  	= $("<div></div>");
	msg     	= $("<div></div>");

	container.addClass('loading');
	circle.addClass('circle-2');
	msg.addClass('msg-dialog');

	container.append(circle);
	ul.append(container);
	ul.append(msg);
	ul.addClass('loading'); //shadow-bottom-z-4

	
	return ul;
}

cemf.js.TemplatePage.prototype.removeLoading = function (msg){
	void 0;

	if(this.loading != null){
		
		(this.loading).find('.loading').remove();
		
	}

}

cemf.js.TemplatePage.prototype.atualizaListaSetores= function(dados){
	void 0;

		dados = dados || null;

		//console.log(dados);
		
		 var conn = this;
			conn.loading = $('.painel-lista .lista-setores');

			//console.log(conn.dados);

			if(dados == null){

					// conn.animation.animaControlFloat(false,true);
			  //  		conn.animation.removeFundoModal();
				 //    conn.element.idConfigElementSelected = null;
				 //   	conn.menuBar();   
				 //   	conn.sincronizaCentrais = true;

				 (conn.connection)
				 				.execute((conn.connection).server('dados'),{acao:'dados_usuario'},this)
						  		.done(function(data){
									//console.log('--> Done');
									if(data.hasOwnProperty('resposta')){
										 
										 	var msg = data.resposta;
											
											conn.sincronizaCentrais = true;

									 	   if(msg.hasOwnProperty('error')){
									 	   		switch(msg.error){
									 	   			case 201://centrais
									 	   				//menu.startCentralConfig();
		   												//menu.configCentralAdicionar();
		   												 conn.sincronizaCentrais = false;
									 	   			break;
									 	   		}
									 		}
										
										//_module_.replace(data.resposta);
										
										conn.dados.replace(data.resposta);


										if(data.resposta.hasOwnProperty('news')){
											var news = data.resposta.news;
											var date = new Date();
									  		var hoje = (date.getFullYear()) +'-' +(date.getMonth()+1)+'-' + (date.getDate());
									  		news.forEach(function(element,index){
									  				
									  				if(conn.comparaData(hoje,element.data_news) < conn.data_limite_mostra_new ){
									 						$('#'+element.desc_tipo_news)
									 								.find('p')
									 								.addClass('new')
									 								.css('font-weight','bold');
									 				}	
									  		});

										}
										conn.carregaNews('Novidade');
									  	
									 			/*
									 			   Faz o Calculo das datas e retorna o valor em dias
									 			   86400000 é a quantidade de millisegundos em 1 dia.
									 			*/

									 			
																									
										var params = {
											tiposModoMenu : conn.menuSelected,
											element: $('.painel-lista .lista-setores'),
											dados: conn.dados,
											callback:function(dadosSetor){
												choiceCallbackSetorItem(dadosSetor);
											}

										};
										jQuery.extend(params,conn.globalCallback());

										conn.element.loadSetor(params);
										conn.assync();

										void 0;

										 var img = $('<img></img>');
										 $('#plano').html(img); 
									 
   									    if(conn.isIntegrador()){
											img.attr('src','../img/icons/system/ic_engineer_16dp.png');
											conn.personalizandoAreadeTrabalho();
										}else if(conn.isPlanoPremium()){
											img.attr('src','../img/icons/system/ic_crown_color_16dp.png');
										}else if(conn.isCliente()){
											img.attr('src','../img/icons/system/ic_person_white_18dp.png');
											//$('#Download').remove();
										}


										/* Verifica se existe um registro de localização*/

										
										if(conn.perfilUsuario().latitude_usuario.length <= 5){
											// var params_geo = {
											// 		callbackGeo:function(position){
											// 			callbackOptionGeo(position);
											// 		}
											// 	}
											// conn.animation.geoLocation(params_geo.callbackGeo);
											void 0;
										}
										
									}else{
										void 0;
									}
								});
				
		    }else{

		    				var params = {
											tiposModoMenu : null,
											element: $('.painel-lista .lista-setores'),
											dados: dados,
											callback:function(dadosSetor){
												choiceCallbackSetorItem(dadosSetor);
											},
										};

										jQuery.extend(params,conn.globalCallback());
										conn.element.loadSetor(params);
										 
		    }

		   


	function choiceCallbackSetorItem(dadosSetor){
		void 0;
		$('#title-setor').html(dadosSetor.nome_setor);
		conn.sincronizaCentrais = true;
	}

	function callbackOptionGeo(position){
			void 0;
			latitude = position.coords.latitude;
			longitude = position.coords.longitude;

			if(position.hasOwnProperty('coords')){

				    start.loading = null;
				 	start.connection
							.execute(
										(start.connection).server('dados'),
											{
												acao:'location',
												latitude:latitude,
												longitude:longitude
											},start).done(function(data){
													void 0;
													
												});
			}else{
				void 0
			}
		}

	function handle_error(err){
    			void 0;

    			/*
    			   PERMISSION_DENIED (1)
    			   POSITION_UNAVAILABLE(2)
    			   TIMEOUT (3)
    			*/

  			if (err.code == 1) {
			    	self.toast("Autorize mostrar sua Localização para controle de proximidade, BETA");
			  }

    	}

}




/*
	Carregando Script personalizado do usuário
*/
cemf.js.TemplatePage.prototype.personalizandoAreadeTrabalho = function(){
	void 0;
	var self = this;

	if(self.path_person != null)
		 return;

			self.path_person = "../js/personalize/"+self.perfilUsuario().PK_usuario+"/script_person.js";
			
				
					$.ajax({
					    		url:self.path_person,
					    		type:'HEAD',
					    		success: function() {
					        		include(self.path_person);
					    		},
					    		error: function() {
					        		void 0;
					        	},
					        	
					 });

				
	
	function include(file_path) {
		var j = document.createElement("script"),
		head = document.getElementsByTagName('head')[0]

		j.setAttribute('type', "text/javascript")
		j.setAttribute('src', file_path)
		head.insertBefore(j,head.firstChild);
	}

	
}



cemf.js.TemplatePage.prototype.menuBar = function(){
		void 0;

	menu = this;

  		var menus = [
  					'Setor',
  					'Módulo',
  					'Componente',
  					'Biblioteca IR',
  					'Agendamento'
  					];

  		var icons_menu = [
  							"../img/icons/system/ic_dns_black_24dp.png",
  							"../img/icons/system/ic_router_black_24dp.png",
  							"../img/icons/system/ic_cursor_black_24dp.png",
  							"../img/icons/system/ic_technology_controle_black_24dp.png",
  							"../img/icons/system/ic_date_range_black_24dp.png"
  						];

  		var classes = {
  			menu_bar : 'menu-bar',
  			icons    : 'btn-icon',
  			menuCard : 'options',
  			right    : 'right',
  			elevation: 'shadow-bottom-z-3',
  			none     : 'none',
  			color	 : 'color-primary',
  			font 	 : 'font-size-2',
  			esconde  : 'esconde-panel'

  		};

  		var imgs = {
  			ic_menu : "../img/icons/system/ic_menu_white_18dp.png",
  			ic_vert : "../img/icons/system/ic_more_vert_white_36dp.png"
  			
  		};

  		var ids = {
  			id_menu  : 'menu-bar',
  			id_title : 'title-setor',
  			id_vert  : 'vert-menu-bar',
  			id_options : 'list-menu-bar'
  			
  		}

  		var params = {
  				menu : menus,
  				id   : ids,
  				img : imgs,
  				classe : classes,
  				icon: icons_menu,
  				callbackMenuBarOptions: function(selectedItem) {
					        choiceCallbackOptions(selectedItem);
				},
				animation:menu.animation
  		};

  		
  		menu.ferramentas = new cemf.js.Ferramentas(params);
   		menu.ferramentas.createMenuBarDefault();

  
  		function choiceCallbackOptions(selectedItem){
		   void 0;
		   menu.menuSelected = selectedItem;

		  menu.sincronizaCentrais = false;
		   if(selectedItem == 0){	// Setor
		   				menu.startSetorConfig();
		   				menu.loadSetoresConfig();
		   	}else if(selectedItem == 1){ // Central
		   				menu.startCentralConfig();
		   				menu.loadCentralConfig();
		   	}else if(selectedItem == 2){ // Componente
		   				//console.log(menu.element.idElementSelected);
		   				// if(menu.dados.get('central').length > 0){
			   				
			   			// }else{
			   			// 	menu.animation.toast("Precisa existir um Módulo Cadastrada");
			   			// }

			   			if(menu.element.idElementSelected == null){
			   				menu.animation.toast("Precisa selecionar um Setor");
			   			}else{
			   					menu.startComponentesConfig();
			   			}

		   	}else if(selectedItem == 3){ // Biblioteca IR
		   						   				
			   			//menu.animation.toast("Em construção");
			   			menu.startBibliotecaConfig();
			   			menu.loadLibConfig();
			   			
			   			
		   	}else if(selectedItem == 4){ //Agendamento
				   //menu.animation.toast("Em construção");
				   var libera = false;
				   menu.dados.get('central').forEach(function(element, index){
						void 0;
						if(element.desc_modelo.search("RTC") > -1){
							libera = true;
						}
				   })

				   if(libera){
						menu.startAgendamentoConfig();
		   		 		menu.loadAgendamentoConfig();
				   }else{
						menu.animation.toast("Função Ativa apenas para Módulos RTC");
				   }
		   		
		   	}
	  	}
	  	

}

/*
   Grupo de Funções de Callback globais para Enviar e Manipular mensagens com Arduno
*/
cemf.js.TemplatePage.prototype.globalCallback = function(){
	var call = this;
	return  {
				callbackRequest: function(response){
					call.choiceCallbackRequest(response);
			}
	}
}

/*
   callback para Resposta do click dos controles.
*/
cemf.js.TemplatePage.prototype.choiceCallbackRequest = function(response){
    void 0;
    var choice = this;
    
    if(response.pause){
    	choice.sincronizaCentrais = false;	
    }

    response.acesso = choice.acesso_externo;
    (choice.connection)
						.request(response,choice)
						.done(function(data){
							//console.log("Done");
							
							// Atualiza os dados de Status de retorno na Central 
							if(data.hasOwnProperty("status")){
								//console.log("Atualizando dados do Status");
								var central = choice.dados.search({obj:'central',PK_central:response.id_central});
								if(central != undefined && central){
									central.data = data;
									jQuery.extend(response,data);
									//choice.element.loadComponente(choice.element.componentesCarregados,choice.globalCallback().callbackRequest);
									void 0;

									if($('.agendador').length > 0){
										choice.element.loadMyAgendamento({ultimaCentral:response.ultimaCentral,ultimaSaida:response.ultimaSaida},choice.globalCallback().callbackRequest);
									}
									choice.atualizaStatusComponentesCentral(response);

								}
							}
							//console.log(central);
						});
}


/*
   Atualiza o Status dos Componentes que estão na TEla.
   Protocolo de Retorno de cada modelo.
 *****************************
 *  SB_08  -> P0000A0T+3243M1F0G0C01L00D20R00000000
 *   PIR    ALARME  TEMP    MONIT.  FOGO  GAS  CHUVA/RELE  LDR   DISPARO       RELES
 *   P0000    A0    T+3243   M1      F0   G0    C0    1    L20     D00       R00000000

	Reles -> 	0 - desligado
				1 - Ligado
				2 - Desligado Automatico
				3 - Ligado Automatico

 *****************************
 *  PRELI5  -> R00000L20D30
 *   Reles  LDR DISPARO
 *   R00000 L20   D30
 * 
 * 	//   012345 67 890123 45 67890 12 345 678 901 234								
	 /" "P00000 A1 T+0000 M1 F0111 G1 C10 O00 U10 I00""}
 


*/
cemf.js.TemplatePage.prototype.atualizaStatusComponentesCentral = function(response){
	var self = this;
	void 0;
	//console.log(response);

	var elementos = $('.lista-componentes li');
	
	elementos.each(function(index, element){
		
		try{
				if(self.element.componentesCarregados[index].FK_central == response.id_central){					

					  var comp  = self.element.componentesCarregados[index].prot_componente; 
					  var letra = comp.charAt(comp.length - 1);
					  var posicao = parseInt(self.element.componentesCarregados[index].pos_componente);

					 
					 	var valor = (response.status).charAt((response.status).indexOf(letra) + posicao + 1);
						//console.log("===============================" + letra);
					 	if(letra == 'R'){
						 	void 0;
						 	switch(valor){
						 		case '0':
						 				($(element).find('input')).prop('checked',false);
						 				($(element).find('small')).fadeOut('fast',function(){
						 					($(element).find('.switch')).fadeIn('slow');
						 					$(element).css('background','transparent');
						 				});
						 		break;
						 		case '1':
						 				($(element).find('input')).prop('checked',true);
						 				($(element).find('small')).fadeOut('fast',function(){
						 					($(element).find('.switch')).fadeIn('slow');
						 					 $(element).css('background','transparent');
						 				});
						 		break;
						 		case '2':
						 				($(element).find('.switch')).fadeOut('fast',function(){
						 					($(element).find('small')).fadeIn('slow');
						 					$(element).css('background','transparent');
						 				});
						 		break;
						 		case '3':
						 				($(element).find('.switch')).fadeOut('fast',function(){
						 					($(element).find('small')).fadeIn('slow');
						 					$(element).css('background','#f4efb6');
						 				});
						 		break;
						 	}
						}
						else if(letra == 'A' || letra == 'M' || letra == 'U' || letra == 'I' || letra == 'O' || letra == 'C'){

						    //  012345 67 890123 45 67890 12 345 678 901 234								
							// "P00000 A1 T+0000 M1 F0111 G1 C10 O00 U10 I00""}

						}
						else{
							 if(letra == 'A'){
								 void 0;
								 void 0;
							 }
						 	 if(response.status[parseInt(self.element.componentesCarregados[index].pos_componente)] == '1'){
						 		($(element).find('input')).prop('checked',true);	
							 }else{
							 	($(element).find('input')).prop('checked',false);
							 }

						}
				}

			}catch(e){
				void 0;
			}
	});

}

/*
   dispara Request a todas as Centrais Cadastradas e ativas.
*/
cemf.js.TemplatePage.prototype.disparaRequest = function(){
	var dispara = this;
	//console.log("PK Setor Selecionado " +dispara.element.idElementSelected);
	
	if(dispara.sincronizaCentrais){
		dispara.dados.get('central').forEach(function(element, index){
			if(element.habilita_central == 1){
				var response = {
								id_central:element.PK_central,
								ip: element.ip_central,
								ddns:element.ddns_central,
								porta:element.porta_central,
								acesso:dispara.acesso_externo,
								nome:element.ident_central,
								data:{cod:element.codigo_central,model:element.desc_modelo,prot:element.protdados_modelo+"!"}
							 };
				//console.log(element.ip_central+":"+element.porta_central);

				(dispara.connection)
								.request(response,dispara)
								.done(function(data){
																			
									if(data.hasOwnProperty("status")){
											
											if(dispara.sincronizaCentrais){

												var atual;
												var anterior;

												try{
												    	anterior = $.trim(data.status);
												    	atual = $.trim((element.data).status);

												}catch(e){
													void 0;
													atual = "";
												}
												// console.log(atual);
												// console.log(anterior);
												// console.log(atual.localeCompare(anterior));

												if(atual.localeCompare(anterior)){
														element.data = new Object();
														element.data.status = anterior;
														//dispara.element.dados_obj = dispara.dados;
														//console.log(dispara.element);

														if(dispara.element.idElementSelected != null){
															dispara.element.loadComponente(dispara.element.componentesCarregados,dispara.globalCallback().callbackRequest);
														}else{
															void 0;
														}
												}
											}else{
												void 0;
											}


									}
									//console.log(element);

								});
			}else{
				//console.log("Módulo "+element.ident_central+" Desativado");
			}
		});
	}else{
		void 0;
	}

}
			
/*
   dispara Interval para Atualizar
*/
cemf.js.TemplatePage.prototype.assync = function(){
	var self = this;

	var intervalID = 0;

	var myfunction = function(){
				self.disparaRequest();
	};

	var repeat = function(ms,func){

						intervalID = setInterval(func, ms);
				    	self.disparaRequest();
	};

	

	repeat(self.tempoSincronizaCentrais, myfunction);

}

/*
var intervalID = 0;
var wait = 
			ms =>  new Promise(	r => setTimeout(r, ms));



	var repeat = 
			(ms, func) => new Promise(
	    		r => (
	        			intervalID = setInterval(func, ms),
	            		wait(ms).then(r)
	        )
	    );

	

	var myfunction = 
			() => new Promise(
	  			r => r(	console.log('repeating...'))
	  	);

	var stopAfter5Secs = 
			() => new Promise(
	  			r => r(setTimeout(
	        					() => { 
	                  		if(cancel) clearInterval(intervalID);
	                      console.log('repeat end') 
	                   } , 8000))
	  	);

	repeat(1000, () => Promise.all([myfunction()]))
	.then(stopAfter5Secs())  // starts timer to end repetitions
	.then(console.log('repeat start')); // informs that all actions were started correctly and we are waiting for them to finish
*/



/*************************************************

   Start Biblioteca IR

***************************************************/
/*
    Carrega Menu Bar Libraries
*/


cemf.js.TemplatePage.prototype.startBibliotecaConfig = function(){
	void 0;
	var self = this;

		var classes = {
  			menu_bar : 'menu-bar',
  			icons    : 'btn-icon',
  			color 	 : 'color-bar-5',
  			font 	 : 'font-size-2',
  			color_text: 'color-text-icons'
  		};

  		var imgs = {
  			ic_back : "../img/icons/system/ic_arrow_back_white_18dp.png",
  			ic_lib  : "../img/icons/system/ic_library_books_white_36dp.png",
  			ic_add  : "../img/icons/system/ic_add_circle_outline_white_18dp.png",
  			ic_save : "../img/icons/system/ic_done_white_36dp.png",
  			ic_control : "../img/icons/system/ic_technology_controle_white_24dp.png",
  			ic_share : "../img/icons/system/ic_share_white_36dp.png"
  		};

  		var params = {
  				//id   : ids,
  				img : imgs,
  				classe : classes,
  				callback: function(selectedItem) {
					        choiceCallback(selectedItem);
				},
				callbackAdd: function(selectItem){
							choiceCallbackAdd(selectItem);
				},
				callbackLib: function(selectItem){
							choiceCallbackLib(selectItem);
				},
				callbackSave: function(selectItem){
							choiceCallbackSave(selectItem);
				},
				callbackShare: function(selectItem){
							choiceCallbackShare(selectItem);
				}
				
  		};


  		self.ferramentas.createMenuBarLibraries(params);

  		function choiceCallback(naoSalvaLista){
  			void 0;
  			
  				if($('.frame-valida-central').length > 0){
  				   self.configCentralAdicionar(null);

				}else if($('.add-setores').length > 0){
  				   	$('.add-setores').remove();
				   	$('.fundo-add-setores').remove();

				}else if($('.etapas').is(':visible')){
						$('.etapas').fadeOut('slow');
				}else if($('.list-modulo').is(':visible')){
						$('.list-modulo').fadeOut('slow');
				}else if(self.libraries_user_selecionado != null){
		   			self.libraries_user_selecionado = null;
		   			self.loadLibConfig();
		   			 $('#img_lib').fadeOut('fast');
					 $('#img_save').fadeOut('fast',function(){
							$('#img_add').fadeIn('slow');
							$('#img_share').fadeIn('slow');
					 });
		   		}else{
		   			self.animation.removeFundoModal();
    				self.menuBar(); 
    				
    				if(!self.element.loadComponente(self.element.componentesCarregados,self.globalCallback().callbackRequest)){
							//$('.lista-componentes').html("");
							//self.element.objetoVazio({element:$('.lista-componentes'),text:'Nenhum Componente Cadastrado !'})
							self.carregaNews('Novidade');
	   				}
    				//self.element.loadComponente(self.element.componentesCarregados,self.globalCallback().callbackRequest);
					self.sincronizaCentrais = true;
					self.element.animation.ajustaLayouts();


		   		}
  		}

  		function choiceCallbackShare(selectItem){
  			void 0;

  			if(!self.isPlanoPremium()){
							self.animation.toast("Compartilhar Biblioteca é exclusivo Plano Premium !");
							return false;
			}
  					var params_share = {
  							color_bar:'color-bar-5',
  							input:{'id':'new-hash','type':'text','placeholder':'compartilhar com ?'},
  							label_text: 'Email', 
  							btn_text:'Enviar',
  							callback:function(email){
  								choiceCallbackCompartilhar(email);
  							}

  					}
  					self.configCentralAdicionar(params_share);

  					function choiceCallbackCompartilhar(email){


			  						var params_dialog = {
												mensagem:'Deseja realmente compartilhar toda sua biblioteca com <b><i>'+ email+'</i></b> ?',
												style:{'text-align':'left'},
												css:{'border':'1px solid #8165a2'},
												callbackDialog:function(result){
													callbackDialog(result);
												}

				  							};


									self.templateMensagemConfirmacao(params_dialog);
						
									function callbackDialog(result){
										
											if(result){

												var email_usuario_atual = self.dados.get('usuario')[0].email_usuario;
												if(email_usuario_atual == email){
													self.animation.toast("Não pode compartilhar com você mesmo! ");
													return;
												}
													
												self.loading = $('.area-controle');
												self.connection
													.execute(
																(self.connection).server('dados'),
																	{
																		acao:'compartilhar_libraries',
																		email: email														
																	},self).done(function(data){
																			//console.log('--> Done');
																			//console.log(data);
																			if(data.hasOwnProperty('resposta')){
																				var msg = data.resposta;

																				if(msg.hasOwnProperty('error_msg')){
																					if(msg.error_msg == 'sucesso'){
																						self.animation.toast("Biblioteca Compartilhada com "+email);
																					}
																	 	   		}
																				
																			}else{
																				self.animation.toast("Erro ao Compartilhar !");
																			}
																		});


											}
									}
 							
  				}


  					

  		}

  		function choiceCallbackAdd(selectItem){
  			void 0;
  					$('.lista-componentes').html("");	   	 					
  					self.loadLibrariesServer();	

  		}
  		function choiceCallbackLib(selectItem){
  			void 0;
  			self.librariesEtapas();	

  		}
  		function choiceCallbackSave(selectItem){
  			void 0;
  			
  			var novoIR = {
  					FK_familia_ap : $('#select_familia').val(),
  					FK_marca_ap:$('#select_marca').val(),
  					FK_tipo_prot_ir:$('#select_tipo').val(),
  					desc_libraries_user:$('#input_desc').val(),
  					bits_libraries_user:$('#input_bits').val(),
  					prot_libraries_user:$('#text_raw').val(),
  					habilita_libraries_user: '1'
  			};


  			jQuery.extend(self.libraries_user_selecionado,novoIR);
  			void 0;
  			

  			if(novoIR.FK_familia_ap == "0"){
  				self.animation.toast("Precisa selecionar uma Família");
  			}else if(novoIR.FK_marca_ap == "0"){
  				self.animation.toast("Precisa selecionar uma Marca");
  			}else if(novoIR.desc_libraries_user == ''){
  				self.animation.toast("Precisa informar uma Descrição");
  			}else if(novoIR.bits_libraries_user == ''){
  				self.animation.toast("Precisa informar os Bits");
  			}else if(novoIR.prot_libraries_user == ''){
  				self.animation.toast("Precisa informa o código IR");
  			}else{

  				    self.loading = $('.lista-componentes');
					self.connection
					.execute(
					(self.connection).server('gerenciador'),
										{
											acao:'new_libraries_user',
											dados:JSON.stringify(self.libraries_user_selecionado)

										},self).done(function(data){
												//console.log('--> Done');
												void 0;
												if(data.hasOwnProperty('resposta')){
													var msg = data.resposta;
													if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

														self.libraries_user_selecionado = null;
														self.dados.replace('libraries_user',msg.libraries_user);
														self.loadLibConfig();
														self.animation.toast("Dados Salvos com Sucesso");

														//console.log(self.dados);
										 	   		}
													
												}else{
													self.animation.toast("Erro ao Alterar Componentes");
												}
												});
  			}

  		}
};

/*
   Atualiza Libraries
*/
cemf.js.TemplatePage.prototype.loadLibConfig = function(){
	void 0;
	 var self = this;


	 	 $('#img_lib').fadeOut('fast');

	  	 $('#img_save').fadeOut('fast',function(){
				$('#img_add').fadeIn('slow');
		 });

	// console.log(this);
		var params = {
						element: $('.lista-componentes'),
						dados: self.dados,
						callbackAlterar:function(data){
							choiceCallbackAlterar(data);
						},
						callbackExcluir:function(data){
							choiceCallbackExcluir(data);
						}
					};

			
				 if(!self.element.loadMyLibraries(params)){
				 	$(".lista-componentes").html("");
				 	self.element.objetoVazio({element:$(".lista-componentes"),text:'Biblioteca Vazia !'});
				 }

				 function choiceCallbackAlterar(data){
				 	void 0;
				 	void 0;
					
				 	self.loadLibrariesServer(data);
				 }	


				 function choiceCallbackExcluir(data){
				 	void 0;

				 	var params_dialog = {
									mensagem:'Confirma a <b><font color="red">Exclusão</font></b> do Registro ? <br> ['+ data.desc_libraries_user+']',
									style:{'text-align':'left'},
									callbackDialog:function(result){
										callbackDialog(result);
									}

	  							};


						self.templateMensagemConfirmacao(params_dialog);
			
						function callbackDialog(result){
							
							if(result){
									void 0;
								 	self.loading = $('.lista-componentes');
									self.connection
									.execute(
									(self.connection).server('gerenciador'),
														{
															acao:'excluir_libraries_user',
															PK_libraries_user:data.PK_libraries_user,

														},self).done(function(data){
																//console.log('--> Done');
																void 0;
																if(data.hasOwnProperty('resposta')){
																	var msg = data.resposta;
																	if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

																		self.dados.replace('libraries_user',msg.libraries_user);
																		self.loadLibConfig();
																		self.animation.toast("Registro Excluido com Sucesso");

														 	   		}else{
														 	   				$(".lista-componentes").html("");
														 	   				self.element.objetoVazio({element:$(".lista-componentes"),text:'Biblioteca Vazia !'});
														 	   		}
																	
																}else{
																	self.animation.toast("Erro ao Alterar Componentes");
																}
																});
							}
						}
				 }
}


cemf.js.TemplatePage.prototype.startLibAdd = function(data){

	/*Area de Adicao*/

	void 0;


	var self = this;
	var reg_lib = (self.load_libraries).libraries;
	var reg_familia = (self.load_libraries).familia;
	var reg_marca = (self.load_libraries).marca;
	var reg_modelo = (self.load_libraries).modelo;
	var reg_prot = (self.load_libraries).tipo;


	self.libraries_user_selecionado  = {'PK_libraries_user':'0'};

	if(data != undefined){
			  $('#img_share').fadeOut('fast');
			  $('#img_add').fadeOut('fast',function(){
					$('#img_lib').fadeIn('slow');
					$('#img_save').fadeIn('slow');
				});
			  	jQuery.extend(self.libraries_user_selecionado, data);
	}

	var div_layout = $('<div></div>');
	div_layout.addClass('layout-etapa-4 layout-config-ir')


	// Inserindo a Familia
	var div_select_1 = $("<div></div>");
	var select_1 = $('<select></select>');
	select_1.attr('id','select_familia');
	
	div_select_1.addClass('div-select-2');
	var option_1 = $('<option></option>');
	option_1.attr('value','0');
	option_1.html('Selecione a Família');
	select_1.append(option_1);

	reg_familia.forEach(function(element,index){
			//console.log(element);
			var option = $('<option></option>');
			option.attr('value',element.PK_familia_ap);
			option.html(element.desc_familia_ap);
			if(data != undefined ){
				if(data.FK_familia_ap == element.PK_familia_ap){
					option.attr('selected',true);
				}
			}
			select_1.append(option);

	});
	div_select_1.append(select_1);

	// Inserindo a Marca
	var div_select_2 = $("<div></div>");
	var select_2 = $('<select></select>');
	select_2.attr('id','select_marca');
	
	div_select_2.addClass('div-select-2');
	var option_2 = $('<option></option>');
	option_2.attr('value','0');
	option_2.html('Selecione a Marca');
	select_2.append(option_2);

	reg_marca.forEach(function(element,index){
			//console.log(element);
			var option = $('<option></option>');
			option.attr('value',element.PK_marca_ap);
			option.html(element.desc_marca_ap);
			select_2.append(option);
			if(data != undefined ){
				if(data.FK_marca_ap == element.PK_marca_ap){
					option.attr('selected',true);
				}
			}

	});
	div_select_2.append(select_2);


	// Inserindo Tipos de Protocolo
	var div_select_3 = $("<div></div>");
	var select_3 = $('<select></select>');
	select_3.attr('id','select_tipo');
	
	div_select_3.addClass('div-select-2');
	var option_3 = $('<option></option>');
	option_3.attr('value','0');
	option_3.html('Selecione o Protocolo');
	select_3.append(option_3);


	reg_prot.forEach(function(element,index){
			//console.log(element);
			var option = $('<option></option>');
			option.attr('value',element.PK_tipo_prot_ir);
			option.html(element.desc_tipo_prot_ir);
			select_3.append(option);
			if(data != undefined ){
				if(data.FK_tipo_prot_ir == element.PK_tipo_prot_ir){
					option.attr('selected',true);
				}
			}

	});
	div_select_3.append(select_3);
	




	var input_1 = $('<input></input>');
	input_1.attr({'type':'text','placeholder':'Descrição','id':'input_desc'});
	if(data != undefined ) input_1.attr('value',data.desc_libraries_user || data.desc_libraries);

	var input_2 = $('<input></input>');
	input_2.attr({'type':'number','placeholder':'Bits','id':'input_bits'});
	if(data != undefined ) input_2.attr('value',data.bits_libraries_user || data.bits_libraries) ;


	var div_icon = $('<div></div>');
	var img = $('<img></img>');
	div_icon.addClass('btn-send-ir color-bar-5');
	img.attr('src','../img/icons/system/ic_technology_controle_white_24dp.png');
	div_icon.append(img);



	var div_area = $('<div></div>');
	div_area.addClass('area-raw');

	var text_area = $('<textarea></textarea>');
	text_area.attr({'rows':'10','placeholder':'Insira o código Raw','maxlength':'1000','id':'text_raw'});
	if(data != undefined ) text_area.html(data.prot_libraries_user || data.prot_libraries);

	div_area.append(text_area);

	var option_text = {
						get:function(comp){
							var len = comp.val().length;
							if(len < 10){
								len = '00'+len;
							} else if(len < 100){
								len = '0'+len;
							}

							return len;
						},
						change:function(comp){
							var text = comp.val();
							text = text.replace(/,/gi,'.');
							text = text.replace(/ |!|#|>|/gi,'');
							//console.log(text);
							return text;
						}
	};

	var span = $('<span></span');
	span.addClass('count-char');
	span.html(option_text.get(text_area));

	text_area.on('input',function(){
		span.html(option_text.get($(this)));
		$(this).val(option_text.change($(this)));
	});



	var div_layout_modulos = $('<div></div>');

	  div_layout_modulos.addClass('list-modulo shadow-bottom-z-4');



	var action_send_ir = {
							click:function(){
								if(text_area.val().length < 1)
									self.animation.toast("Campo RAW não pode ser vazio");
									
								else if(input_2.val().length < 1)
									self.animation.toast("Campo Bits não pode ser vazio");

								else if(select_3.val().length < 1)
									self.animation.toast("Precisa definir o Protocolo.");
							
								else{
									var prot = $("#select_tipo :selected").text();
									self.LoadModulosSendIR(div_layout_modulos, prot +input_2.val()+"."+text_area.val());
								}
									
							}
	};


	div_icon.on(action_send_ir);

	div_layout.append(	
									div_select_1,
									div_select_2,
									div_select_3,
									input_1,
									input_2,
									div_icon,
									div_area,
									span,
									div_layout_modulos

									);



	$('.lista-componentes').html(div_layout);
	

}

cemf.js.TemplatePage.prototype.loadLibrariesServer = function(params){
	
	var self = this;
	void 0;

    self.loading = $('.lista-componentes');
			if(self.load_libraries == null){
				 (self.connection)
				 				.execute((self.connection).server('dados'),{acao:'libraries'},this)
						  		.done(function(data){
						  			void 0;
									if(data.hasOwnProperty("resposta")){
										self.load_libraries = data.resposta;
										self.startLibAdd(params);	
									}
								});

			}else{
				void 0;
				void 0;
				self.startLibAdd(params);
			}


}

cemf.js.TemplatePage.prototype.LoadModulosSendIR = function(layout,raw){
	    var self = this;
		var params = {
						element: layout,
						dados: self.dados,
						habilitado:true,
						callbackCentral:function(data){
								callbackCentralIrSend(data);
							}
					};

	   if(!self.element.loadCentral(params)){
	   		self.element.objetoVazio({element:layout,text:'Nenhum módulo Cadastrado !'})
	   }

	   layout.fadeIn('slow');

	  function callbackCentralIrSend(data){
	  		void 0;
	  		void 0;
	  		void 0;
	  		layout.fadeOut('fast');

	  		self.choiceCallbackRequest({
													id_central:data.FK_central,
													ip:data.ip_central,
													ddns:data.ddns_central,
													porta:data.porta_central,
													nome:data.ident_central,
													data:{
															cod:data.codigo_central,
															model:data.desc_modelo,
															prot:raw+"!"
														},
												});

	  }


}

cemf.js.TemplatePage.prototype.librariesEtapas = function(){
	var self = this;
	var etapa = 0;
	var selecao = {
					PK_familia_ap : 0,
					PK_marca_ap : 0,
					PK_modelo_ap : 0,
					PK_libraries : 0,

	};

	var self = this;
	var reg_lib = (self.load_libraries).libraries;
	var reg_familia = (self.load_libraries).familia;
	var reg_marca = (self.load_libraries).marca;
	var reg_modelo = (self.load_libraries).modelo;
	
	var div_etapa = $('<div></div>');
	div_etapa.addClass('libraries etapas shadow-bottom-z-4');

	var h1 = $('<h1></h1>');
	h1.text('Escolha o Família');
    
    var ul = $('<ul></ul>');
	
    var action_click = {
    					click:function(){
    						etapa ++;
    						switch(etapa){
    							case 1:
    									selecao.PK_familia_ap = $(this).attr('id');
    								//	console.log(selecao);
    									h1.text('Escolha a Marca');
    									ul.html(h1);
										    reg_marca.forEach(function(element,index){
													var exist = false;
													reg_lib.forEach(function(element2,index2){
														if(
																element.PK_marca_ap == element2.FK_marca_ap &&
																selecao.PK_familia_ap == element2.FK_familia_ap){
															exist = true;
														}

													});

													if(exist){
														var li = $('<li></li>');
														li.attr('id',element.PK_marca_ap);
														li.html(element.desc_marca_ap);
														li.on(action_click);
														ul.append(li);
													}		
											});
    							break;
    							case 2:
    									selecao.PK_marca_ap = $(this).attr('id');
    								//	console.log(selecao);

    									h1.text('Escolha a Modelo');
    									 ul.html(h1);
										    reg_modelo.forEach(function(element,index){
													var exist = false;
													reg_lib.forEach(function(element2,index2){
														if(
																element.PK_modelo_ap == element2.FK_modelo_ap &&
																selecao.PK_familia_ap == element2.FK_familia_ap &&
																selecao.PK_marca_ap == element2.FK_marca_ap
															){
															exist = true;
														}

													});

													if(exist){
														var li = $('<li></li>');
														li.attr('id',element.PK_modelo_ap);
														li.html(element.desc_modelo_ap);
														li.on(action_click);
														ul.append(li);
													}			
											});
    							break;
    							case 3:
    									selecao.PK_modelo_ap = $(this).attr('id');
    									void 0;
    									 h1.text('Escolha o sinal');
    									 ul.html(h1);
										    reg_lib.forEach(function(element,index){
										    	//console.log(element);
													
													if(
																element.FK_modelo_ap == selecao.PK_modelo_ap &&
																element.FK_familia_ap == selecao.PK_familia_ap &&
																element.FK_marca_ap == selecao.PK_marca_ap
														){

														var li = $('<li></li>');
														li.attr('id',element.PK_libraries);
														li.html("["+element.desc_tipo_prot_ir+"] "+element.desc_libraries);
														li.on(action_click);
														ul.append(li);			
													}
											});
    							break;
    							case 4:
    									selecao.PK_libraries = $(this).attr('id');
    									void 0;
    								//	console.log("capturar daddos");
    									etapa = 0;

    									if(!self.isPlanoPremium()){
    											div_etapa.fadeOut('slow');
												self.animation.toast("Acesso aos dados da Biblioteca é exclusivo Plano Premium !");
												return false;
										}

    									reg_lib.forEach(function(element2,index2){
														if(selecao.PK_libraries == element2.PK_libraries){
															void 0;
															self.startLibAdd(element2); 				
															return;
														}

										});
    									

    									

    							break;
    						}
    					}
    }

    ul.append(h1);


	reg_familia.forEach(function(element,index){
			
			var exist = false;
			reg_lib.forEach(function(element2,index2){
				if(element.PK_familia_ap == element2.FK_familia_ap){
					exist = true;
				}

			});

			if(exist){
				var li = $('<li></li>');
				li.attr('id',element.PK_familia_ap);
				li.html(element.desc_familia_ap);
				li.on(action_click);
				ul.append(li);			
			}

	});
		
	div_etapa.append(ul);
	$('.layout-config-ir').append(div_etapa);
	div_etapa.fadeIn('slow');

}



/*************************************************

   Start Agendamento

***************************************************/
/*
    Carrega Menu Bar Agendamentos
*/


cemf.js.TemplatePage.prototype.startAgendamentoConfig = function(){
	void 0;
	var self = this;

		var classes = {
  			menu_bar : 'menu-bar',
  			icons    : 'btn-icon',
  			color 	 : 'color-bar-6',
  			font 	 : 'font-size-2',
  			color_text: 'color-text-icons'
  		};

  		var imgs = {
  			ic_back : "../img/icons/system/ic_arrow_back_white_18dp.png",
  		};

  		var params = {
  				img : imgs,
  				classe : classes,
  				callback: function(selectedItem) {
					        choiceCallback(selectedItem);
				}
				
  		};


  		 self.ferramentas.createMenuBarAgendamentos(params);

  		function choiceCallback(naoSalvaLista){
  			void 0;
  			
  		   			self.animation.removeFundoModal();
    				self.menuBar(); 
    				
    				if(!self.element.loadComponente(self.element.componentesCarregados,self.globalCallback().callbackRequest)){
							self.carregaNews('Novidade');
	   				}
					self.sincronizaCentrais = true;
					self.element.animation.ajustaLayouts();

  		}
};

/*
   Atualiza Agendamentos
*/
cemf.js.TemplatePage.prototype.loadAgendamentoConfig = function(){
	void 0;
	 var self = this;


	 	 $('#img_lib').fadeOut('fast');

	  	 $('#img_save').fadeOut('fast',function(){
				$('#img_add').fadeIn('slow');
		 });

		var params = {
						dados: self.dados,
						callbackExcluir:function(data){
							choiceCallbackExcluir(data);
						},
						ultimaCentral: -1,
						ultimaSaida: -1,

					};

			
				self.sincronizaCentrais = false;
				void 0;

				 if(!self.element.loadMyAgendamento(params,self.globalCallback().callbackRequest)){
				 	$(".lista-componentes").html("");
				 	self.element.objetoVazio({element:$(".lista-componentes"),text:'Nenhum modulo modelo RTC instalado !'});
				 }

				

				
}

/*************************************************

   Config COMPONENTEs

***************************************************/
/*
    Carrega Menu Bar Componentes Config
*/

cemf.js.TemplatePage.prototype.startComponentesConfig = function(){
void 0;
	  var componente = this;
	  var modo_option = '';   // Guardo qual item do menu está em seleção

		var classes = {
  			menu_bar : 'menu-bar',
  			icons    : 'btn-icon',
  			color 	 : 'color-bar-2',
  			font 	 : 'font-size-2',
  			color_text: 'color-text-icons'
  		};

  		var imgs = {
  			ic_back : "../img/icons/system/ic_arrow_back_white_18dp.png",
  		};

  		
  		var params = {
  				//id   : ids,
  				img : imgs,
  				classe : classes,
  				callback: function(selectedItem) {
					        choiceCallback(selectedItem);
				},
				callbackNext: function(option) {
					        callbackNext(option);
				},
				callbackFloat: function(option) {
					    	    choiceCallbackFloat(option);
				}
				
  		};

  		componente.ferramentas.createMenuBarComponentes(params);
  		
		$('.lista-componentes').on('click','li',function(){
		 	 $('.lista-componentes').find('li').removeClass('selected');
		 	 $(this).addClass('selected');
		 	 menu.element.idConfigElementSelected = $(this).index();
		});

		/*
		    Esconde todos os botões de ação dos componentes para entrar no modo de edição
		*/
		$('.lista-componentes').find('.switch').css('visibility','hidden');
		$('.lista-componentes').find('.temp-umid').css('visibility','hidden');
		$('.lista-componentes').find('.config-valor').css('visibility','hidden');
		$('.lista-componentes').find('.ir-btn').css('visibility','hidden');
		$('.lista-componentes').find('.ldr').css('visibility','hidden');

		   				
        
  		function choiceCallback(naoSalvaLista){
  			void 0;
  			
  			if(componente.element.etapaConfigComponente > 1){
  				componente.element.etapaConfigComponente --;
  				//console.log("Retornando -> "+componente.element.etapaConfigComponente );
  				componente.element.configComponentesEtapas();
  			}else{
  					if($('.add-setores').length > 0){
  						//console.log("Removendo .add-setores");
				   	$('.add-setores').remove();
				   	$('.fundo-add-setores').remove();

			   		componente.animation.animaControlFloat(true,false);

			 		}else{

			 			//console.log("Encerrando retornando ao estado normal");
				   		componente.animation.removeFundoModal();
		    			componente.menuBar(); 
			   			menu.animation.animaControlFloat(false,true);
		   	 			$('.lista-componentes')
			   	 						.off('click','li')
			   	 						.find('li').removeClass('selected');
		   	  			$('.lista-componentes').find('.switch').css('visibility','visible');

		   	  			
		   	  			 		/*
							   	   Efetuando alterações das TAB´s do Componente
							   	*/

							   	if(naoSalvaLista){
							   		var lista_tabs = [];
							   		var error = false;
							   		
							   		try{
									   		(componente.dados.get('setores',componente.element.posElementSelected).componentes).forEach(function(elem, index){
										   		lista_tabs[index] = new Object({PK_componente:elem.PK_componente,tab_componente:index});
									   		});

								   	}catch(e){
								   		  error = true;
								   		  void 0;

								   	}

									
									if(lista_tabs.length > 0 && !error){  // verifica se está na opção de alteração na lista.
											componente.loading = $('.lista-componentes');
											componente.connection
													.execute(
																(componente.connection).server('gerenciador'),
																	{
																		acao:'altera_tab_componente',
																		dados:JSON.stringify(lista_tabs)

																	},componente).done(function(data){
																			//console.log('--> Done');
																			//console.log(data);
																			if(data.hasOwnProperty('resposta')){
																				var msg = data.resposta;
																				if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){


																					componente.element.loadComponente(componente.element.componentesCarregados,componente.globalCallback().callbackRequest);
																					componente.sincronizaCentrais = true;
																					componente.element.animation.ajustaLayouts();
																						
																	 	   		}
																				
																			}else{
																				componente.animation.toast("Erro ao Alterar Componentes");
																			}
																			});
									}else{
											if(!componente.element.loadComponente(componente.element.componentesCarregados,componente.globalCallback().callbackRequest)){
													$('.lista-componentes').html("");
													componente.element.objetoVazio({element:$('.lista-componentes'),text:'Nenhum Componente Cadastrado !'})
	   										}
											componente.sincronizaCentrais = true;
											componente.element.animation.ajustaLayouts();
									}
								}
								   	
						componente.element.idConfigElementSelected = null;
		   	  			componente.element.auxElementComponente = null;

				   	}
				}

  		}

  		function callbackNext(option){
  			componente.element.etapaConfigComponente ++;
  			void 0;
  			void 0;

  			if(componente.element.etapaConfigComponente >= 5){

  				//console.log("Envidar dados");
  				//console.log(componente.element.auxElementComponente);
  				
  				// Gravar dados no Servidor
  				  componente.loading = $('.lista-componentes');
  				  (componente.connection)
				 		 		.execute((componente.connection).server('gerenciador'),
				 		 				{
				 		 					acao: (modo_option == 'option-5') ? 'novo_componente' : 'alterar_componente',
				 		 					dados: JSON.stringify(componente.element.auxElementComponente)
				 		 				},componente)
						  		.done(function(data){
									//console.log('--> Done');
									//console.log(data);
									if(data.hasOwnProperty('resposta')){

										var objeto_setor = componente.dados.get('setores',componente.element.posElementSelected);
										//var tamanho = (objeto_setor.componentes).length;

												objeto_setor.componentes = data.resposta.componentes;
												componente.animation.toast("Item salvo com sucesso");
												
												componente.element.loadComponente(data.resposta.componentes,componente.globalCallback().callbackRequest);
												componente.element.componentesCarregados = objeto_setor.componentes;
												componente.sincronizaCentrais = true;
												//console.log(componente.dados.get());
										
									}else{
										void 0;
									}	
								});


  				componente.element.etapaConfigComponente = 0;
  				choiceCallback(false);
  					
  			}else{

	  				if(componente.element.etapaConfigComponente == 2 && (componente.element.auxElementComponente).FK_tipo_componente == ''){
	  					componente.element.etapaConfigComponente--;
	  					componente.animation.toast("Escolha um Tipo");

	  				}else if(componente.element.etapaConfigComponente == 3 && (componente.element.auxElementComponente).FK_central == ''){
	  					componente.element.etapaConfigComponente--;
	  					componente.animation.toast("Selecione um Módulo");
	  				
	  				}else if(componente.element.etapaConfigComponente == 4 && (componente.element.auxElementComponente).prot_componente == ''){
	  					componente.element.etapaConfigComponente--;
	  					componente.animation.toast("Selecione um Comando");

	  				}else{
	  					componente.element.configComponentesEtapas();
	  				}
  			}
  			

  		}
  		function choiceCallbackFloat(option){
		   					void 0;
		   					modo_option = option;
		   					switch(option){
		   						case 'option-0':
		   								

		   						break;
		   						case 'option-1': //Excluir
		   								if(componente.element.idConfigElementSelected == null){
		   									componente.animation.toast("Precisa Selecionar um Item");
		   								}else{

		   										 var params_dialog = {
	  														mensagem:'Confirma a Exclusão ?',
	  														style:{'border':'1px solid red'},
	  														callbackDialog:function(result){
	  															callbackDialog(result);
	  														}

	  												};

	  												componente.templateMensagemConfirmacao(params_dialog);

	  												function callbackDialog(result){
	  													//console.log("Result Dialog ->" + componente.element.idElementSelected);
	  													

	  													//console.log(setor['componentes'][componente.element.idConfigElementSelected].PK_componente);
	  													componente.animation.animaControlFloat(true,false);		

	  													if(result){

	  														//var setor 	= componente.dados.search({obj:'setores',PK_setor:componente.element.idElementSelected});  // Guarda setores[x]
	  														var dados 	= componente.dados.get('setores', componente.element.posElementSelected).componentes;
	  														//var id 		= setor['componentes'][componente.element.idConfigElementSelected].PK_componente; // guarda setores.componentes[x].PK_componente
	  														var pos 	= componente.element.idConfigElementSelected; // guarda x
  															var $lista 	= $(".lista-componentes li");

  															
	  														void 0;

															//console.log(componente.dados.get());
															componente.loading = $('.lista-componentes');
															componente.connection
																	.execute(
																				(componente.connection).server('gerenciador'),
																					{
																						acao:'excluir_componente',
																						id: dados[pos].PK_componente

																					},componente).done(function(data){
																							//console.log('--> Done');
																							//console.log(data);
																							if(data.hasOwnProperty('resposta')){
																								var msg = data.resposta;
																								if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

																									       
																									        componente.animation.toast("Componente Removido");

																									       	if(dados.length > 1){
																										       	for(var x = pos; x < (dados.length - 1) ; x++){
																													
																													dados[x] = dados[x+1];
																								 		 		}
																								 		 		dados.pop();  // remove o Item da ultima Posicação
																								 		 	
																								 		 	}else{
																								 		 		dados.pop();
																								 		 	}
																							 		 		
																							 		 		//console.log(dados);

																							 		 		componente.animation.removeItemLista($lista[pos]);	
																							 		 		
																							 		 		componente.element.componentesCarregados = dados;
																						 		 	

																							 		 		//console.log(componente.dados.get());
																								   	
																					 	   		}
																								
																							}else{
																								componente.animation.toast("Erro ao Excluir Componentes");
																							}
																							});

	  													}

	  												}

		   								}
		   						break;
		   						case 'option-2': // Subir
		   								if(componente.element.idConfigElementSelected == null){
		   									componente.animation.toast("Precisa Selecionar um Item");
		   								}else{

		   										var dados 	= componente.dados.get('setores', componente.element.posElementSelected);

		   										dados.componentes = componente.listUP(
		  												 				componente.element.idConfigElementSelected,
		  												 				dados.componentes,
		  												 				$(".lista-componentes li")
		  												 			);

				  									if(componente.element.idConfigElementSelected > 0)
				  										componente.element.idConfigElementSelected --;
					   								}
		   						break;
		   						case 'option-3': // Descer
		   								if(componente.element.idConfigElementSelected == null){
		   									componente.animation.toast("Precisa Selecionar um Item");
		   								}else{

		   									
		   									var dados 	= componente.dados.get('setores', componente.element.posElementSelected);

		   									dados.componentes = componente.listDown(
		  												 				componente.element.idConfigElementSelected,
		  												 				dados.componentes,
		  												 				$(".lista-componentes li")
		  												 			);
											 
											//console.log(componente.element.idConfigElementSelected + "<" + ((dados.componentes).length -1));
											//console.log(componente.element.idConfigElementSelected  < ((dados.componentes).length -1));
											if(componente.element.idConfigElementSelected < ((dados.componentes).length -1)){
				  										componente.element.idConfigElementSelected ++;
			   								}
			   							}
		   						break;
		   						case 'option-4': // Editar
		   								if(componente.element.idConfigElementSelected == null){
		   									componente.animation.toast("Precisa Selecionar um Item");
		   								}else{

		   										componente.animation.animaControlFloat(false,true);
				   								var params_config = {
			  															dados:componente.dados.get('setores', componente.element.posElementSelected).componentes[componente.element.idConfigElementSelected],
			  													   		callback:function(result){
			  																callbackEtapas(result);
			  														}

			  												};
			  									//console.log("--> Enviar Params");
			  									//console.log(componente.dados.get('setores', componente.element.posElementSelected).componentes[componente.element.idConfigElementSelected]);
			  									componente.element.etapaConfigComponente = 1;
				   								componente.element.configComponentesEtapas(params_config);

				   								function callbackEtapas(result){
				   									void 0;
				   								}
		   									
		   								}
		   						break;
		   						case 'option-5': // Novo
		   								void 0;
		   								componente.animation.animaControlFloat(false,true);
		   								var params_config = {
	  															dados:null,
	  													   		callback:function(result){
	  																callbackEtapas(result);
	  														}

	  												};
	  									componente.element.etapaConfigComponente = 1;
		   								componente.element.configComponentesEtapas(params_config);

		   								function callbackEtapas(result){
		   									void 0;
		   								}
		   						break;
		   					}
		}
  	
}


/*************************************************

   Config CENTRAL

***************************************************/
/*
    Carrega Menu Bar Central Config
*/
cemf.js.TemplatePage.prototype.startCentralConfig = function(){
	void 0;
	var central = this;

		var classes = {
  			menu_bar : 'menu-bar',
  			icons    : 'btn-icon',
  			none   	 : 'none',
  			color 	 : 'color-bar-3',
  			font 	 : 'font-size-2',
  			control  : 'control-icon-central'
  		};

  		var imgs = {
  			ic_back : "../img/icons/system/ic_arrow_back_white_18dp.png",
  			ic_down : "../img/icons/system/ic_cloud_download_white_18dp.png",
  			ic_add  : "../img/icons/system/ic_add_circle_outline_white_18dp.png",
  			ic_share: "../img/icons/system/ic_share_white_36dp.png"

  		};

  		// var ids = {
  		// 	id_title : 'title-setor',
  		// 	id_back : 'menu-back',
  		// }

  		var params = {
  				//id   : ids,
  				img : imgs,
  				classe : classes,
  				callback: function(selectedItem) {
					        choiceCallback(selectedItem);
				},
				callbackDown: function(option) {
					        choiceCallbackDown(option);
				},
				callbackAdd: function(option) {
					        choiceCallbackAdd(option);
				},
				callbackShare : function(option) {
					        choiceCallbackShare(option);
				},
				
  		};

  		central.ferramentas.createMenuBarCentral(params);

  		function choiceCallback(selectedItem){
  			void 0;

  			if($('.frame-valida-central').length > 0){
  				   central.configCentralAdicionar(null);

			}else if($('.add-setores').length > 0){
  				   	$('.add-setores').remove();
				   	$('.fundo-add-setores').remove();

			}else if($('.frame-valida-central').length > 0){
				 central.animation.slideUpDown($('.frame-valida-central'));

			}else if($('.frame-add-central').length > 0){
				
				 central.loadCentralConfig();

			}else{



	  				central.animation.animaControlFloat(false,true);
			   		central.animation.removeFundoModal();
				    central.element.idConfigElementSelected = null;
				   	central.menuBar();   
				   	central.sincronizaCentrais = true;

				   	if(central.element.componentesCarregados != null){
				    		central.element.loadComponente(central.element.componentesCarregados,central.globalCallback().callbackRequest);
				    		central.element.animation.ajustaLayouts();
					}else{
						central.animation.animaAreaControle();
					}
					 central.element.idConfigElementSelected = null;
				}
  		}

  		function choiceCallbackShare(selectItem){
  			void 0;

  			if(!central.isPlanoPremium()){
							central.animation.toast("Compartilhamento Módulos é exclusivo Plano Premium !");
							return false;
			}
  					var params_share = {
  							color_bar:'color-bar-3',
  							input:{'id':'new-comp','type':'text','placeholder':'compartilhar com ?'},
  							label_text: 'Email', 
  							btn_text:'Enviar',
  							callback:function(email){
  								choiceCallbackShare(email);
  							}

  					}
  					central.configCentralAdicionar(params_share);

  					function choiceCallbackShare(email){

							var params_dialog = {
										mensagem:'Deseja realmente compartilhar esta central com <b><i>'+ email+'</i></b> ?',
										style:{'text-align':'left'},
										css:{'border':'1px solid #ff9800'},
										callbackDialog:function(result){
											callbackDialog(result);
										}

		  							};


							central.templateMensagemConfirmacao(params_dialog);
				
							function callbackDialog(result){

									if(result){
										var email_usuario_atual = central.dados.get('usuario')[0].email_usuario;
										if(email_usuario_atual == email){
											central.animation.toast("Não pode compartilhar com você mesmo! ");
											return;
										}

										central.loading = $('.area-controle');
										central.connection
												.execute(
															(central.connection).server('dados'),
																{
																	acao:'compartilhar_central',
																	email_usuario: email,
																	PK_central: central.centralSelecionada.PK_central,
																	propietario_central: 2
																},central).done(function(data){
																		//console.log('--> Done');
																		void 0;
																		if(data.hasOwnProperty('resposta')){
																			var msg = data.resposta;

																			if(msg.hasOwnProperty('error_msg')){
																				if(msg.error_msg == 'sucesso'){
																					central.animation.toast("Central Compartilhada com "+email);
																				}
																 	   		}
																			
																		}else{
																			central.animation.toast("Erro ao Cadastrar Setor");
																		}
																});

												}
							}

  			}
  		}

  		function choiceCallbackDown(option){
  			void 0;
  			window.open("http://appweb.automacaohouseonline.com.br/extras/index.php",'_blank');
  			central.animation.toast("Atualizando Módulos...");
  		}
  		function choiceCallbackAdd(option){
  			void 0;

  			var params_add = {
  							color_bar:'color-bar-3',
  							input:{'id':'new-hash','type':'text','placeholder':'KEY'},
  							btn_text:'VALIDAR',
  							label_text: 'Chave', 
  							callback:function(key){
  								choiceCallbackAddCentral(key);
  							}

  			}
  			central.configCentralAdicionar(params_add);

  			function choiceCallbackAddCentral(key){

  							central.loading = $('.area-controle');
							central.connection
									.execute(
												(central.connection).server('key'),
													{
														acao:'validar',
														hash: key														
													},central).done(function(data){
															//console.log('--> Done');
															//console.log(data);
															if(data.hasOwnProperty('resposta')){
																var msg = data.resposta;

																if(msg.hasOwnProperty('error_msg')){

																	//central.animation.toast(msg.error_msg);
																	
																	if(msg.hasOwnProperty('central')){
																		central.dados.replace('central',msg.central);
																		central.loadCentralConfig();
																		void 0;
																	}																	
																	
													 	   		}
																
															}else{
																setor.animation.toast("Erro ao Cadastrar Setor");
															}
														});
  			}

  		}
}

/*
   Atualiza Centrais Ativadas para o Usuario
*/
cemf.js.TemplatePage.prototype.loadCentralConfig = function(){
	void 0;
	 var load = this;

	// console.log(this);
	var params = {
					element: $('.lista-componentes'),
					dados: load.dados,
					callbackCentral:function(data){
							callbackAlterarCentral(data);
						}
				
					};

			
				 $("#img_share_central").fadeOut('fast', function() {
				 			$('#img_add_central').fadeIn('slow');
				 });

				 
				 if(!load.element.loadCentral(params)){
				   		load.element.objetoVazio({element:$('.lista-componentes'),text:'Nenhum módulo Cadastrado !'})
				  }

				 function callbackAlterarCentral(data){

				 	load.centralSelecionada = data;
				 	
				 	var prop = data.proprietario_central;
				 	var itemId = data.PK_central;

				 	void 0;
				 	
				 
				 	if(prop == 2){
				 		load.animation.toast("Módulo bloqueada pelo proprietário.");

				 	}else if(prop == 1){
				 		load.configCentralAlterar(load.dados.search({obj:'central','PK_central':itemId}));
				 		$("#img_add_central").fadeOut('fast', function() {
				 			$('#img_share_central').fadeIn('slow');
				 		});

				 		
				 	}else if(prop == 0){
				 		load.animation.toast("Módulo só pode ser alterada pelo proprietário.");
				 	}
				 }	

	 			 
}


/*
   Função Responsavel por criar o template para Adicionar um novo Setor e as funções de criação.
   Options-5
*/
cemf.js.TemplatePage.prototype.configCentralAdicionar = function(params){
	void 0;
	dados = dados || null;
	var config = this;


	if($('.frame-valida-central').length > 0 || params == null){
		 config.animation.slideUpDown($('.frame-valida-central'));

	}else{
		
			var div 	= $('<div></div>');
			var label 	= $('<label></label>');
			var input 	= $('<input></input>');
			var span 	= $('<span></span>');

			//div.addClass('frame-valida-central color-bar-3 shadow-bottom-z-2');
			div.addClass('frame-valida-central '+params.color_bar+' shadow-bottom-z-2');
			label.text(params.label_text);
			// input.attr({
			// 				'id':'new-hash',
			// 				'type':'text',
			// 				'placeholder':'KEY'
			// 			});
			input.attr(params.input);
			
			span.addClass('font-size-2');
			//span.text("VALIDAR");
			span.text(params.btn_text);
			span.css('color','#212121');

			var action = {
					click: function(event){
						//console.log("Validar KEY");
						
							var key = input.val();
							config.animation.slideUpDown($('.frame-valida-central'));

							params.callback(key);
						
							
							// config.loading = $('.area-controle');
							// config.connection
							// 		.execute(
							// 					(config.connection).server('key'),
							// 						{
							// 							acao:'validar',
							// 							hash: key														
							// 						},config).done(function(data){
							// 								//console.log('--> Done');
							// 								//console.log(data);
							// 								if(data.hasOwnProperty('resposta')){
							// 									var msg = data.resposta;

							// 									if(msg.hasOwnProperty('error_msg')){

							// 										config.animation.toast(msg.error_msg);
																	
							// 										if(msg.hasOwnProperty('central')){
							// 											config.dados.replace('central',msg.central);
							// 											config.loadCentralConfig();
							// 											console.log(config.dados);
							// 										}																	
																	
							// 						 	   		}
																
							// 								}else{
							// 									setor.animation.toast("Erro ao Cadastrar Setor");
							// 								}
							// 							});
						
					}
				
			}
			
			$(span).on(action);

			div.append(label);
			div.append(input);
			div.append(span);
			// span.css('padding-top','0px');
			
			//$(div).animate('top','-86px');

			

			 
			 // $(div).animate({top:100,opacity:0},3500,function(){
			 // 	console.log($(this));
			 // });

			 $('.lista-componentes').prepend(div);
			  config.animation.slideUpDown(div);
			 
		}

	
}

/*
   Função Responsavel por criar o template para Alterar os dados da Central
   
*/
cemf.js.TemplatePage.prototype.configCentralAlterar = function(dados){

	dados = dados || null;

	var config = this;
	//console.log(dados);

	var div = $('<div></div>');
	var table = $('<table></table>');
	var span_alterar = $('<span></span>');
	var span_excluir = $('<span></span>');
	var span_compartilhar  = $('<span></span>');

	div.addClass('frame-add-central font-size-2');

	span_alterar.addClass('font-size-2');
	span_alterar.text("SALVAR");

	span_excluir.addClass('font-size-2');
	span_excluir.css('color','red');
	span_excluir.text("EXCLUIR MÓDULO");

	span_compartilhar.addClass('font-size-2');
	span_compartilhar.text("COMPARTILHAR");

	var action = {
		click:function(){
			//console.log("Alterar Dados Central");

			var params = {
				 	PK_central:dados.PK_central,
                    ident_central:$('#ident_central').val(),
                    ip_central:$('#ip_central').val(),
                    porta_central:$('#porta_central').val(),
                    ddns_central:$('#ddns_central').val(),
                    codigo_central:$('#codigo_central').val(),
                    habilita_central:(($('#habilita_central').is(':checked'))? 1:0)
			}
			void 0;
					
					config.loading = $('.area-controle');
					config.connection
							.execute(
										(config.connection).server('gerenciador'),
											{
												acao:'alterar_central',
												dados:JSON.stringify(params)
											},config).done(function(data){
													//console.log('--> Done');
													//console.log(data);
													if(data.hasOwnProperty('resposta')){
														var msg = data.resposta;

														if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

															config.dados.change('central',params,config.element.idConfigElementSelected);
															config.loadCentralConfig();
											 	   														 	   			
											 	   		}
														
													}else{
														setor.animation.toast("Erro ao Cadastrar Setor");
													}
												});
		}
	}

	
	var table_params = 		[
								{ // Nome
									tr:[{
												style: {},
												text: 'Nome'
										},
										{
												type:'text',
												placeholder:'nome',
												id:'ident_central',
												value:dados.ident_central

										}]
								},
								{ // IP
									tr:[{
												style: {},
												text: 'IP'
										},
										{
												type:'text',
												placeholder:'ip',
												id:'ip_central',
												value: dados.ip_central

										}]
								},
								{ // PORTA
									tr:[{
												style: {},
												text: 'Porta'
										},
										{
												type:'text',
												placeholder:'porta',
												id:'porta_central',
												value: dados.porta_central

										}]
								},
								{ // DDNS
									tr:[{
												style: {},
												text: 'DDNS'
										},
										{
												type:'text',
												placeholder:'ddns',
												id:'ddns_central',
												style: 'text-transform:none',
												value: dados.ddns_central

										}]
								},
								{ // Hash
									tr:[{
												style: {opacity:0.4},
												text: 'Chave'
										},
										{
												type:'text',
												placeholder:'key',
												id:'hash_central',
												readonly:true,
												style:'opacity:0.4',
												value: dados.hash_central

										}]
								},
								{ // Code
									tr:[{
												style: {},
												text: 'Code'
										},
										{
												type:'text',
												placeholder:'caracteres [0..9][a..Z]',
												id:'codigo_central',
												value: dados.codigo_central

										}]
								},
								{ // Model
									tr:[{
												style: {opacity:0.4},
												text: 'Model'
										},
										{
												type:'text',
												placeholder:'Model',
												id:'desc_central',
												readonly:true,
												style:'opacity:0.4',
												value: dados.desc_modelo

										}]
								},
								{ // Habilita
									tr:[{
												style: {},
												text: 'Habilita'
										},
										{
												type:'checkbox',
												placeholder:'habilita',
												id:'habilita_central',
												style:'width:20px;padding:10px',
												checked: (dados.habilita_central == 1) ? true : false

										}]
								}
							];
								
	var action_excluir = {
		click:function(){

			var params_dialog = {
									mensagem:'Ao Excluir o módulo, irá exlcuir todos os componentes vinculados e ela, você confirma assim mesmo ?',
									style:{'text-align':'center'},
									callbackDialog:function(result){
										callbackDialog(result);
									}

	  							};
			config.templateMensagemConfirmacao(params_dialog);
			
			function callbackDialog(result){
				void 0;

				// Se o usuario tiver somente 1 central (e esta for FREE_5) não deixar excluir.
				
				try{
				   var tamanho = (config.dados.get('central')).length
				}catch(e){
					void 0;
				}
				

				if(result && tamanho > 0){
					config.animation.toast("Excluindo Módulo");
					config.loading = $('.lista-componentes .lista-centrais');
					config.connection
							.execute(
										(config.connection).server('gerenciador'),
											{
												acao:'excluir_central',
												central : dados.PK_central,
												prop: dados.proprietario_central,
												hash: dados.hash_central

											},config).done(function(data){
													//console.log('--> Done');
													//console.log(data);
													if(data.hasOwnProperty('resposta')){
														var msg = data.resposta;
														if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

															config.animation.toast("Excluindo Setores Vinculados ao Módulo");
															
															
													   		config.animation.removeFundoModal();
														    config.element.idConfigElementSelected = null;
														   	config.menuBar();   
															location.reload();
															//console.log("reload Pagina");


											 	   		}
														
													}else{
														config.animation.toast("Erro ao Alterar Módulo");
													}
													});
				}else{
					// if(tamanho == 1){
					// 	config.animation.toast("Não autorizada a exclusão");
					// }
				}
			}
		}
	}

	table_params.forEach(function(elem,el){
			var _tr = $('<tr></tr>');
			var _td1 = $('<td></td>');
			var _td2 = $('<td></td>');
			var input = $('<input></input>');
				 
				 _td1.css(elem.tr[0].style);
				 _td1.text(elem.tr[0].text);

				 input.attr(elem.tr[1]);

				 _td2.html(input);


				 _tr.append(_td1);
				 _tr.append(_td2);
			
			table.append(_tr);	
	});			
	

	$(span_alterar).on(action);
	$(span_excluir).on(action_excluir);

	div.append(table);
	div.append(span_alterar);
	div.append(span_excluir);
	
    
	//div.append(span_compartilhar);   // adicionar quando não for FREE

	$('.lista-componentes .lista-centrais').html(div);

	


}


/*************************************************

   Config SETOR

***************************************************/
/*
    Carrega Menu Bar Setor Config
*/

cemf.js.TemplatePage.prototype.startSetorConfig = function(){
		void 0;

	var setor = this;
	

  		var classes = {
  			menu_bar : 'menu-bar',
  			icons    : 'btn-icon',
  			none   	 : 'none',
  			color 	 : 'color-bar-4',
  			font 	 : 'font-size-2',
  		};

  		var imgs = {
  			ic_back : "../img/icons/system/ic_arrow_back_white_18dp.png"

  		};

  		// var ids = {
  		// 	id_title : 'title-setor',
  		// 	id_back : 'menu-back',
  		// }

  		var params = {
  			//	id   : ids,
  				img : imgs,
  				classe : classes,
  				callback: function(selectedItem) {
					        choiceCallback(selectedItem);
				},
				callbackFloat: function(option) {
					        choiceCallbackFloat(option);
				}
				
  		};

  		setor.ferramentas.createMenuBarSetor(params);	
  		
  		function choiceCallback(selectedItem) {
		   void 0;

		   if($('.add-setores').length > 0){
		   	$('.add-setores').remove();
		   	$('.fundo-add-setores').remove();

		   	setor.animation.animaControlFloat(true,false);

		   }else{
		   		setor.animation.animaControlFloat(false,true);
		   		setor.animation.removeFundoModal();
			    setor.element.idConfigElementSelected = null;
			   	setor.menuBar();   

			   	

			   	/*
			   	   Efetuando alterações das TAB´s
			   	*/

			   		var lista_tabs = [];

			   		(setor.dados.get('setores')).forEach(function(elem, index){
				   		lista_tabs[index] = new Object({PK_setor:elem.PK_setor,tab_setor:index});
			   		});
			   		
					if(lista_tabs.length > 1){	// verifica se existem item a serem modificados
							
							setor.loading = $('.painel-lista .lista-setores');
							setor.connection
									.execute(
												(setor.connection).server('gerenciador'),
													{
														acao:'altera_tab_setor',
														dados:JSON.stringify(lista_tabs)

													},setor).done(function(data){
															//console.log('--> Done');
															//console.log(data);
															if(data.hasOwnProperty('resposta')){
																var msg = data.resposta;
																if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

																	setor.atualizaListaSetores(setor.dados);																				 	   														 	   			
													 	   		}
																
															}else{
																setor.animation.toast("Erro ao Alterar Setor");
															}
															});
					}else{
						setor.atualizaListaSetores(setor.dados);
					}
			   	
	  					
	  								

			   	if(setor.element.componentesCarregados != null){
			    		
			    		setor.element.loadComponente(setor.element.componentesCarregados,setor.globalCallback().callbackRequest);
			    		
			    		setor.sincronizaCentrais = true;
						setor.element.animation.ajustaLayouts();
				}else{
					setor.animation.animaAreaControle();
				}

				setor.element.idConfigElementSelected = null;
			}

	  	}


	  	function choiceCallbackFloat(option){   //  Manipular Setores
	  		void 0;

	  		if(setor.element.idConfigElementSelected != null || option == 'option-5'){
	  			switch(option){
	  				case 'option-0': 
	  				break;
	  				case 'option-1': // Excluir
	  							//console.log("excluir Item");

	  												var pos = setor.element.idConfigElementSelected;
  													var dados = setor.dados.get('setores');
  													var $lista = $(".lista-componentes .lista-setores li");
	  												
	  												var params_dialog = {
	  														mensagem:'Confirma a Exclusão ?',
	  														style:{'border':'1px solid red'},
	  														callbackDialog:function(result){
	  															callbackDialog(result);
	  														}

	  												};

	  												$($lista[pos]).css({background:'tomato'});
	  												setor.templateMensagemConfirmacao(params_dialog);

	  												function callbackDialog(result){
	  													//console.log("Executar result :" + result);

				  													

				  												// Aguarda Resposta de confirmação para continuar.
				  												if(result){
				  													setor.animation.animaControlFloat(true,false);


				  													setor.loading = $('.area-controle');
																	setor.connection
																			.execute(
																						(setor.connection).server('gerenciador'),
																							{
																								acao:'excluir_setor',
																								id:dados[pos].PK_setor
																							},setor).done(function(data){
																									//console.log('--> Done');
																									//console.log(data);
																									if(data.hasOwnProperty('resposta')){
																										var msg = data.resposta;
																										if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

																											setor.animation.toast("["+ dados[pos].nome_setor +"] Removido !");
																											for(var x = pos; x < dados.length ; x++){
																								 		  	 dados[x] = dados[x+1];
																								 		  	// console.log(x);
																							 		 		}
																							 		 		setor.animation.removeItemLista($lista[pos]);
																							 		 		dados.pop();  // remove o Item da ultima Posicação
																							 		 		setor.dados.replace('setores',dados);
																							 		 		setor.atualizaListaSetores();
																							 		 		void 0;
																																 	   														 	   			
																							 	   		}
																	
																									}else{
																										setor.animation.toast("Erro ao Cadastrar Setor");
																									}
																					});

																setor.element.idConfigElementSelected = null;
				  												}else{
				  														setor.animation.animaControlFloat(true,false);
				  														$($lista[pos])
																			.css({background:''})
																			.removeClass('selected');
																			setor.element.idConfigElementSelected = null;
																		
				  												}
	  												}

	  												
	  												

	  													//(pos, dados, $lista
	  							
	  												// setor.templateMensagemConfirmacao(
	  												// 					setor.element.idConfigElementSelected,
	  												// 					setor.dados.get('setores'),
	  												// 					$(".lista-componentes .lista-setores li")
	  												// 				);
	  							
	  				break;
	  				case 'option-2': // Subir
	  							void 0;
	  							
	  							setor.dados.replace(
	  												'setores',
	  												 setor.listUP(
	  												 				setor.element.idConfigElementSelected,
	  												 				setor.dados.get('setores'),
	  												 				$(".lista-componentes .lista-setores li")
	  												 			)
	  											);
	  							
	  							if(setor.element.idConfigElementSelected > 0)
	  									setor.element.idConfigElementSelected --;

	  							

	  				break;
	  				case 'option-3': // Descer
	  							var _dados = setor.dados.get('setores');

	  							setor.dados.replace(
													'setores',
													 setor.listDown(
												 				setor.element.idConfigElementSelected,
												 				_dados,
												 				$(".lista-componentes .lista-setores li")
													 			)
												);
								 
								if(setor.element.idConfigElementSelected < (_dados.length -1))
	  										setor.element.idConfigElementSelected ++;

	  							  									

	  							//console.log("descer Item");
	  				break;
	  				case 'option-4': // Editar
	  							void 0;
	  							//console.log(setor.dados.get('setores',setor.element.idConfigElementSelected));
	  							setor.configSetorAdicionar(
	  														setor.dados.search({
	  																				obj:'setores',
	  																				PK_setor:
	  																							setor.dados.get(
	  																												'setores',
	  																												setor.element.idConfigElementSelected
	  																											).PK_setor
	  																						  
	  																			}
	  																			)
	  														);
	  				break;
	  				case 'option-5': // Novo
	  							void 0;
	  							setor.configSetorAdicionar();

	  				break;
	  				
	  			}
	  		}else{
	  			setor.animation.toast("Selecione um Setor");
	  		}


	  	}

}

/*
   Função Responsavel por criar o template para Adicionar um novo Setor e as funções de criação.
   Options-5
*/
cemf.js.TemplatePage.prototype.configSetorAdicionar = function(dados){
	void 0;
	
	dados = dados || null;

	var config = this;

	config.animation.animaControlFloat(false,false);

	var div_fundo	= $('<div></div>');
	var div 	= $('<div></div>');
	var label 	= $('<label></label>');
	var input 	= $('<input></input>');
	var span 	= $('<span></span>');

	div_fundo.css({'position':'absolute','top':'0px','width':'100%','height':'90%'});
	div_fundo.addClass('fundo-add-setores');
	div.addClass('add-setores shadow-bottom-z-4');
	label.text('Nome');
	input.val((dados == null)?"":dados.nome_setor);
	input.attr({
					'id':'nome_setor',
					'type':'text',
					'placeholder':'Nome Setor'
				});
	input.css('text-transform','none');
	
	span.addClass('right font-size-2');
	span.attr('id','add-setor');
	span.text((dados == null)?"CRIAR":"ALTERAR");

	var action = {
			click: function(event){
				config.animation.animaControlFloat(true,false);
				$(div_fundo).remove();
				$(div).remove();
				
					var tamanho = (config.dados.get('setores')).length;

					var params = {
									PK_setor: (dados == null) ? 0: dados.PK_setor,
									nome_setor:input.val(),
									icon_setor:(dados == null) ? 'ic_dns_black_24dp.png': dados.icon_setor,
									tab_setor:(dados == null) ? tamanho: dados.tab_setor,
									habilita_setor:(dados == null) ? 1: dados.habilita_setor									

					};
				
					config.loading = $('.area-controle');
					config.connection
							.execute(
										(config.connection).server('gerenciador'),
											{
												acao:(dados == null) ? 'novo_setor': 'alterar_setor',
												dados:JSON.stringify(params)
											},config).done(function(data){
													//console.log('--> Done');
													//console.log(data);
													if(data.hasOwnProperty('resposta')){
														var msg = data.resposta;

														if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){


															if (dados == null){  // Se for um item novo Incluso a lista

																params.PK_setor = msg.PK_setor;	
											 	   				config.dados.replace('setores',params,tamanho);

															}else{
											 	   				config.dados.change('setores',params,config.element.idConfigElementSelected);

															}


											 	   			 config.loadSetoresConfig();
											 	   			
											 	   														 	   			
											 	   		}
														
													}else{
														setor.animation.toast("Erro ao Cadastrar Setor");
													}
												});
				
			}
		
	}
	
	$(span).on(action);

	div.append(label);
	div.append(input);
	div.append(span);
	
	
	$('.area-controle').append(div_fundo);
	$('.area-controle').append(div);

}
/*
   Atualiza Lista de Setores no template de configuração.
*/
cemf.js.TemplatePage.prototype.loadSetoresConfig = function(){
	void 0;
	 var load = this;

	// console.log(this);
	var params = {
					tiposModoMenu : load.menuSelected,
					element: $('.lista-componentes'),
					dados: load.dados,
					};

			
				 //load.element.loadSetor(params);
				  if(!load.element.loadSetor(params)){
				 	$(".lista-componentes").html("");
				 	load.element.objetoVazio({element:$(".lista-componentes"),text:'Setor Vazio !'});

				 }

				

				
}

/*
 	Gerencia todos os compartilhamentos do Usuario
*/


cemf.js.TemplatePage.prototype.carregaCompartilhamentos = function(){
	void 0;
	 var self = this;

	 self.element.idElementSelected = null;
	 $('#title-setor').html("Meus Compartilhamentos");

	 var params_comp = {
	 				element: $('.lista-componentes'),
	 				dados: self.dados,
	 				callbackCentrais:function(res){
	 					choiceExcluirCentrais(res);
	 				},
	 				callbackLibraries:function(res){
	 					choiceCompLibraries(res);
	 				},
	 				callbackPerson:function(id){
	 					choiceBuscaPerson(id);
	 				},
	 }

	 self.loading = $('.area-controle');
	 self.connection
		.execute(
					(self.connection).server('dados'),
						{
							acao:'carrega_compartilhamentos'
						},self).done(function(data){
								//console.log('--> Done');
								//console.log(data);
								if(data.hasOwnProperty('resposta')){
									var msg = data.resposta;
									try{

										params_comp.result = msg.compartilhamentos;
										self.element.loadCompartilhamento(params_comp);

									}catch(e){
										void 0;
										void 0;
									}
									
								}else{
									self.animation.toast("Erro ao Cadastrar Setor");
								}
							});




		function choiceExcluirCentrais(res){
			void 0;
			void 0;

			if(!self.isPlanoPremium()){
						self.animation.toast("Exclusão de Compartilhamento é exclusivo Plano Premium !");
						return false;
			}

			var params_dialog = {
									mensagem:'Deseja realmente excluir o compartilhamento do módulo <b><i>'+res.ident_central+'</b></i> ?',
									style:{'border':'1px solid red'},
									callbackDialog:function(result){
										callbackDialog(result);
									}

								};

	  							self.templateMensagemConfirmacao(params_dialog);

								function callbackDialog(result){
											if(result){
													 self.loading = $('.area-controle');
													 self.connection
														.execute(
																	(self.connection).server('dados'),
																		{
																			acao:'excluir_compartilhamento_central',
																			FK_usuario: res.FK_usuario,
																			FK_central: res.FK_central
																		},self).done(function(data){
																				

																				if(data.hasOwnProperty('resposta')){
																					data = data.resposta;

																					if(data.hasOwnProperty('error_msg') && data.error_msg == 'sucesso'){

																							self.animation.toast("Compartilhamento Excluido !");
																							self.carregaCompartilhamentos();
													 								}else{

													 								}
											 	   			
											 	   								}																		
																					
																				
																			});

											}
								}


		}

		function choiceCompLibraries(res){
			void 0;
			void 0;

					if(!self.isPlanoPremium()){
							self.animation.toast("Exclusão de Compartilhamento é exclusivo Plano Premium !");
							return false;
				}
			

			var params_dialog = {
									mensagem:'Deseja realmente excluir o compartilhamento da <b><i>Biblioteca IR</b></i> ?',
									style:{'border':'1px solid red'},
									callbackDialog:function(result){
										callbackDialog(result);
									}

								};

	  							self.templateMensagemConfirmacao(params_dialog);

								function callbackDialog(result){
											if(result){
													 self.loading = $('.area-controle');
													 self.connection
														.execute(
																	(self.connection).server('dados'),
																		{
																			acao:'excluir_compartilhamento_libraries',
																			FK_usuario_pai: res.FK_usuario_pai,
																			FK_usuario_filho: res.FK_usuario_filho
																		},self).done(function(data){
																				
																				if(data.hasOwnProperty('resposta')){
																					data = data.resposta;
																					
																					if(data.hasOwnProperty('error_msg') && data.error_msg == 'sucesso'){

																							self.animation.toast("Compartilhamento Excluido !");
																							self.carregaCompartilhamentos();
																							

													 								}
											 	   			
											 	   								}																		
																					
																				
																			});

											}
								}
		}
		function choiceBuscaPerson(id){
			void 0;
			void 0;

			 self.loading = $('.area-controle');
							 self.connection
								.execute(
											(self.connection).server('dados'),
												{
													acao:'localiza_usuario',
													FK_central: id.FK_central,
													FK_usuario: id.FK_usuario_pai || 0
												},self);
		}



		self.animation.ajustaLayouts();

	
}

/*
   Sobe um item da lista com animação
   pos    = posicao da item na lista
   dados  = o array com os itens da lista
   $lista = os elemente html para animar
*/
cemf.js.TemplatePage.prototype.listUP = function(pos, dados, $lista){
	var list = this;
	var aux;
   			
	       if(pos > 0){
	       	    
				aux = dados[pos];
				dados[pos] = dados[pos-1];
				dados[pos-1] = aux;
				list.animation.movimentaLista($lista[pos],$lista[pos-1]);
				
			}
	
	
	return dados;
}
/*
   Desce um item da lista com animação
*/
cemf.js.TemplatePage.prototype.listDown = function(pos, dados, $lista){
	var list = this;
	var aux;
				
				if(pos < (dados.length - 1)){
	       	    

				 	aux = dados[pos];
					dados[pos] = dados[pos+1];
					dados[pos+1] = aux;
					list.animation.movimentaLista($lista[pos],$lista[pos+1]);
				}
	return dados;
	
}



/*

   Layout para mensagens de confirmação.
   {callback, mensagem, style}
*/

cemf.js.TemplatePage.prototype.templateMensagemConfirmacao = function(params){
	var list = this;

	list.animation.animaControlFloat(false,false);		

	var div_fundo		= $('<div></div>');
	var div 			= $('<div></div>');
	
	var p 				= $('<p></p>');
	var span_conf 		= $('<span></span>');
	var span_canc 		= $('<span></span>');

	div_fundo.css({'position':'absolute','top':'0px','width':'100%','height':'90%'});

	

	div_fundo.addClass('fundo-add-setores');
	div.addClass('add-setores shadow-bottom-z-4');
	p.html(params.mensagem);
	try{
		div.css(params.css);
	}catch(e){
		void 0;
	}
	
	span_conf.addClass('right font-size-2');
	span_conf.attr('id','add-setor');
	span_conf.text("Confirmar");

	span_canc.addClass('right font-size-2');
	span_canc.text("Cancelar");
	span_canc.css({'margin-right':'20px','color':'#787878'});

	if(params.hasOwnProperty('style'))
					 div.css(params.style);



	var action_confirmar = {
			click: function(event){
				
				$(div_fundo).remove();
				$(div).remove();
				params.callbackDialog(true);
				
			}
		
	}

	var action_cancelar = {
						click:function(){
							
							$(div_fundo).remove();
							$(div).remove();
							params.callbackDialog(false);
							
						}
	}
	
	$(span_conf).on(action_confirmar);
	$(span_canc).on(action_cancelar);
	$(div_fundo).on(action_cancelar);

	div.append(p);
	div.append(span_conf);
	div.append(span_canc);

	
	
	$('.area-controle').append(div_fundo);
	$('.area-controle').append(div);


	
}

cemf.js.TemplatePage.prototype.logouUsuario = function(){
		void 0;
		var self = this;

		var $area_controle			= $('.area-controle');
		var $menu_bar 				= $('.menu-bar');

					self.animation.toast("Logout");
				    self.loading = null;
				 	self.connection
							.execute(
										(self.connection).server('login'),
											{
												acao:'destroisession'
											},self).done(function(data){
													void 0;
													if(data.hasOwnProperty('resposta')){
														var msg = data.resposta;

														if(msg.hasOwnProperty('error_msg') && msg.error_msg == 'sucesso'){

															$area_controle.animate({opacity:'0'},1000);
															$('.menu-panel').animate({left:'-300px'},800);
													 		$menu_bar.animate({top:'-300px'},1000,function(){
													 			
													 			//document.cookie = 'USER=carlos';
													 			//window.location = "../";
													 			window.location = new cemf.js.Utility().url_current();

													 		});
											 	   			
											 	   		}
														
													}else{
														self.animation.toast("Erro ao Encerrar Sessão");
													}
												});

}

cemf.js.TemplatePage.prototype.carregaNews = function(tipo){
		var self = this;

		var news = self.dados.get('news');
		
		var $painel = $(".lista-componentes");
		void 0;
		

		self.element.idElementSelected = null;


		if(news){

 			  var lista = $("<div></div>");
 			  lista.addClass('list-files');
			  var ul = $("<ul></ul>");

			 var data = new Date();
			 var hoje = (data.getFullYear()) +'-' +(data.getMonth()+1)+'-' + (data.getDate());
			
				

			  news.forEach(function(element,index){

			 
			 	if(element.desc_tipo_news == tipo){
			 		var mostra = false;


					 var li = $("<li></li>");
					 var link = $("<a></a>");
					 var img = $("<img></img>");
					 var info  = $("<div></div>");
					 var title = $("<div></div>");
					 var subtitle = $("<span></span>");

					
					 link.addClass('modulette shadow-bottom-z-2');

					 link.attr('href',element.link_news);
					 link.attr('target',"_blank");
					 
					 img.addClass('icon callout-icon');

					 img.attr('src','../img/icons/news/'+element.img_news);

					 info.addClass('info');
					 title.addClass('title');

					  subtitle.addClass('subtitle');
					

					 switch(tipo){
					 	case 'Tutorial':
					 			title.html("<font color='green'><b>" + element.titulo_news+"</b></font>");
					 			 subtitle.html(element.subtitle_news);
					 			 mostra = true;
					 	break;
					 	case 'Novidade':
					 			title.html("<font color='blue'><b>" + element.titulo_news+"</b></font>");
					 			subtitle.html(element.subtitle_news);
					 			li.css({
					 					display:'block',
					 					width: 'auto'
					 			});
					 			link.attr('target',"");
					 			mostra = true;

					 	break;
					 	case 'Loja':
					 			title.html("<font color='orange' ><b>" + element.titulo_news+"</b></font>");
					 			 subtitle.html("<font color='gray'>" +element.subtitle_news+"</font>");
					 			 mostra = true;
					 	break;
					 	case 'Download':

					 			title.html("<font color='green' ><b>" + element.titulo_news+"</b></font>");
					 			 subtitle.html("<font color='gray'>" +element.subtitle_news+"</font>");
					 			 li.css({
					 					display:'block',
					 					width: 'auto'
					 			});


					 	break;

					 }
					 
					 // Verifica se o cliente tem algum modulo do tipo para liberar o download
					 if(tipo == 'Download'){
				 			var centrais = self.dados.get('central');
							void 0;
							var mostra = false;

							centrais.forEach(function(el,ind){
								void 0;
								if((element.titulo_news).search(el.desc_modelo) > -1){
									mostra = true;
								}
							});
					 }

					 if(mostra){


					 	 info.append(title);
						 info.append(subtitle);

						 link.append(img);
						 link.append(info);
						 li.append(link);
						 ul.append(li);

						if(self.comparaData(hoje,element.data_news) < self.data_limite_mostra_new ){
	  							void 0;
	 							title.addClass('new');
	 					}	
					}

						
					

						 
				}

			 });


			lista.append(ul);
			$painel.html(lista) ;			


		}else{
			void 0;
			
		}
		self.animation.ajustaLayouts();

		

		

}

/*
  compara 2 data e retorna a quantidade de dias entre elas,
  primeiramente passar a data maior.
  
*/
cemf.js.TemplatePage.prototype.comparaData = function(date1,date2){

			date1 = new Date(date1).getTime();
			date2 = new Date(date2).getTime()
			dias = parseInt(date1) - parseInt(date2);
			return dias/86400000
																								
}

/*
	Funções de inicialização do sistema.
*/


cemf.js.TemplatePage.prototype.start = function(){
		void 0;

	var start = this;
  		
		var params = {
			callback: function(screen){
				callbackRezise(screen);
			}
		};
  		
  		
  		start.animation = new cemf.js.Animation(params);
  		start.screen = start.animation.screenSize();
  		start.connection = new cemf.js.Connection();
  		start.element = new cemf.js.Element(start.animation);
  		start.dados = new cemf.js.Dados();

  		// Carrega Menu Bar Default
  		start.menuBar();
  		start.atualizaListaSetores();

	
		  		

 		$('.lista-config #acesso_externo').on('click',function(){
	    	//console.log($(this).is(":checked"));
	    	start.acesso_externo = $(this).is(":checked");
	    	start.animation.toast("Acesso Externo : " + ((start.acesso_externo)? "Ativado" : "Desativado"));
	    })

	    $('.image-top-menu #logout').on('click',function(){
	    	start.logouUsuario();
	    });

	    $('.item-panel').on('click',function(){
	    	start.carregaNews($(this).attr('id'));
	    	start.element.componentesCarregados = null;
	    });

	    $('.item-comp').on('click',function(){
			//console.log("Clicou");
	    	start.carregaCompartilhamentos();
	    	start.element.componentesCarregados = null;
	    });
	    $('.footer-panel').on('click',function(){
			void 0;
			start.element.sincronizaCentrais = false;
			start.element.idElementSelected = null;
	    });

	    // $('#Tutorial').on('click',function(){
	    // 	start.carregaNews(1,this);
	    // });
	    //  $('#Loja').on('click',function(){
	    // 	start.carregaNews(3,this);
	    // });



	   // Caso o navegador não reconheça o comando .remove() ...  IE
		if (!('remove' in Element.prototype)) {
			void 0;
		    Element.prototype.remove = function() {
		        if (this.parentNode) {
		            this.parentNode.removeChild(this);
		        }
		    };
		}
		

  		function callbackRezise(screen){

  			void 0;
  			start.screen = screen;
  			//start.animation.menuBar();
  		}

}


$( document ).ready(function() {
	if($('#page-panel').length > 0){

		//var _cookie = document.cookie.replace(/(?:(?:^|.*;\s*)USER\s*\=\s*([^;]*).*$)|^.*$/, "$1");
		//console.log("coockie -:" + _cookie);

		new cemf.js.TemplatePage().start();

	}

});

// function Data_hora(data_hora){
		// 	// Capturando a data do sistema
		// 	var data = new Date();
		// 	var retorno = "-";

		// 	switch(data_hora){
		// 		case 'dia'     : retorno = data.getDate(); break;  // 1-31
		// 		case 'dia_sem' : retorno = data.getDay(); break;   // 0-6 (zero=domingo)
		// 		case 'mes'     : retorno = data.getMonth(); break; // 0-11 (zero=janeiro)
		// 		case 'ano2'    : retorno = data.getYear()-100;break;   // 2 dígitos
		// 		case 'ano4'    : retorno = data.getFullYear();break;  // 4 dígitos
		// 		case 'hora'    : retorno = data.getHours(); break;    // 0-23
		// 		case 'min'     : retorno = data.getMinutes(); break;  // 0-59
		// 		case 'seg'     : retorno = data.getSeconds(); break;  // 0-59
		// 		case 'mseg'    : retorno = data.getMilliseconds(); break;  // 0-999
		// 		case 'UTC'     : retorno = data.getTimezoneOffset();break; // em minutos
		// 		case 'data'    : retorno = data.getDate() + '/' + (data.getMonth()+1) + '/' + (data.getYear()-100);break; // em minutos
		// 		case 'horas'    : retorno = data.getHours() + ':' + data.getMinutes(); break; // em minutos
		// 	}
		// 	return retorno;

		// }


void 0;


var cemf =  cemf || {
  js: {}
};

cemf.js.Login = function(){}

/*
	Recebe a instancia da comunicação
*/
cemf.js.Login.prototype.connection = null;
cemf.js.Login.prototype.longitude  = 1;
cemf.js.Login.prototype.latitude   = 1;

/*
	 Recebe o objeto Loading
*/
cemf.js.Login.prototype.loading = null;

cemf.js.Login.prototype.md5 = function(value) {
												    return CryptoJS.MD5(value).toString();
											}
cemf.js.Login.prototype.createFormLogin = function(){
	var self = this;

	var $content = $(".content");
	
	var $painel = $("<div></div>");
		$painel.addClass('painel-login ');
	
	var $form = $("<div></div>");
		$form.addClass("lg-form");
	//	$form.attr('id','lg-form');

	var $email = $("<input></input>");
	$email.addClass('color-secondary-text');
			$email.attr({
					'id':'email',
					'type':'email',
					'placeholder':'email',
					'style':'text-transform:lowercase'
				  });
	
	var $senha = $("<input></input>");
	$senha.addClass('color-secondary-text');
			$senha.attr({
					'id':'senha',
					'type':'password',
					'placeholder':'senha',
				  });

	var $span = $("<span></span>");
		$span.addClass('msg-error font-size-1');
		//$span.attr('id','msg-error-entrar');

	var $div_action	= $("<div></div>");
		$div_action.addClass("lg-acao");

	var $btn_recuperar = $("<a></a>");
		$btn_recuperar.addClass('btn font-size-1 color-primary-text');
		$btn_recuperar.text("Esqueci a senha");
		$btn_recuperar.attr({'href':'#'});

	var $btn_entrar = $("<a></a>");
		$btn_entrar.addClass('a-off bold color-primary-text btn right block');
		$btn_entrar.text("ENTRAR");
		$btn_entrar.attr({'href':'#'});

	var $div_cad = $("<div></div>");

	var $btn_cadastrar = $("<a></a>");
		$btn_cadastrar.addClass('btn a-off bold left color-primary-text font-size-2 mgt-1');
		$btn_cadastrar.text("SE CADASTRAR");
		$btn_cadastrar.attr({'href':'#'});

		var action_entrar = {
						click:function(){
							void 0;
							void 0;
							self.loading = $('.msg-error');
						 	self.connection
									.execute(
												(self.connection).server('ilogin'),
													{
										 					acao:'validar',
										 					email:$email.val().toLowerCase(),
										 					senha:self.md5($senha.val())
													},self).done(function(data){
															void 0;
															if(data.hasOwnProperty('resposta')){
																var msg = data.resposta;
																if(msg.hasOwnProperty('error_msg') && msg.error == 0){

																	$span.html('');
												 					$('.content').animate({opacity:'0'},400,function(){
																	});
																	$('.banner-title').animate({top:'-300px',height:'140px'},950);
																	$painel.animate({height: '-300px'},1000,function(){
																		 //document.cookie = 'USER='+ msg.usuario+"; expires=Fri, 31 Dec 9999 23:59:59 GMT";
																		   //window.location = "view/dashboard.php";
																		   window.location = (new cemf.js.Utility().url_current())+"/view/dashboard.php";
																		   
																	});
													 	   			
													 	   		}else{
													 	   			$span.text(msg.error_msg);
													 	   			$senha.val("");
													 	   		}
																
															}else{
																
															}
														});

						}
		}
		var action_cadastrar = {
						click:function(){
							self.createFormCadastro($painel);

							
						}
		}
		var action_recuperar = {
						click:function(){
							
							// var params = {
							// 	callbackGeo:function(position){
							// 		callbackOptionGeo(position);
							// 	}
							// }
							//self.animation.geoLocation(params.callbackGeo);

							self.createFormRecuperaSenha($painel);
							

							function callbackOptionGeo(position){
								void 0;
							}
						}
		}

	
	$btn_cadastrar.on(action_cadastrar);
	$btn_recuperar.on(action_recuperar);
	$btn_entrar.on(action_entrar);

	$div_cad.append($btn_cadastrar);
	$div_action.append($btn_recuperar);
	$div_action.append($btn_entrar);
	

	$form.append($email);
	$form.append($senha);
	$form.append($span);
	$form.append($div_action);
	$form.append($div_cad);

	$painel.append($form);

	$content.html($painel);
	$painel.fadeIn('slow');



}

cemf.js.Login.prototype.createFormRecuperaSenha = function (painel){
	var self = this;

	var $content = $(".content");

	$div_back   = $("<div></div>");
	$div_back.addClass('icon-back btn-icon');

	img	 = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36"><path d="M30 16.5H11.74l8.38-8.38L18 6 6 18l12 12 2.12-2.12-8.38-8.38H30v-3z"/></svg>';
	
	$div_back.html(img);
	
	var $form = $("<div></div>");
		$form.addClass("recuperar-form");
	

	var $email = $("<input></input>");
	$email.addClass('color-secondary-text');
			$email.attr({
					'id':'email',
					'type':'email',
					'placeholder':'email',
					'style':'text-transform:lowercase'
				  });
	
	var $span = $("<span></span>");
		$span.addClass('msg-error font-size-1');
		//$span.attr('id','msg-error-entrar');

	//var $div_action	= $("<div></div>");
		
	var $btn_recuperar = $("<a></a>");
		$btn_recuperar.addClass('btn a-off bold left color-primary-text font-size-2 mgt-1');
		$btn_recuperar.text("RECUPERAR");
		$btn_recuperar.attr({'href':'#'});

	var p = $("<p></p>");
	p.addClass('msg-alert-recuperar font-size-1');
	p.text('* Os procedimentos de recuperação serão enviados para o e-mail informado, caso não receba, verifique no SPAM');

	
	var action_recuperar = {
		click:function(){
			void 0;

							window.location = "https://automacaonaveia.cemf.com.br/solicitar-recuperacao/"+$email.val();
							return;
							self.loading = $span;
						 	self.connection
									.execute(
												(self.connection).server('forget'),
													{
															 acao:'forget',
										 					email:$email.val()
													},self).done(function(data){

															if(data.hasOwnProperty('resposta')){
																var msg = data.resposta;
																if(msg.hasOwnProperty('error_msg') && msg.error == 0){
																	$span.text("Enviado");
																	self.animation.toast(msg.error_msg);

																	setTimeout(function(){ 

																			painel.fadeOut('slow');
																			$('.content').animate({height: '200px'},600);
																			$('.banner-title').animate({top:'200px'},500, function(){
																				self.createFormLogin();
																					
																			 });
																		}, 5000);
																	
													 	   		}else{
													 	   			$span.text(msg.error_msg);
													 	   		}
																
															}
														});
		}
	}	

	var action_back={
			click:function(){
				painel.fadeOut('slow');
				$('.content').animate({height: '200px'},600);
				$('.banner-title').animate({top:'200px'},500, function(){
					self.createFormLogin();
						
				 });

				
			}
	}

	
	
	$btn_recuperar.on(action_recuperar);
	$div_back.on(action_back);

	//$div_action.append($btn_recuperar);
	$form.append($email);
	$form.append($btn_recuperar);
	$form.append($span);
	$form.append(p);
	
	// $painel.append($div_back);
	// $painel.append($form);

	// $content.html($painel);
	
	painel.fadeOut('fast',function(){
				painel.html('');
				painel.append($div_back);
				painel.append($form);
				
				painel.fadeIn('slow');
		});
	
		
}


cemf.js.Login.prototype.createFormCadastro = function (painel){
	var self = this;

	

	div_back   = $("<div></div>");
		div_back.addClass('icon-back btn-icon');

	img	 = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36"><path d="M30 16.5H11.74l8.38-8.38L18 6 6 18l12 12 2.12-2.12-8.38-8.38H30v-3z"/></svg>';
	

	div_form =  $("<div></div>");
		div_form.addClass('cadastro-form');

	i_nome = $("<input></input>");
		i_nome.attr({
					'id':'cadastro-nome',
					'type':'text',
					'placeholder':'nome',
					'class':'color-secondary-text',
					'style':'text-transform:capitalize'
				  });


	error_nome = $("<span></span>");
		error_nome.addClass('msg-error font-size-1 mgt-0');
		error_nome.attr('id','msg-error-nome');

	
	i_email = $("<input></input>");
		i_email.attr({
					'id':'cadastro-email',
					'type':'text',
					'placeholder':'email',
					'class':'color-secondary-text',
					'style':'text-transform:lowercase'
				  });
		
	error_email = $("<span></span>");
	error_email.addClass('msg-error font-size-1 mgt-0');
	error_email.attr('id','msg-error-email');
	
	i_senha = $("<input></input>");
	i_senha.attr({
					'id':'cadastro-senha',
					'type':'password',
					'placeholder':'senha',
					'class':'color-secondary-text',
				  });
		
	error_senha= $("<span></span>");
	error_senha.addClass('msg-error font-size-1 mgt-0');
	error_senha.attr('id','msg-error-senha');
	
	i_confirma = $("<input></input>");
	i_confirma.attr({
					'id':'cadastro-confirma-senha',
					'type':'password',
					'placeholder':'confirma senha',
					'class':'color-secondary-text',
				  });
		

	div_btn = $("<div></div>");
	a_btn = $("<a></a>");
		a_btn.addClass('btn a-off bold right color-primary-text font-size-2 mgt-1');
		a_btn.attr({'id':'btn-confirma-cadastro','href':'#'});
		a_btn.text('CONFIRMAR');

	error_msg = $("<span></span>");
		error_msg.addClass('msg-error');
		error_msg.addClass('msg-error font-size-1 mgt-0');
		error_msg.attr('id','error-cadastro');

	var action_back={
			click:function(){
				painel.fadeOut('slow');
				$('.content').animate({height: '200px'},600);
				$('.banner-title').animate({top:'200px'},500, function(){
					self.createFormLogin();
						
				 });

				
			}
	}
	var action_cadastrar={
			click:function(){
				void 0;


					var nome = i_nome.val();
					var email = i_email.val().toLowerCase();
					var senha = i_senha.val();
					var confirma_senha = i_confirma.val();
					var error = 0;

					
			
					if(nome.length < 1){
						error_nome.html('Nome não pode ser vazio');
						error ++;
					} else{ error_nome.html(''); }
					if(!isEmail(email)){
						error_email.html('Email inválido');
						error++;
					}else{ error_email.html(''); }

					if(senha != confirma_senha){
						error_senha.html('Senhas diferentes');
						error++;
					}else if(senha.length < 6){
						error_senha.html('minimo 6 caracteres');
						error++;
					}else{error_senha.html('');}

					if(error == 0){
							
							error_msg.text("");
							self.loading = error_msg;
						 	self.connection
									.execute(
												(self.connection).server('ilogin'),
													{
										 				acao:'cadastrar_usuario',
														nome:nome,
														email:email,
														senha:self.md5(senha),
														latitude: self.latitude,
														longitude: self.longitude

													},self).done(function(data){
															
															if(data.hasOwnProperty('resposta')){

																if(data.resposta.error > 0){
																	error_msg.text(data.resposta.error_msg);
																}else{
																	div_form.fadeOut('slow', function() {
																			var p = $("<p></p>");
																			p.addClass('font-size-2');
																			p.text("Você receberá um e-mail para validar o cadastro, caso não receba, verifique no SPAM");
																			$(this).html(p);
																			$(this).fadeIn('fast');

																			setTimeout(function(){ 

																				painel.fadeOut('slow');
																				$('.content').animate({height: '200px'},600);
																				$('.banner-title').animate({top:'200px'},500, function(){
																					self.createFormLogin();
																						
																				 });
																			 }, 4000);
																			
																	});

																}
															
															}
																
															
														});

					}
				
			}
	}

	$(div_back).on(action_back);
	$(a_btn).on(action_cadastrar);


	div_back.html(img);

	div_form.append(i_nome);
	div_form.append(error_nome);
	div_form.append(i_email);
	div_form.append(error_email);
	div_form.append(i_senha);
	div_form.append(error_senha);
	div_form.append(i_confirma);
	div_form.append(div_btn);
	div_btn.append(a_btn);
	div_form.append(error_msg);

		painel.fadeOut('fast',function(){
				painel.html('');
				painel.append(div_back);
				painel.append(div_form);
				painel.fadeIn('slow');
		});
	
		$('.content').animate({height: '250px'},500);
		$('.banner-title').animate({top:'250px'},600);
}


function isEmail(email) {
	  var filtro = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	  return filtro.test(email);
}

cemf.js.Login.prototype.createLoading = function (){
	void 0;

	circle  = $("<div></div>");
	circle.addClass('circle-1');
		
	return circle;
}

cemf.js.Login.prototype.removeLoading = function (msg){
	void 0;

	if(this.loading != null){
		(this.loading).find('.circle-1').remove();
	}

}

cemf.js.Login.prototype.start = function(){
	var start = this;

	var params = {
			callback: function(screen){
				callbackRezise(screen);
			}
		};
  		
  	start.animation = new cemf.js.Animation(params);
  	start.connection = new cemf.js.Connection();
  //	start.animation.toast("Ative sua Localização para controle de proximidade, BETA .");
  	start.animation.toast("Seja Bem Vindo !");

  	start.createFormLogin();

  		// 	var params = {
				// 	callbackGeo:function(position){
				// 		callbackOptionGeo(position);
				// 	}
				// }
	 		//start.animation.geoLocation(params.callbackGeo);
	
	
	
	// function callbackOptionGeo(position){
	// 		console.log(position);
	// 		start.latitude = position.coords.latitude;
	// 		start.longitude = position.coords.longitude;

	// 		if(position.hasOwnProperty('coords')){

	// 			    start.loading = null;
	// 			 	start.connection
	// 						.execute(
	// 									(start.connection).server('idados'),
	// 										{
	// 											acao:'location',
	// 											latitude:start.latitude,
	// 											longitude:start.longitude
	// 										},start).done(function(data){
	// 												console.log(data);
	// 											});
	// 		}else{
	// 			console.log("Ative sua Localização no próximo logon para controle de proximidade, BETA .")
	// 		}
	// 	}

  		
	function callbackRezise(screen){

		void 0;
		start.screen = screen;
		//start.animation.menuBar();
	}

}

$( document ).ready(function() {
		if($('#page-login').length > 0) 
			new cemf.js.Login().start();
});